require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/00e252642ee113da8161d0e7e0a3b9a7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_00e252642ee113da8161d0e7e0a3b9a7'] = async function fn_00e252642ee113da8161d0e7e0a3b9a7() {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel:') + String(itemData['telefonDispecer'])), true, null);



}

})
define('./functions/05c135d7255b029e3038c5ffe039551c/code.js', () => { 

var toTime, fromTime;

/**
 * Describe this function...
 */
async function do_something() {
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('59')
}



BackendlessUI.Functions.Custom['fn_05c135d7255b029e3038c5ffe039551c'] = async function fn_05c135d7255b029e3038c5ffe039551c() {


  return
}

})
define('./functions/072680b7ab197a44b3ba3d48b6c27b92/code.js', () => { 

var currentUser;



BackendlessUI.Functions.Custom['fn_072680b7ab197a44b3ba3d48b6c27b92'] = async function fn_072680b7ab197a44b3ba3d48b6c27b92(currentUser) {


  return (((await Backendless.Data.of('Livratori').find(Backendless.DataQueryBuilder.create().setWhereClause((['emailLivrator = \'',(currentUser['userEmail']),'\''].join(''))).setProperties('tipLivrator').setPageSize(1)))[0])['tipLivrator'])
}

})
define('./functions/0e251b8b29ab426b3c031f27e8228fca/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0e251b8b29ab426b3c031f27e8228fca'] = async function fn_0e251b8b29ab426b3c031f27e8228fca(formData) {


  return ((formData['cartier']) == 'FLORESTI' || (formData['cartier']) == 'BACIU' || (formData['cartier']) == 'SOMESENI' || (formData['cartier']) == 'FELEACU' ? (formData['cartier']) : 'Cluj-Napoca')
}

})
define('./functions/11593aa790e181139b1b24e3e261f697/code.js', () => { 

var currentUser;



BackendlessUI.Functions.Custom['fn_11593aa790e181139b1b24e3e261f697'] = async function fn_11593aa790e181139b1b24e3e261f697(pageData) {


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['emailLivrator = \'',(currentUser['userEmail']),'\' AND status = \'',(pageData['filtruStatus']),'\''].join(''))).setSortBy('cartier asc').setPageSize(10)))
}

})
define('./functions/125b1f57c148cee2761435564e1f0fcd/code.js', () => { 

BackendlessUI.Functions.Custom['fn_125b1f57c148cee2761435564e1f0fcd'] = async function fn_125b1f57c148cee2761435564e1f0fcd(itemData) {


  return (['Cash: ',(itemData['plata_cash']),'lei'].join(''))
}

})
define('./functions/15f29054098133a5a7fd88582d53befe/code.js', () => { 

var toTime, fromTime, currentUser;



BackendlessUI.Functions.Custom['fn_15f29054098133a5a7fd88582d53befe'] = async function fn_15f29054098133a5a7fd88582d53befe(AppData, SortText) {
    await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](AppData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](AppData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['status = \'',SortText,'\' AND emailLivrator = \'',(currentUser['userEmail']),'\' AND programare >=',(fromTime.valueOf()),' AND programare <=',(toTime.valueOf()),''].join(''))).setSortBy('cartier').setPageSize(35)))
}

})
define('./functions/187b03b2849899b2e75e38a64aff4193/code.js', () => { 

BackendlessUI.Functions.Custom['fn_187b03b2849899b2e75e38a64aff4193'] = async function fn_187b03b2849899b2e75e38a64aff4193(itemData) {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel:') + String(itemData['telefonClient'])), true, null);



}

})
define('./functions/192c23d151715a3eac0a67ade93d16aa/code.js', () => { 

var toTime, fromTime;



BackendlessUI.Functions.Custom['fn_192c23d151715a3eac0a67ade93d16aa'] = async function fn_192c23d151715a3eac0a67ade93d16aa() {
    fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['livrator = \'FARA LIVRATOR\' AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf()),' AND NOT status = \'ANULATA\'','AND NOT status = \'LIVRATA\' ',''].join(''))).setSortBy('programare').setPageSize(10)))
}

})
define('./functions/1b1491a6628a59d640a874ec31cb38ca/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1b1491a6628a59d640a874ec31cb38ca'] = async function fn_1b1491a6628a59d640a874ec31cb38ca(itemData) {


  return ((itemData['livrator']) == 'FARA LIVRATOR' ? true : false)
}

})
define('./functions/22aa31d803a9a54e4e2c0b5968de005a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_22aa31d803a9a54e4e2c0b5968de005a'] = async function fn_22aa31d803a9a54e4e2c0b5968de005a(PageData) {


  return (['created >=',(PageData['dinData']),' AND created <=',(PageData['panaInData']),!((PageData['cautaComanda']) == null) ? [' AND search LIKE \'%',(PageData['cautaComanda']),'%\''].join('') : null,!((PageData['cautaClient']) == null) ? [' AND masterClient LIKE \'%',(PageData['cautaClient']),'%\''].join('') : null,'','',''].join(''))
}

})
define('./functions/24c2427dde99a858be2915933244e803/code.js', () => { 

var item;



BackendlessUI.Functions.Custom['fn_24c2427dde99a858be2915933244e803'] = async function fn_24c2427dde99a858be2915933244e803(pageData, userEmail) {


  return (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['emailLivrator = \'',userEmail,'\' AND masterClient = \'',(pageData['filtruClient']),'\' AND decontat = FALSE AND NOT status = \'ANULATA\'',''].join(''))).setProperties('plata_cash').setPageSize(99))).map(item => {; return (item['plata_cash']);})).reduce(function(x, y) {return x + y;}))
}

})
define('./functions/2a9d1e2d5be71d9d6c033c17e335977a/code.js', () => { 

var offset, sumTarifare, item, toateComenzile;

/**
 * Describe this function...
 */
async function do_something() {
  toateComenzile = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_22aa31d803a9a54e4e2c0b5968de005a'](PageData)))));
  offset = 1;
  while (!(offset > toateComenzile)) {
    sumTarifare = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_22aa31d803a9a54e4e2c0b5968de005a'](PageData))).setPageSize(100).setOffset(offset))).reduce(function(x, y) {return x + y;})).map(item => {; return (item['tarifare']);}));
    PageData['valoareTarifare'] = (sumTarifare + (PageData['valoareTarifare']));
    offset = offset + 99;
  }
}



BackendlessUI.Functions.Custom['fn_2a9d1e2d5be71d9d6c033c17e335977a'] = async function fn_2a9d1e2d5be71d9d6c033c17e335977a(PageData) {
    toateComenzile = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_22aa31d803a9a54e4e2c0b5968de005a'](PageData)))));
  offset = 1;
  while (!(offset > toateComenzile)) {
    sumTarifare = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_22aa31d803a9a54e4e2c0b5968de005a'](PageData))).setPageSize(100).setOffset(offset))).reduce(function(x, y) {return x + y;})).map(item => {; return (item['tarifare']);}));
    PageData['valoareTarifare'] = (sumTarifare + (PageData['valoareTarifare']));
    offset = offset + 99;
  }


  return
}

})
define('./functions/32e352d4c7be26abb5ea1882d3e85efc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_32e352d4c7be26abb5ea1882d3e85efc'] = async function fn_32e352d4c7be26abb5ea1882d3e85efc() {


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause('decontat = FALSE AND NOT status = \'ANULATA\'').setSortBy('livrator asc').setPageSize(100)))
}

})
define('./functions/3a371f630994ad53d7377795bae215dc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3a371f630994ad53d7377795bae215dc'] = async function fn_3a371f630994ad53d7377795bae215dc(userEmail) {


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['emailLivrator = \'',userEmail,'\' AND decontat != FALSE AND status != \'ANULATA\'','',''].join(''))).setSortBy('masterClient asc').setPageSize(100)))
}

})
define('./functions/3c829c762097f5b43b62f9b30d137401/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3c829c762097f5b43b62f9b30d137401'] = async function fn_3c829c762097f5b43b62f9b30d137401(itemData, textIfTrue) {


  return ((itemData['status']) == textIfTrue && !((itemData['livrator']) == 'FARA LIVRATOR') ? true : false)
}

})
define('./functions/3d58c5ccb9ba8a2e7023d123a728db7d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3d58c5ccb9ba8a2e7023d123a728db7d'] = async function fn_3d58c5ccb9ba8a2e7023d123a728db7d(itemData) {


  return ((itemData['livrator']) == 'FARA LIVRATOR' ? false : true)
}

})
define('./functions/4151feb5a437708e1781f57b8909bced/code.js', () => { 

var rezultat;



BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'] = async function fn_4151feb5a437708e1781f57b8909bced(valoare) {
    rezultat = Math.round(valoare * 100) / 100;


  return rezultat
}

})
define('./functions/44828da4b8bd127c139b830513ea78f4/code.js', () => { 

/**
 * Describe this function...
 */
async function distanta_time() {
  pageData['newAdresaLivrare'] = ([(itemData['adresaLivrare']),' ',(itemData['cartier']) == 'FLORESTI' || (itemData['cartier']) == 'BACIU' || (itemData['cartier']) == 'SOMESENI' || (itemData['cartier']) == 'FELEACU' ? [' comuna ',(itemData['cartier']),' jud Cluj'].join('') : ' Cluj-Napoca','',''].join(''));
  pageData['newAdresaRidicare'] = ([(itemData['adresaRidicare']),' Cluj-Napoca','','',''].join(''));
  pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).send(({ 'destinations': String(pageData['newAdresaLivrare']) + String(''),'origins': [(pageData['newAdresaRidicare']),' Cluj-Napoca',''].join('') })));
  await tarifareKm();
  pageData['distance'] = ((((pageData['distanceGoogle'])['distance'])['value']) / 1000 + 0.8);
  console.log(['\nAdresa Ridicare:',(pageData['newAdresaRidicare']),'\nAdresa Livrare:',(pageData['newAdresaLivrare'])].join(''));
  console.log(['\nDistanta bruta:',(((pageData['distanceGoogle'])['distance'])['value']) / 1000,'\nDistanta:',(pageData['distance']),'Km','\nKm suplimentari:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((pageData['kmSPL'])))].join(''));
  if ((pageData['client'])['tarifareKm']) {
  }
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log((pageData['client'])['tarifareKm']);
  pageData['kmSPL'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((pageData['distance']) - 2)));
  if (((pageData['client'])['tarifareKm']) && (pageData['kmSPL']) < 6 && (pageData['kmSPL']) > 0) {
    itemData['tarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((((pageData['client'])['tarifareKmBaza']) + (pageData['kmSPL']) * ((pageData['client'])['tarifareKmSPL1']))));
  } else if (((pageData['client'])['tarifareKm']) && (pageData['kmSPL']) >= 6) {
    itemData['tarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((((pageData['client'])['tarifareKmBaza']) + (pageData['kmSPL']) * ((pageData['client'])['tarifareKmSPL2']))));
  }
}



BackendlessUI.Functions.Custom['fn_44828da4b8bd127c139b830513ea78f4'] = async function fn_44828da4b8bd127c139b830513ea78f4(pageData, itemData) {
    await distanta_time();



}

})
define('./functions/4831e40bc784b9e58d67251b83990d16/code.js', () => { 

var item;



BackendlessUI.Functions.Custom['fn_4831e40bc784b9e58d67251b83990d16'] = async function fn_4831e40bc784b9e58d67251b83990d16(pageData, currentUser) {


  return (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(currentUser['masterEmail']),'\' AND livrator = \'',(pageData['filtruLivrator']),'\' AND decontat = FALSE AND NOT status = \'ANULATA\'',''].join(''))).setProperties('plata_cash').setPageSize(99))).map(item => {; return (item['plata_cash']);})).length == 0 ? 0 : ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(currentUser['masterEmail']),'\' AND livrator = \'',(pageData['filtruLivrator']),'\' AND decontat = FALSE AND NOT status = \'ANULATA\'',''].join(''))).setProperties('plata_cash').setPageSize(99))).map(item => {; return (item['plata_cash']);})).reduce(function(x, y) {return x + y;}))
}

})
define('./functions/48ca14785afeef6f05dd11f72b6a3c4f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_48ca14785afeef6f05dd11f72b6a3c4f'] = async function fn_48ca14785afeef6f05dd11f72b6a3c4f(_id, body, appData) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



return (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(getObjectProperty(appData, 'server')),'comenzi/',_id].join('')))).setEncoding('utf8').send(body))
}

})
define('./functions/4a898faf6e7a9544faab89f4db4d0f63/code.js', () => { 

var currentUser;



BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'] = async function fn_4a898faf6e7a9544faab89f4db4d0f63(pageData, appData) {
    await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](appData));


  return (await Backendless.Data.of('ComenziActive').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(currentUser['masterEmail']),'\' AND status = \'',(pageData['filtruStatus']),'\'',!((pageData['cautaComanda']) == '') ? [' AND search LIKE \'%',(pageData['cautaComanda']),'%\''].join('') : null].join(''))).setSortBy('programare desc').setPageSize(100)))
}

})
define('./functions/51e9ddb2d1ea3edbbd4134a4f19128c9/code.js', () => { 

var timpRamas, acum;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}



BackendlessUI.Functions.Custom['fn_51e9ddb2d1ea3edbbd4134a4f19128c9'] = async function fn_51e9ddb2d1ea3edbbd4134a4f19128c9(dateNow, pageData, itemData) {

  ;(function() {
    const callback = async () => {
        acum = (new Date());
    if ((itemData['programare']) - acum >= 0) {
      timpRamas = (itemData['programare']) - acum;
      pageData['timeLabel'] = 'Timp ramas ';
    } else {
      timpRamas = acum - (itemData['programare']);
      pageData['timeLabel'] = 'Intarziere ';
    }
    pageData['oraR'] = ((new Date(timpRamas).getHours()) - 2);
    pageData['minR'] = (new Date(timpRamas).getMinutes());
    pageData['secR'] = (new Date(timpRamas).getSeconds());

    };

    const timerId = 'timpRamas';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()


  return ([(pageData['timeLabel']),(pageData['oraR']) < 10 ? String('0') + String(pageData['oraR']) : (pageData['oraR']),':',(pageData['minR']) < 10 ? String('0') + String(pageData['minR']) : (pageData['minR']),':',(pageData['secR']) < 10 ? String('0') + String(pageData['secR']) : (pageData['secR'])].join(''))
}

})
define('./functions/57d8bc61cf6ed36fee515736253e321b/code.js', () => { 

var comandaNoua, destinatarNou, currentUser;

/**
 * Describe this function...
 */
async function do_something() {
}



BackendlessUI.Functions.Custom['fn_57d8bc61cf6ed36fee515736253e321b'] = async function fn_57d8bc61cf6ed36fee515736253e321b() {
    await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb67d460bb595d9b5cb8a86d63b8a5b', false);
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Comenzi', null);
  ___arguments.context.dataModel['newComanda'] = ([(___arguments.context.dataModel['newNumarComanda']),' (',(___arguments.context.dataModel['newCartier']),')-',(___arguments.context.dataModel['newStrada']),' ',String(___arguments.context.dataModel['newNumar']) + String(___arguments.context.dataModel['newAnexaNumar']),''].join(''));
  if (___arguments.context.dataModel['newBloc']) {
    ___arguments.context.dataModel['newComanda'] = ([(___arguments.context.dataModel['newComanda']),' (',String('sc. ') + String(___arguments.context.dataModel['newScara']),String(' et. ') + String(___arguments.context.dataModel['newEtaj']),String(' ap. ') + String(___arguments.context.dataModel['newApartament']),' )','','',''].join(''));
  }
  ___arguments.context.dataModel['newComanda'] = ([(___arguments.context.dataModel['newComanda']),'[',(___arguments.context.dataModel['newTarifare']),']',''].join(''));
  ___arguments.context.pageData['newTelefonDispecer'] = (currentUser['telefonUser']);
  ___arguments.context.pageData['newNumeClient'] = '';
  ___arguments.context.dataModel['newAwb'] = (await Backendless.Counters.addAndGet('awb', 1));
  ___arguments.context.dataModel['newAdresaLivrare'] = ([(___arguments.context.dataModel['newStrada']),' ',(___arguments.context.dataModel['newNumar']),' Cluj-Napoca',''].join(''));
  if ((___arguments.context.dataModel['newPlataCash']) == 0) {
    ___arguments.context.pageData['newDecontat'] = true;
  }
  if ((await Backendless.Data.of('Destinatar').find(Backendless.DataQueryBuilder.create().setWhereClause((['telefon = \'',(___arguments.context.dataModel['newTelefonClient']),'\''].join(''))).setProperties('telefon').setPageSize(1))).length == 0) {
    destinatarNou = (await Backendless.Data.of('Destinatar').save( ({ 'telefon': (___arguments.context.dataModel['newTelefonClient']),'bloc': (___arguments.context.dataModel['newBloc']),'cartier': (___arguments.context.dataModel['newCartier']),'strada': (___arguments.context.dataModel['newStrada']),'scara': (___arguments.context.dataModel['newScara']),'etaj': (___arguments.context.dataModel['newEtaj']),'apartament': (___arguments.context.dataModel['newApartament']),'numar': String(___arguments.context.dataModel['newNumar']) + String(___arguments.context.dataModel['newAnexaNumar']),'zona': (___arguments.context.dataModel['newZona']) }) ));
  } else {
    await Backendless.Data.of('Destinatar').bulkUpdate( (['telefon = \'',(___arguments.context.dataModel['newTelefonClient']),'\''].join('')), ({ 'bloc': (___arguments.context.dataModel['newBloc']),'cartier': (___arguments.context.dataModel['newCartier']),'strada': (___arguments.context.dataModel['newStrada']),'scara': (___arguments.context.dataModel['newScara']),'etaj': (___arguments.context.dataModel['newEtaj']),'apartament': (___arguments.context.dataModel['newApartament']),'numar': String(___arguments.context.dataModel['newNumar']) + String(___arguments.context.dataModel['newAnexaNumar']),'zona': (___arguments.context.dataModel['newZona']) }) );
  }
  console.log(String('Adresa Ridicare default:\n') + String(___arguments.context.pageData['newDefaultRidicare']));
  comandaNoua = (await Backendless.Data.of('Comenzi').save( ({ 'ridicareDefault': (___arguments.context.pageData['newDefaultRidicare']),'plataOp': (___arguments.context.dataModel['newPlataOp']),'dataComanda': (___arguments.context.dataModel['newDataComanda']),'allText': (___arguments.context.pageData['newAllText']),'logo': (___arguments.context.dataModel['newLogo']),'optiuneAwb': (___arguments.context.dataModel['newOptiuneAwb']),'decontat': (___arguments.context.pageData['newDecontat']),'TipMasina': (___arguments.context.dataModel['newTipMasina']),'masterClient': (___arguments.context.dataModel['newMaster']),'masterEmail': (___arguments.context.dataModel['newMasterEmail']),'adresaLivrare': (___arguments.context.dataModel['newAdresaLivrare']),'awb': (___arguments.context.dataModel['newAwb']),'comanda': (___arguments.context.dataModel['newComanda']),'oraLimita': (___arguments.context.dataModel['newOraLimita']),'status': (___arguments.context.dataModel['newStatus']),'livrareExtern': (___arguments.context.dataModel['newLivrareExtern']),'adresaRidicare': (___arguments.context.dataModel['newAdresaRidicare']),'aviz': (___arguments.context.dataModel['newAviz']),'cartier': (___arguments.context.dataModel['newCartier']),'comisionPos': (___arguments.context.dataModel['newComisionPos']),'customerAccount': (___arguments.context.dataModel['newCustomerAccount']),'programare': (___arguments.context.dataModel['newProgramare']),'detaliiLivrare': (___arguments.context.dataModel['newDetaliiLivrare']),'emailClient': (___arguments.context.dataModel['newEmailClient']),'factura': (___arguments.context.dataModel['newFactura']),'incasarePos': (___arguments.context.dataModel['newIncasarePos']),'numeClient': (___arguments.context.dataModel['newNumeClient']),'numeUser': (___arguments.context.dataModel['newNumeUser']),'plata_cash': (___arguments.context.dataModel['newPlataCash']),'plata_card': (___arguments.context.dataModel['newPlataCard']),'tarifare': (___arguments.context.dataModel['newTarifare']),'tarifareIntern': (___arguments.context.dataModel['newTarifareIntern']),'telefonClient': (___arguments.context.dataModel['newTelefonClient']),'telefonDisp': (___arguments.context.pageData['newTelefonDispecer']),'tipLivrare': (___arguments.context.dataModel['newTipLivrare']),'user': (___arguments.context.dataModel['newUser']) }) ));
  if (___arguments.context.dataModel['newLivrareExtern']) {
    await Backendless.Messaging.sendEmail((String('Comanda: ') + String(___arguments.context.dataModel['newMaster'])), new Backendless.Bodyparts({ htmlmessage: (['Comanda:  ',(___arguments.context.dataModel['newComanda']),'<br>Adresa Ridicare: ',(___arguments.context.dataModel['newAdresaRidicare']),'<br>Adresa Livrare: ',(___arguments.context.dataModel['newAdresaLivrare']),'<br> Ramburs: ',(___arguments.context.dataModel['newPlataCash']),'<br>Telefon Client: ',(___arguments.context.dataModel['newTelefonClient']),'<br>Observatii: ',(___arguments.context.dataModel['newDetaliiLivrare']),'<br><br>Va multumim ca folositi DeliveryPro App (CallDelivery Team. Tel: 0752621501)) ','<br>Va rugam nu raspundeti la acest email '].join('')) }), ['mihaltan.matei@gmail.com'], undefined)
    await Backendless.Messaging.sendEmail((String('Comanda: ') + String(___arguments.context.dataModel['newMaster'])), new Backendless.Bodyparts({ htmlmessage: (['Comanda:  ',(___arguments.context.dataModel['newComanda']),'<br>Adresa Ridicare: ',(___arguments.context.dataModel['newAdresaRidicare']),'<br>Customer Account: ',(___arguments.context.dataModel['newCustomerAccount']),'<br>Factura: ',(___arguments.context.dataModel['newFactura']),'<br>Aviz: ',(___arguments.context.dataModel['newAviz']),'<br>Nume Client: ',(___arguments.context.dataModel['newNumeClient']),'<br>Adresa Livrare: ',(___arguments.context.dataModel['newAdresaLivrare']),'<br> Ramburs: ',(___arguments.context.dataModel['newPlataCash']),'<br>Telefon Client: ',(___arguments.context.dataModel['newTelefonClient']),'<br>Observatii: ',(___arguments.context.dataModel['newDetaliiLivrare']),'','<br>Va rugam nu raspundeti la acest email '].join('')) }), ['horea.mihaltan@gmail.com'], undefined)
  }
  if (___arguments.context.dataModel['newOptiuneAwb']) {
    await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/pdf/pdf-email')).send(({ 'to': ['','',(___arguments.context.dataModel['newEmailRidicare'])].join(''),'textBody': ['Comanda:  ',(___arguments.context.dataModel['newComanda']),'Adresa Ridicare: ',(___arguments.context.dataModel['newAdresaRidicare']),'Adresa Livrare: ',(___arguments.context.dataModel['newAdresaLivrare']),'Ramburs: ',(___arguments.context.dataModel['newPlataCash']),'Telefon Client: ',(___arguments.context.dataModel['newTelefonClient']),'Observatii: ',(___arguments.context.dataModel['newDetaliiLivrare']),'',['Acceseaza urmatorul link pentru a vizualiza/printa AWB-ul <br> <a href="','https://calldelivery.ro/pdf/get-pdf/',(___arguments.context.dataModel['newAwb']),'">AWB</a>',(___arguments.context.dataModel['newAwb']),'</a>'].join(''),' Va multumim ca folositi DeliveryPro App (CallDelivery Team. Tel: 0752621501)) ','Va rugam nu dati replay la acest email '].join(''),'htmlBody': ['Comanda:  ',(___arguments.context.dataModel['newComanda']),'<br>Adresa Ridicare: ',(___arguments.context.dataModel['newAdresaRidicare']),'<br>Adresa Livrare: ',(___arguments.context.dataModel['newAdresaLivrare']),'<br> Ramburs: ',(___arguments.context.dataModel['newPlataCash']),'<br>Telefon Client: ',(___arguments.context.dataModel['newTelefonClient']),'<br>Observatii: ',(___arguments.context.dataModel['newDetaliiLivrare']),'',['<br><b>Acceseaza urmatorul link pentru a vizualiza/printa AWB-ul <br> ','<a href="https://calldelivery.ro/pdf/get-pdf/',(___arguments.context.dataModel['newAwb']),'">AWB-',(___arguments.context.dataModel['newAwb']),'</a></b>'].join(''),'<br>Va multumim ca folositi DeliveryPro App (CallDelivery Team. Tel: 0752621501)) ','<br>Va rugam nu raspundeti la acest email '].join(''),'comanda': (___arguments.context.dataModel['newComanda']),'awb': (___arguments.context.dataModel['newAwb']),'expeditor': (___arguments.context.pageData['expeditor']),'adresa': (___arguments.context.pageData['adresaFirma']),'cui': (___arguments.context.pageData['cui']),'nirc': (___arguments.context.pageData['nirc']),'aviz': (___arguments.context.dataModel['newAviz']),'factura': (___arguments.context.dataModel['newFactura']),'adresaRidicare': (___arguments.context.dataModel['newAdresaRidicare']),'client': (___arguments.context.dataModel['newNumeClient']),'customerAccount': (___arguments.context.dataModel['newCustomerAccount']),'adresaLivrare': (___arguments.context.dataModel['newAdresaLivrare']),'plataCash': (___arguments.context.dataModel['newPlataCash']),'telefon': (___arguments.context.dataModel['newTelefonClient']),'observatii': (___arguments.context.dataModel['newDetaliiLivrare']),'ramburs': (___arguments.context.dataModel['newPlataCash']) }));
    if ((___arguments.context.pageData['adresaRidicareUser']) == (___arguments.context.dataModel['newAdresaRidicare'])) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((['https://calldelivery.ro/pdf/get-pdf/',(___arguments.context.dataModel['newAwb']),''].join('')), true, null);
    }
  }


  return
}

})
define('./functions/5ebae7222521285e52a5d844681fd4d6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5ebae7222521285e52a5d844681fd4d6'] = async function fn_5ebae7222521285e52a5d844681fd4d6(itemData) {


  return ((itemData['livrator']) == 'FARA LIVRATOR' ? false : true)
}

})
define('./functions/648a85a7c317c0fa93a27a1d3563822b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_648a85a7c317c0fa93a27a1d3563822b'] = async function fn_648a85a7c317c0fa93a27a1d3563822b(itemData, appData) {
    if ((itemData['plata_cash']) > 0 && (itemData['optiuneAwb']) == true) {
    await BackendlessUI.Functions.Custom['fn_9993e1bfa1c675227a637bf2e21bad2b'](itemData, appData, 'IncasareAWB')
  }



}

})
define('./functions/652c76f78c482caafc69bc07f7e147c3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_652c76f78c482caafc69bc07f7e147c3'] = async function fn_652c76f78c482caafc69bc07f7e147c3(itemData) {
    if ((itemData['optiuneAwb']) == true && (itemData['plata_cash']) > 0 && (itemData['documentIncasare']) == '-' && ((itemData['status']) == 'LIVRATA' || (itemData['status']) == 'RIDICATA' || (itemData['status']) == 'IN LIVRARE')) {
    return true;
  } else {
    return false;
  }


  return
}

})
define('./functions/65a1c7e5f0fd7497566e4541b53bcf4f/code.js', () => { 

var toTime, fromTime, currentUser;



BackendlessUI.Functions.Custom['fn_65a1c7e5f0fd7497566e4541b53bcf4f'] = async function fn_65a1c7e5f0fd7497566e4541b53bcf4f(currentUser) {
    fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  fromTime.setHours('23')
  fromTime.setMinutes('59')
  fromTime.setSeconds('59')
  fromTime.setSeconds('999')
  if ((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['emailLivrator = \'',(currentUser['userEmail']),'\' AND activ = TRUE',' AND created >= ',(fromTime.valueOf()),'AND created <= ',(toTime.valueOf()),''].join(''))).setSortBy('created asc').setPageSize(1)))[0] == null) {
    return false;
  } else {
    return true;
  }


  return
}

})
define('./functions/65edb76208e25fb7608766d6c519a6ba/code.js', () => { 

/**
 * Describe this function...
 */
async function clientData() {
  pageData['client'] = ((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(itemData['masterClient']),'\''].join(''))).setPageSize(1)))[0]);
}

/**
 * Describe this function...
 */
async function mesajSMSData() {
  pageData['mesajSMSclient'] = ((await Backendless.Data.of('MesajSMS').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterClient = \'',(itemData['masterClient']),'\''].join(''))).setPageSize(1)))[0]);
}



BackendlessUI.Functions.Custom['fn_65edb76208e25fb7608766d6c519a6ba'] = async function fn_65edb76208e25fb7608766d6c519a6ba(itemData, currentUser, pageData) {
    itemData['status'] = 'IN LIVRARE';
  await Backendless.Data.of('Comenzi').save( itemData );
  await clientData();
  await mesajSMSData();
  if (itemData['livrareExtern']) {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((['sms:',(itemData['telefonClient']),'?&body=','Comanda la adresa: ',(itemData['adresaLivrare']),((pageData['mesajSMSclient'])['deLaFirma']),(itemData['masterClient']),' va fi livrata in aprox: ',(itemData['duration']),'. Telefon livrator: ',(currentUser['telefonUser']),[' Aveti de plata ',(itemData['plata_cash']),((pageData['mesajSMSclient'])['modalitatePlata'])].join(''),'',((pageData['mesajSMSclient'])['linkGoogle']),' ',(((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['livrator = \'',(currentUser['username']),'\''].join(''))).setProperties('shareLocation').setSortBy('created desc').setPageSize(1)))[0])['shareLocation']),'&'].join('')), true, null);
  }



}

})
define('./functions/663ffc8a88cb0ba744e30a91eb472025/code.js', () => { 

BackendlessUI.Functions.Custom['fn_663ffc8a88cb0ba744e30a91eb472025'] = async function fn_663ffc8a88cb0ba744e30a91eb472025(itemData) {
    if (itemData['livrareExtern']) {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((['sms:',(itemData['telefonClient']),'?&body=','Comanda de la: ',(itemData['masterClient']),' a fost livrata. Te rugam sa accesezi urmatorul link: ','https://www.facebook.com/HoreaMihaltan/reviews/',' si sa dai un review livratorului. Multumim. ',(itemData['plata_cash']) == 0 && (itemData['optiuneAwb']) == true ? ' Va rugam sa confirmati primirea coletului cu un mesaj: "CONFIRM  PRIMIREA COLETULUI"' : '',' \n(CallDelivery Team)','','','','&'].join('')), true, null);
  }



}

})
define('./functions/6b866624272cc426fbdc68d6122f46f8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6b866624272cc426fbdc68d6122f46f8'] = async function fn_6b866624272cc426fbdc68d6122f46f8(appData, pageData, minRange, maxRange, masterClient) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



return (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(appData, 'server')) + String('comenzi/get')))).setEncoding('utf8').send(({ [`ranges`]: ({ [`programare`]: ({ [`min`]: minRange,[`max`]: maxRange }) }),[`selected`]: ({ [`masterClient`]: masterClient }),[`notSelected`]: ({ [`status`]: 'ANULATA' }) })))
}

})
define('./functions/704990f4e9d195a79fdbde33ad45721b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_704990f4e9d195a79fdbde33ad45721b'] = async function fn_704990f4e9d195a79fdbde33ad45721b(itemData) {
    itemData['livrator'] = 'FARA LIVRATOR';
  itemData['emailLivrator'] = 'nolivrator@gmail.com';
  await Backendless.Data.of('Comenzi').save( itemData );



}

})
define('./functions/71c90b7681f2c8b9eb72624de9567aa7/code.js', () => { 

var currentUser, error, errorCode;



BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'] = async function fn_71c90b7681f2c8b9eb72624de9567aa7(appData) {
    if (!(await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](appData))) {
    try {
      currentUser = (await Backendless.UserService.getCurrentUser(false));

    } catch (error) {
      errorCode = (error['code']);
      if (errorCode == 3064) {
        await Backendless.UserService.logout()
      }
      console.log(error);

    }
    appData['currentUser'] = currentUser;
  }



}

})
define('./functions/740e2a764787f1b2171a4988cef8f28f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_740e2a764787f1b2171a4988cef8f28f'] = async function fn_740e2a764787f1b2171a4988cef8f28f(itemData, textValue) {
    itemData['status'] = textValue;
  await Backendless.Data.of('Comenzi').save( itemData );



}

})
define('./functions/7468cb32c45dc15cfad8ce4a69923657/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7468cb32c45dc15cfad8ce4a69923657'] = async function fn_7468cb32c45dc15cfad8ce4a69923657(appData, itemData) {
    appData['selectComanda'] = itemData;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EditareComanda', ({ 'objectId': (itemData['objectId']) }));



}

})
define('./functions/76823ab1a00d8f923f1ee30b83555997/code.js', () => { 

var currentUser, toTime, fromTime, timeOfset;



BackendlessUI.Functions.Custom['fn_76823ab1a00d8f923f1ee30b83555997'] = async function fn_76823ab1a00d8f923f1ee30b83555997() {
    fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  timeOfset = (new Date());
  timeOfset.setTime((new Date(timeOfset.getTime() + (5400 * 1000))))
  ___arguments.context.dataModel['newProgramare'] = (timeOfset.valueOf());
  ___arguments.context.dataModel['newOraLimita'] = (timeOfset.valueOf());
  ___arguments.context.pageData['altaAdresa'] = false;
  console.log(___arguments.context.dataModel['newOraLimita']);
  ___arguments.context.dataModel['newNumeUser'] = (currentUser['username']);
  ___arguments.context.dataModel['newUser'] = (currentUser['userEmail']);
  ___arguments.context.dataModel['newMaster'] = (currentUser['masterName']);
  ___arguments.context.dataModel['newMasterEmail'] = (currentUser['masterEmail']);
  ___arguments.context.pageData['adresaRidicareUser'] = (currentUser['adresaRidicare']);
  ___arguments.context.dataModel['newCustomerAccount'] = '';
  ___arguments.context.dataModel['newNumeClient'] = '';
  ___arguments.context.dataModel['newFactura'] = '';
  ___arguments.context.dataModel['newAviz'] = '';
  ___arguments.context.dataModel['newNumarComanda'] = ([(currentUser['masterID']),'#',(await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['created >=',(fromTime.valueOf()),' AND created <=',(toTime.valueOf()),' AND user = \'',(currentUser['userEmail']),'\''].join(''))))) + 1].join(''));
  ___arguments.context.dataModel['newComanda'] = (String(___arguments.context.dataModel['newNumarComanda']));
  ___arguments.context.dataModel['newLivrareExtern'] = (((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setProperties('defaultExtern').setPageSize(1)))[0])['defaultExtern']);
  ___arguments.context.dataModel['newOptiuneAwb'] = (((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setProperties('awb').setPageSize(1)))[0])['awb']);
  ___arguments.context.dataModel['newAdresaRidicare'] = (((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username = \'',(currentUser['username']),'\''].join(''))).setProperties('adresaRidicare').setPageSize(1)))[0])['adresaRidicare']);
  ___arguments.context.dataModel['newEmailRidicare'] = (((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(___arguments.context.dataModel['newAdresaRidicare']),'\''].join(''))).setProperties('email').setPageSize(1)))[0])['email']);
  ___arguments.context.dataModel['newLogo'] = (((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setProperties('logo').setPageSize(1)))[0])['logo']);
  ___arguments.context.pageData['cui'] = (((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setProperties('cui').setPageSize(1)))[0])['cui']);
  ___arguments.context.pageData['nirc'] = (((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setProperties('nirc').setPageSize(1)))[0])['nirc']);
  ___arguments.context.pageData['expeditor'] = (((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setProperties('nume_firma').setPageSize(1)))[0])['nume_firma']);
  ___arguments.context.pageData['adresaFirma'] = (((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setProperties('adresa_firma').setPageSize(1)))[0])['adresa_firma']);
  ___arguments.context.pageData['newDefaultRidicare'] = (((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(currentUser['adresaRidicare']),'\''].join(''))).setProperties('default').setPageSize(1)))[0])['default']);
  console.log(String('Adresa Ridicare default:') + String(___arguments.context.pageData['newDefaultRidicare']));


  return
}

})
define('./functions/77858a4e5ffc1517c121f8949e73c742/code.js', () => { 

BackendlessUI.Functions.Custom['fn_77858a4e5ffc1517c121f8949e73c742'] = async function fn_77858a4e5ffc1517c121f8949e73c742(itemData, textIfTrue) {


  return ((itemData['notificare']) == textIfTrue ? true : false)
}

})
define('./functions/89ec28a6525666ddd0c83fb68ebb086f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_89ec28a6525666ddd0c83fb68ebb086f'] = async function fn_89ec28a6525666ddd0c83fb68ebb086f(pageData) {


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['','','livrator = \'',(pageData['filtruLivrator']),'\' AND decontat = FALSE AND NOT status = \'ANULATA\'','',''].join(''))).setSortBy('livrareExtern asc').setPageSize(100)))
}

})
define('./functions/8af6424a70c1d94a9789067e5d616b53/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8af6424a70c1d94a9789067e5d616b53'] = async function fn_8af6424a70c1d94a9789067e5d616b53(appData, pageData, currentUser) {


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['emailLivrator = \'',(currentUser['userEmail']),'\'',(pageData['filtruClient']) == null ? '' : [' AND masterClient = \'',(pageData['filtruClient']),'\''].join(''),' AND decontat = FALSE AND NOT status = \'ANULATA\''].join(''))).setSortBy('created asc').setPageSize(100)))
}

})
define('./functions/918591c96e83b755f6f3aa935fcedd44/code.js', () => { 

var item;



BackendlessUI.Functions.Custom['fn_918591c96e83b755f6f3aa935fcedd44'] = async function fn_918591c96e83b755f6f3aa935fcedd44(userEmail) {


  return (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['emailLivrator = \'',userEmail,'\' AND decontat = FALSE AND NOT status = \'ANULATA\''].join(''))).setProperties('plata_cash').setPageSize(100))).map(item => {; return (item['plata_cash']);})).length == 0 ? 0 : ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['emailLivrator = \'',userEmail,'\' AND decontat = FALSE AND NOT status = \'ANULATA\''].join(''))).setProperties('plata_cash').setPageSize(99))).map(item => {; return (item['plata_cash']);})).reduce(function(x, y) {return x + y;}))
}

})
define('./functions/9993e1bfa1c675227a637bf2e21bad2b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9993e1bfa1c675227a637bf2e21bad2b'] = async function fn_9993e1bfa1c675227a637bf2e21bad2b(itemData, appData, goTo) {
    appData['selectComanda'] = itemData;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })(goTo, ({ 'objectId': (itemData['objectId']) }));



}

})
define('./functions/9af296e16726173ee06b890b0b8fa56a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9af296e16726173ee06b890b0b8fa56a'] = async function fn_9af296e16726173ee06b890b0b8fa56a(pageData, AppData) {
    // atentie, verifica daca functioneaza. Daca nu, muta-l la coada!
  if ((pageData['tipLivrator']) == 'EXTERN' && (pageData['filtruStatus']) == 'DISPONIBILE') {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['livrareExtern = TRUE AND livrator = \'FARA LIVRATOR\'','','',' AND NOT status = \'ANULATA\' AND NOT status = \'LIVRATA\' ','','',''].join(''))).setSortBy('created').setPageSize(30))));
  } else if ((pageData['tipLivrator']) == 'INTERN' && (pageData['filtruStatus']) == 'DISPONIBILE') {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['livrareExtern = FALSE AND livrator = \'FARA LIVRATOR\'',' AND NOT status = \'ANULATA\' AND NOT status = \'LIVRATA\' ',(pageData['selectCartier']) == '' ? null : [' AND cartier = \'',(pageData['selectCartier']),'\''].join(''),'',' AND masterEmail = \'',(pageData['masterEmail']),'\''].join(''))).setSortBy('created').setPageSize(30))));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['status = \'',(pageData['filtruStatus']),'\' AND emailLivrator = \'',(pageData['userEmail']),'\'',(pageData['selectCartier']) == '' || (pageData['selectCartier']) == null ? '' : [' AND cartier = \'',(pageData['selectCartier']),'\''].join(''),(pageData['selectRidicare']) == '' || (pageData['selectRidicare']) == null ? '' : [' AND adresaRidicare = \'',(pageData['selectRidicare']),'\''].join(''),''].join(''))).setSortBy('created').setPageSize(30))));
  }
  pageData['counterDisponibileExtern'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['livrareExtern = TRUE','','','',' AND livrator = \'FARA LIVRATOR\'',' AND NOT status =\'','LIVRATA\' AND NOT status = \'ANULATA\''].join('')))));
  pageData['counterDisponibileIntern'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['livrareExtern = FALSE','','','',' AND livrator = \'FARA LIVRATOR\'',' AND NOT status =\'','LIVRATA\' AND NOT status = \'ANULATA\'',' AND masterEmail = \'',(pageData['masterEmail']),'\''].join('')))));
  pageData['counterProgramate'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_d9733facbed29671ea191eaddae6a598'](AppData, 'PROGRAMATA', (pageData['fromTime']), (pageData['toTime']))))));
  pageData['counterIL'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_d9733facbed29671ea191eaddae6a598'](AppData, 'IN LUCRU', (pageData['fromTime']), (pageData['toTime']))))));
  pageData['counterGDL'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_d9733facbed29671ea191eaddae6a598'](AppData, 'GATA DE LIVRARE', (pageData['fromTime']), (pageData['toTime']))))));
  pageData['counterR'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_d9733facbed29671ea191eaddae6a598'](AppData, 'RIDICATA', (pageData['fromTime']), (pageData['toTime']))))));
  pageData['counterRC'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_d9733facbed29671ea191eaddae6a598'](AppData, 'RIDICATA\' AND notificare = \'CONFIRMAT', (pageData['fromTime']), (pageData['toTime']))))));
  pageData['counterRN'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_d9733facbed29671ea191eaddae6a598'](AppData, 'RIDICATA\' AND notificare = \'NOTIFICAT', (pageData['fromTime']), (pageData['toTime']))))));
  pageData['counterILiv'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_d9733facbed29671ea191eaddae6a598'](AppData, 'IN LIVRARE', (pageData['fromTime']), (pageData['toTime']))))));
  pageData['counterLiv'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['oraLivrare >=',(pageData['fromTime']),' AND oraLivrare <=',(pageData['toTime']),'AND emailLivrator = \'',(pageData['userEmail']),'\' AND status = \'LIVRATA\''].join('')))));
  pageData['nedecontat'] = (await BackendlessUI.Functions.Custom['fn_918591c96e83b755f6f3aa935fcedd44'](null));



}

})
define('./functions/9d5b67c3c59cbf0a593e31e64cf49378/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9d5b67c3c59cbf0a593e31e64cf49378'] = async function fn_9d5b67c3c59cbf0a593e31e64cf49378(pageData) {


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['','','status = \'',(pageData['filtruStatus']),'\'',''].join(''))).setSortBy('programare asc').setPageSize(30)))
}

})
define('./functions/a0ad6012a17565f1b4bd5b8afb3dade3/code.js', () => { 

var item;



BackendlessUI.Functions.Custom['fn_a0ad6012a17565f1b4bd5b8afb3dade3'] = async function fn_a0ad6012a17565f1b4bd5b8afb3dade3() {


  return (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['','',' decontat = FALSE AND NOT status = \'ANULATA\''].join(''))).setProperties('plata_cash').setPageSize(99))).map(item => {; return (item['plata_cash']);})).length == 0 ? 0 : ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['','',' decontat = FALSE AND NOT status = \'ANULATA\''].join(''))).setProperties('plata_cash').setPageSize(100))).map(item => {; return (item['plata_cash']);})).reduce(function(x, y) {return x + y;}))
}

})
define('./functions/ab08204b3d244b3bde6f35c2d53b9565/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ab08204b3d244b3bde6f35c2d53b9565'] = async function fn_ab08204b3d244b3bde6f35c2d53b9565(whereClause, pageData) {
    if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10))).length >= 1) {
    pageData['cartier1'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10)))[0])['cartier']);
    pageData['countCartier1'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier1']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10))).length >= 2) {
    pageData['cartier1'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10)))[1])['cartier']);
    pageData['countCartier2'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier2']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10))).length >= 3) {
    pageData['cartier3'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10)))[2])['cartier']);
    pageData['countCartier3'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier3']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10))).length >= 4) {
    pageData['cartier4'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10)))[3])['cartier']);
    pageData['countCartier4'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier4']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10))).length >= 5) {
    pageData['cartier5'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10)))[4])['cartier']);
    pageData['countCartier5'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier5']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10))).length >= 6) {
    pageData['cartier6'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10)))[5])['cartier']);
    pageData['countCartier6'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier6']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10))).length >= 7) {
    pageData['cartier7'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10)))[6])['cartier']);
    pageData['countCartier7'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier7']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10))).length >= 8) {
    pageData['cartier8'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(10)))[7])['cartier']);
    pageData['countCartier8'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier8']),'\''].join('')))));
  }



}

})
define('./functions/ab3b61a11d9e37daa00885d77611ff8b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ab3b61a11d9e37daa00885d77611ff8b'] = async function fn_ab3b61a11d9e37daa00885d77611ff8b(itemData, textIfTrue) {


  return (!((itemData['livrator']) == 'FARA LIVRATOR') && ((itemData['notificare']) == textIfTrue || (itemData['notificare']) == null) && !((itemData['status']) == 'IN LIVRARE') && !((itemData['status']) == 'LIVRATA') ? true : false)
}

})
define('./functions/ab3cfca3d708348592cd5edcfab17e23/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ab3cfca3d708348592cd5edcfab17e23'] = async function fn_ab3cfca3d708348592cd5edcfab17e23(pageData, currentUser) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  pageData['showObjects'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\' AND created >=',((getObjectProperty(pageData, 'dinData')).valueOf()),' AND created <=',((getObjectProperty(pageData, 'panaInData')).valueOf()),!(getObjectProperty(pageData, 'cautaComanda')).length && (getObjectProperty(pageData, 'cautaComanda')) == '' ? '' : [' AND search LIKE \'%',(getObjectProperty(pageData, 'cautaComanda')),'%\''].join(''),'','',''].join('')))));

return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\' AND created >=',((getObjectProperty(pageData, 'dinData')).valueOf()),' AND created <=',((getObjectProperty(pageData, 'panaInData')).valueOf()),!(getObjectProperty(pageData, 'cautaComanda')).length && (getObjectProperty(pageData, 'cautaComanda')) == '' ? '' : [' AND search LIKE \'%',(getObjectProperty(pageData, 'cautaComanda')),'%\''].join(''),'','',''].join(''))).setSortBy('created desc').setPageSize(100)))
}

})
define('./functions/b1747a4bfee1a266f4c250afe0fbea73/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b1747a4bfee1a266f4c250afe0fbea73'] = async function fn_b1747a4bfee1a266f4c250afe0fbea73(itemData) {


  return (['ora livrare: ',(new Date((itemData['oraLivrare'])).getHours()) <= 9 ? String('0') + String(new Date((itemData['oraLivrare'])).getHours()) : (new Date((itemData['oraLivrare'])).getHours()),':',(new Date((itemData['oraLivrare'])).getMinutes()) <= 9 ? String('0') + String(new Date((itemData['oraLivrare'])).getMinutes()) : (new Date((itemData['oraLivrare'])).getMinutes())].join(''))
}

})
define('./functions/b1b46bd5fa14dd113bb3bf7912fbcf6c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b1b46bd5fa14dd113bb3bf7912fbcf6c'] = async function fn_b1b46bd5fa14dd113bb3bf7912fbcf6c(itemData) {


  return (!((itemData['livrator']) == 'FARA LIVRATOR') && ((itemData['status']) == 'GATA DE LIVRARE' || (itemData['status']) == 'PROGRAMATA' || (itemData['status']) == 'IN LUCRU') ? true : false)
}

})
define('./functions/b84dbd218d0bc052358773d5b4441bcf/code.js', () => { 

var object, toTime, fromTime, currentUser;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

/**
 * Describe this function...
 */
async function do_something() {
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')
  ___arguments.context.pageData['filtruStatus'] = 'TOATE';
  ___arguments.context.pageData['fromTime'] = (fromTime.valueOf());
  ___arguments.context.pageData['toTime'] = (toTime.valueOf());
  ___arguments.context.pageData['dinData'] = ((((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setProperties('created').setSortBy('created').setPageSize(100)))[0])['created']).valueOf());
  ___arguments.context.pageData['panaInData'] = ((((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setProperties('created').setSortBy('created desc').setPageSize(100)))[0])['created']).valueOf());
  ___arguments.context.pageData['counterElemente'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_f0a77863b8f7a67332afc58752e9ff88'](___arguments.context.pageData)))));
  if ((await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData)) && (currentUser['rol']) == 'MASTERADMIN') {
  } else {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('NoAccess', null);
  }
  ___arguments.context.pageData['sumaNedecontata'] = (await BackendlessUI.Functions.Custom['fn_a0ad6012a17565f1b4bd5b8afb3dade3']());

  ;(function() {
    const callback = async () => {
        ___arguments.context.pageData['pulseFaraLivrator'] = false;
    await new Promise(r => setTimeout(r, 1000 || 0));
    ___arguments.context.pageData['pulseFaraLivrator'] = true;

    };

    const timerId = 'pulseFaraLivrator';
    const timerDelay = 2000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setSortBy('programare desc').setPageSize(100))));
  if ((___arguments.context.pageData['filtruStatus']) == 'TOATE' || (___arguments.context.pageData['filtruStatus']) == null) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setSortBy('programare desc').setPageSize(100))));
  } else if ((___arguments.context.pageData['filtruStatus']) == 'LIVRATA') {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_d98d91bd0f197b0a281b6509b663adc7'](___arguments.context.appData, ___arguments.context.pageData)));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));
  }
  ___arguments.context.pageData['counterToate'] = (await Backendless.Data.of('Comenzi').getObjectCount());
  ___arguments.context.pageData['counterProgramate'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'PROGRAMATA\'')));
  ___arguments.context.pageData['counterIL'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'IN LUCRU\'')));
  ___arguments.context.pageData['counterGDL'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'GATA DE LIVRARE\'')));
  ___arguments.context.pageData['counterR'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'RIDICATA\'')));
  ___arguments.context.pageData['counterILiv'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'IN LIVRARE\'')));
  ___arguments.context.pageData['counterLiv'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'LIVRATA\'')));
  ___arguments.context.pageData['sumaNedecontata'] = (await BackendlessUI.Functions.Custom['fn_a0ad6012a17565f1b4bd5b8afb3dade3']());

  ;(function() {
    const callback = async object => {
        ;await ( async function (message){ alert(message) })('Sunt disponibile comenzi noi!');
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b7d4e7f099d352af9c47537215d2f18', true);
    if ((___arguments.context.pageData['filtruStatus']) == 'TOATE' || (___arguments.context.pageData['filtruStatus']) == null) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setSortBy('programare desc').setPageSize(100))));
    } else if ((___arguments.context.pageData['filtruStatus']) == 'LIVRATA') {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_d98d91bd0f197b0a281b6509b663adc7'](___arguments.context.appData, ___arguments.context.pageData)));
    } else {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));
    }

    ;(function() {
      const callback = async () => {
          ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b7d4e7f099d352af9c47537215d2f18', false);

      };

      const timerId = 'comandaNoua';
      const timerDelay = 10000;

      runSetTimeout(timerId, callback, timerDelay)
    })()

    };

    const rtHandlers = Backendless.Data.of('Comenzi').rt();

    const whereClause = '';
    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addCreateListener.apply(rtHandlers, options);

    getRTSubscriptions().add('createComanda', () => rtHandlers.removeCreateListener(callback));

  })()

  ;(function() {
    const callback = async object => {
        if ((___arguments.context.pageData['filtruStatus']) == 'TOATE' || (___arguments.context.pageData['filtruStatus']) == null) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setSortBy('created desc').setPageSize(100))));
    } else if ((___arguments.context.pageData['filtruStatus']) == 'LIVRATA') {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_d98d91bd0f197b0a281b6509b663adc7'](___arguments.context.appData, ___arguments.context.pageData)));
    } else {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));
    }
    ___arguments.context.pageData['counterToate'] = (await Backendless.Data.of('Comenzi').getObjectCount());
    ___arguments.context.pageData['counterProgramate'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'PROGRAMATA\'')));
    ___arguments.context.pageData['counterIL'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'IN LUCRU\'')));
    ___arguments.context.pageData['counterGDL'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'GATA DE LIVRARE\'')));
    ___arguments.context.pageData['counterR'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'RIDICATA\'')));
    ___arguments.context.pageData['counterILiv'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'IN LIVRARE\'')));
    ___arguments.context.pageData['counterLiv'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'LIVRATA\'')));
    ___arguments.context.pageData['sumaNedecontata'] = (await BackendlessUI.Functions.Custom['fn_a0ad6012a17565f1b4bd5b8afb3dade3']());

    };

    const rtHandlers = Backendless.Data.of('Comenzi').rt();

    const whereClause = '';
    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add('updateComenzi', () => rtHandlers.removeUpdateListener(callback));

  })()
    }



BackendlessUI.Functions.Custom['fn_b84dbd218d0bc052358773d5b4441bcf'] = async function fn_b84dbd218d0bc052358773d5b4441bcf() {
    await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')
  ___arguments.context.pageData['filtruStatus'] = 'TOATE';
  ___arguments.context.pageData['fromTime'] = (fromTime.valueOf());
  ___arguments.context.pageData['toTime'] = (toTime.valueOf());
  ___arguments.context.pageData['dinData'] = ((((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setProperties('created').setSortBy('created').setPageSize(100)))[0])['created']).valueOf());
  ___arguments.context.pageData['panaInData'] = ((((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setProperties('created').setSortBy('created desc').setPageSize(100)))[0])['created']).valueOf());
  ___arguments.context.pageData['counterElemente'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_f0a77863b8f7a67332afc58752e9ff88'](___arguments.context.pageData)))));
  if ((await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData)) && (currentUser['rol']) == 'MASTERADMIN') {
  } else {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('NoAccess', null);
  }
  ___arguments.context.pageData['sumaNedecontata'] = (await BackendlessUI.Functions.Custom['fn_a0ad6012a17565f1b4bd5b8afb3dade3']());

  ;(function() {
    const callback = async () => {
        ___arguments.context.pageData['pulseFaraLivrator'] = false;
    await new Promise(r => setTimeout(r, 1000 || 0));
    ___arguments.context.pageData['pulseFaraLivrator'] = true;

    };

    const timerId = 'pulseFaraLivrator';
    const timerDelay = 2000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setSortBy('programare desc').setPageSize(100))));
  if ((___arguments.context.pageData['filtruStatus']) == 'TOATE' || (___arguments.context.pageData['filtruStatus']) == null) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setSortBy('programare desc').setPageSize(100))));
  } else if ((___arguments.context.pageData['filtruStatus']) == 'LIVRATA') {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_d98d91bd0f197b0a281b6509b663adc7'](___arguments.context.appData, ___arguments.context.pageData)));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));
  }
  ___arguments.context.pageData['counterToate'] = (await Backendless.Data.of('Comenzi').getObjectCount());
  ___arguments.context.pageData['counterProgramate'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'PROGRAMATA\'')));
  ___arguments.context.pageData['counterIL'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'IN LUCRU\'')));
  ___arguments.context.pageData['counterGDL'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'GATA DE LIVRARE\'')));
  ___arguments.context.pageData['counterR'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'RIDICATA\'')));
  ___arguments.context.pageData['counterILiv'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'IN LIVRARE\'')));
  ___arguments.context.pageData['counterLiv'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'LIVRATA\'')));
  ___arguments.context.pageData['sumaNedecontata'] = (await BackendlessUI.Functions.Custom['fn_a0ad6012a17565f1b4bd5b8afb3dade3']());

  ;(function() {
    const callback = async object => {
        ;await ( async function (message){ alert(message) })('Sunt disponibile comenzi noi!');
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b7d4e7f099d352af9c47537215d2f18', true);
    if ((___arguments.context.pageData['filtruStatus']) == 'TOATE' || (___arguments.context.pageData['filtruStatus']) == null) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setSortBy('programare desc').setPageSize(100))));
    } else if ((___arguments.context.pageData['filtruStatus']) == 'LIVRATA') {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_d98d91bd0f197b0a281b6509b663adc7'](___arguments.context.appData, ___arguments.context.pageData)));
    } else {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));
    }

    ;(function() {
      const callback = async () => {
          ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b7d4e7f099d352af9c47537215d2f18', false);

      };

      const timerId = 'comandaNoua';
      const timerDelay = 10000;

      runSetTimeout(timerId, callback, timerDelay)
    })()

    };

    const rtHandlers = Backendless.Data.of('Comenzi').rt();

    const whereClause = '';
    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addCreateListener.apply(rtHandlers, options);

    getRTSubscriptions().add('createComanda', () => rtHandlers.removeCreateListener(callback));

  })()

  ;(function() {
    const callback = async object => {
        if ((___arguments.context.pageData['filtruStatus']) == 'TOATE' || (___arguments.context.pageData['filtruStatus']) == null) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setSortBy('created desc').setPageSize(100))));
    } else if ((___arguments.context.pageData['filtruStatus']) == 'LIVRATA') {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_d98d91bd0f197b0a281b6509b663adc7'](___arguments.context.appData, ___arguments.context.pageData)));
    } else {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));
    }
    ___arguments.context.pageData['counterToate'] = (await Backendless.Data.of('Comenzi').getObjectCount());
    ___arguments.context.pageData['counterProgramate'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'PROGRAMATA\'')));
    ___arguments.context.pageData['counterIL'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'IN LUCRU\'')));
    ___arguments.context.pageData['counterGDL'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'GATA DE LIVRARE\'')));
    ___arguments.context.pageData['counterR'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'RIDICATA\'')));
    ___arguments.context.pageData['counterILiv'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'IN LIVRARE\'')));
    ___arguments.context.pageData['counterLiv'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status = \'LIVRATA\'')));
    ___arguments.context.pageData['sumaNedecontata'] = (await BackendlessUI.Functions.Custom['fn_a0ad6012a17565f1b4bd5b8afb3dade3']());

    };

    const rtHandlers = Backendless.Data.of('Comenzi').rt();

    const whereClause = '';
    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add('updateComenzi', () => rtHandlers.removeUpdateListener(callback));

  })()


  return
}

})
define('./functions/b9681bbc770913a33d9ceedb73e585a2/code.js', () => { 

var currentUser;



BackendlessUI.Functions.Custom['fn_b9681bbc770913a33d9ceedb73e585a2'] = async function fn_b9681bbc770913a33d9ceedb73e585a2(pageData, currentUser) {


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(currentUser['masterEmail']),'\' AND livrator = \'',(pageData['filtruLivrator']),'\' AND decontat = FALSE AND NOT status = \'ANULATA\'','',''].join(''))).setSortBy('created asc').setPageSize(100)))
}

})
define('./functions/bc975a714a5b947cb4db68034f432e01/code.js', () => { 

BackendlessUI.Functions.Custom['fn_bc975a714a5b947cb4db68034f432e01'] = async function fn_bc975a714a5b947cb4db68034f432e01(itemData) {


  return (['data/ora limita: ',(new Date((itemData['programare'])).getDate()) <= 9 ? String('0') + String(new Date((itemData['programare'])).getDate()) : (new Date((itemData['programare'])).getDate()),'/',(new Date((itemData['programare'])).getMonth()) + 1 <= 9 ? String('0') + String((new Date((itemData['programare'])).getMonth()) + 1) : (new Date((itemData['programare'])).getMonth()) + 1,'/',(new Date((itemData['programare'])).getFullYear()) <= 9 ? String('0') + String(new Date((itemData['programare'])).getFullYear()) : (new Date((itemData['programare'])).getFullYear()),'  ',(new Date((itemData['programare'])).getHours()) <= 9 ? String('0') + String(new Date((itemData['programare'])).getHours()) : (new Date((itemData['programare'])).getHours()),':',(new Date((itemData['programare'])).getMinutes()) <= 9 ? String('0') + String(new Date((itemData['programare'])).getMinutes()) : (new Date((itemData['programare'])).getMinutes())].join(''))
}

})
define('./functions/c4e97af1f13356084877663da10b7363/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'] = async function fn_c4e97af1f13356084877663da10b7363(appData) {


  return (appData['currentUser'])
}

})
define('./functions/c935344860c51958c4736c7f34f3d4a5/code.js', () => { 

var currentUser;



BackendlessUI.Functions.Custom['fn_c935344860c51958c4736c7f34f3d4a5'] = async function fn_c935344860c51958c4736c7f34f3d4a5(itemData, appData) {
    await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](appData));
  itemData['livrator'] = (currentUser['username']);
  itemData['emailLivrator'] = (currentUser['userEmail']);
  await Backendless.Data.of('Comenzi').save( itemData );



}

})
define('./functions/cff56ffe779e610ecf21eb93303266a5/code.js', () => { 

var toTime, fromTime;



BackendlessUI.Functions.Custom['fn_cff56ffe779e610ecf21eb93303266a5'] = async function fn_cff56ffe779e610ecf21eb93303266a5(curentUser) {
    fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['programare >=',(fromTime.valueOf()),'AND programare <=',(toTime.valueOf()),'AND masterEmail =\'',(curentUser['masterEmail']),'\' AND NOT status = \'ANULATA\'','',''].join(''))).setSortBy('created desc').setPageSize(100)))
}

})
define('./functions/d3d564c2dfc2d41f3d62890e3adde373/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d3d564c2dfc2d41f3d62890e3adde373'] = async function fn_d3d564c2dfc2d41f3d62890e3adde373(itemData) {


  return (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['livrator = \'',(itemData['livrator']),'\' AND NOT status = \'LIVRATA\' AND NOT status = \'ANULATA\''].join('')))))
}

})
define('./functions/d96b7da8ca6e1159e055c46f4f6d832c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d96b7da8ca6e1159e055c46f4f6d832c'] = async function fn_d96b7da8ca6e1159e055c46f4f6d832c(itemData) {
    itemData['notificare'] = 'CONFIRMAT';
  await Backendless.Data.of('Comenzi').save( itemData );



}

})
define('./functions/d9733facbed29671ea191eaddae6a598/code.js', () => { 

var currentUser;



BackendlessUI.Functions.Custom['fn_d9733facbed29671ea191eaddae6a598'] = async function fn_d9733facbed29671ea191eaddae6a598(AppData, Status, fromTime, toTime) {
    await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](AppData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](AppData));


  return (['emailLivrator = \'',(currentUser['userEmail']),'\' AND status = \'',Status,'\' AND programare >=',(fromTime.valueOf()),' AND programare <=',(toTime.valueOf())].join(''))
}

})
define('./functions/d98d91bd0f197b0a281b6509b663adc7/code.js', () => { 

var toTime, fromTime, currentUser;



BackendlessUI.Functions.Custom['fn_d98d91bd0f197b0a281b6509b663adc7'] = async function fn_d98d91bd0f197b0a281b6509b663adc7(appData, pageData) {
    await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](appData)
  currentUser = appData;
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setSeconds('999')


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(currentUser['masterEmail']),'\' AND status = \'LIVRATA\'',' AND oraLivrare >= ',(fromTime.valueOf()),' AND oraLivrare <= ',(toTime.valueOf()),!((pageData['cautaComanda']) == null) ? [' AND search LIKE \'%',(pageData['cautaComanda']),'%\''].join('') : null].join(''))).setSortBy('programare desc').setPageSize(99)))
}

})
define('./functions/d9dc12d90f53834ce88f0a2e96fa375a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d9dc12d90f53834ce88f0a2e96fa375a'] = async function fn_d9dc12d90f53834ce88f0a2e96fa375a(currentUser) {


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail= \'',(currentUser['masterEmail']),'\' AND decontat = FALSE AND NOT status = \'ANULATA\'','',''].join(''))).setSortBy('livrator asc').setPageSize(100)))
}

})
define('./functions/e13b67317943122e9a1d8627ac4ab81b/code.js', () => { 

var toTime, fromTime;



BackendlessUI.Functions.Custom['fn_e13b67317943122e9a1d8627ac4ab81b'] = async function fn_e13b67317943122e9a1d8627ac4ab81b() {
    fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')


  return (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['programare >=',(fromTime.valueOf()),'AND programare <=',(toTime.valueOf()),' AND NOT status = \'ANULATA\'','','','',''].join(''))).setSortBy('created desc').setPageSize(100)))
}

})
define('./functions/ea2ba1dd61ffa04865dcece4f28a1a2f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ea2ba1dd61ffa04865dcece4f28a1a2f'] = async function fn_ea2ba1dd61ffa04865dcece4f28a1a2f(textValoareFiltru, pageData, whereClause, appData) {
    pageData['cartier1'] = '-';
  pageData['cartier2'] = '-';
  pageData['cartier3'] = '-';
  pageData['cartier4'] = '-';
  pageData['cartier5'] = '-';
  pageData['cartier6'] = '-';
  pageData['cartier7'] = '-';
  pageData['cartier8'] = '-';
  pageData['cartier9'] = '-';
  pageData['cartier10'] = '-';
  pageData['cartier11'] = '-';
  pageData['cartier12'] = '-';
  pageData['cartier13'] = '-';
  pageData['cartier14'] = '-';
  pageData['cartier15'] = '-';
  pageData['filtruStatus'] = textValoareFiltru;
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100))).length >= 1) {
    pageData['cartier1'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100)))[0])['cartier']);
    pageData['countCartier1'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier1']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100))).length >= 2) {
    pageData['cartier2'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100)))[1])['cartier']);
    pageData['countCartier2'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier2']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100))).length >= 3) {
    pageData['cartier3'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100)))[2])['cartier']);
    pageData['countCartier3'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier3']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100))).length >= 4) {
    pageData['cartier4'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100)))[3])['cartier']);
    pageData['countCartier4'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier4']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100))).length >= 5) {
    pageData['cartier5'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100)))[4])['cartier']);
    pageData['countCartier5'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier5']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100))).length >= 6) {
    pageData['cartier6'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100)))[5])['cartier']);
    pageData['countCartier6'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier6']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100))).length >= 7) {
    pageData['cartier7'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100)))[6])['cartier']);
    pageData['countCartier7'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier7']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100))).length >= 8) {
    pageData['cartier8'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100)))[7])['cartier']);
    pageData['countCartier8'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier8']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100))).length >= 9) {
    pageData['cartier9'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100)))[8])['cartier']);
    pageData['countCartier9'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier9']),'\''].join('')))));
  }
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100))).length >= 10) {
    pageData['cartier10'] = (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties('cartier').setSortBy('cartier').setGroupBy('cartier').setPageSize(100)))[9])['cartier']);
    pageData['countCartier10'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(([whereClause,'AND cartier = \'',(pageData['cartier10']),'\''].join('')))));
  }



}

})
define('./functions/eb0fab0b577e4258db7644dcf6560004/code.js', () => { 

var item;



BackendlessUI.Functions.Custom['fn_eb0fab0b577e4258db7644dcf6560004'] = async function fn_eb0fab0b577e4258db7644dcf6560004(masterEmail) {


  return (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',masterEmail,'\' AND decontat = FALSE AND NOT status = \'ANULATA\''].join(''))).setProperties('plata_cash').setPageSize(99))).map(item => {; return (item['plata_cash']);})).length == 0 ? 0 : ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',masterEmail,'\' AND decontat = FALSE AND NOT status = \'ANULATA\''].join(''))).setProperties('plata_cash').setPageSize(100))).map(item => {; return (item['plata_cash']);})).reduce(function(x, y) {return x + y;}))
}

})
define('./functions/ee7324dbc868b551955859991782e774/code.js', () => { 

var item;



BackendlessUI.Functions.Custom['fn_ee7324dbc868b551955859991782e774'] = async function fn_ee7324dbc868b551955859991782e774(pageData) {


  return (((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(([' livrator = \'',(pageData['filtruLivrator']),'\' AND decontat = FALSE AND NOT status = \'ANULATA\'','','',''].join(''))).setProperties('plata_cash').setPageSize(99))).map(item => {; return (item['plata_cash']);})).length == 0 ? 0 : ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['','',' livrator = \'',(pageData['filtruLivrator']),'\' AND decontat = FALSE AND NOT status = \'ANULATA\'',''].join(''))).setProperties('plata_cash').setPageSize(99))).map(item => {; return (item['plata_cash']);})).reduce(function(x, y) {return x + y;}))
}

})
define('./functions/ef9dee2633c677fc43bc1bfe6b8c49a8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ef9dee2633c677fc43bc1bfe6b8c49a8'] = async function fn_ef9dee2633c677fc43bc1bfe6b8c49a8(itemData, currentUser) {
    itemData['notificare'] = 'NOTIFICAT';
  await Backendless.Data.of('Comenzi').save( itemData );
  ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((['sms:',(itemData['telefonClient']),'?&body=','Coletul dumneavoastra de la: ',(itemData['masterClient']),' a fost preluat de un livrator CallDelivery. Va rugam sa luati legatura cu livratorul pentru a stabili amanuntele livrarii.  Telefon livrator: ',(currentUser['telefonUser']),(itemData['plata_cash']) > 0 && ((itemData['masterClient']) == 'ECCO' || (itemData['masterClient']) == 'MUCHATON' || (itemData['masterClient']) == 'PANDORA') ? [' Aveti de plata ',(itemData['plata_cash']),'lei. Puteti plati si cu CARD(de preferat) sau Revolut, direct la livrator. '].join('') : '',(itemData['plata_cash']) > 0 && !((itemData['masterClient']) == 'ECCO' || (itemData['masterClient']) == 'MUCHATON' || (itemData['masterClient']) == 'PANDORA') ? [' Aveti de plata ',(itemData['plata_cash']),'lei. Puteti plati si cu Revolut direct la livrator. '].join('') : '','','','','','&'].join('')), true, null);



}

})
define('./functions/f0a77863b8f7a67332afc58752e9ff88/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f0a77863b8f7a67332afc58752e9ff88'] = async function fn_f0a77863b8f7a67332afc58752e9ff88(PageData) {


  return (['created >= ',(PageData['dinData']),' AND created <= ',(PageData['panaInData']),'','','',!((PageData['cautaComanda']) == null) ? [' AND search LIKE \'%',(PageData['cautaComanda']),'%\''].join('') : null,!((PageData['cautaClient']) == null) ? [' AND masterClient LIKE \'%',(PageData['cautaClient']),'%\''].join('') : null].join(''))
}

})
define('./functions/f83af483d7d600291a5da56768f3bacb/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f83af483d7d600291a5da56768f3bacb'] = async function fn_f83af483d7d600291a5da56768f3bacb(itemData, currentUser) {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((['sms:',(itemData['telefonClient']),'?&body=','Comanda: ',(itemData['comanda']),' de la: ',(itemData['masterClient']),'este in livrare. Telefon livrator: ',(currentUser['telefonUser']),'',(itemData['plata_cash']) > 0 ? ['Aveti de plata ',(itemData['plata_cash']),'lei. Va rugam sa aveti bani potriviti. Puteti plati si cu Revolut direct la livrator. '].join('') : '','Accesand urmatorul link puteti urmari localizarea livratorului.',(((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['emailLivrator = \'',(currentUser['userEmail']),'\'','','','',''].join(''))).setProperties('shareLocation').setSortBy('created desc').setPageSize(1)))[0])['shareLocation']),'&'].join('')), true, null);



}

})
define('./pages/404/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async onEnter(___arguments) {
    var currentUser;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (!(await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  }

  },  
/* handler:onEnter *//* content */
}));

define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },
  /* handler:onClick *//* content */
}));

define('./pages/ArhivaComenzi/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, toTime, fromTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (!(await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  ___arguments.context.pageData['showObjects'] = '0';
  ___arguments.context.pageData['cautaComanda'] = '';
  ___arguments.context.pageData['sumaNedecontata'] = (await BackendlessUI.Functions.Custom['fn_eb0fab0b577e4258db7644dcf6560004']((getObjectProperty(currentUser, 'masterEmail'))));

  ;(function() {
    const callback = async () => {
        ___arguments.context.pageData['pulseFaraLivrator'] = false;
    await new Promise(r => setTimeout(r, 1000 || 0));
    ___arguments.context.pageData['pulseFaraLivrator'] = true;

    };

    const timerId = 'pulseFaraLivrator';
    const timerDelay = 2000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  ___arguments.context.pageData['textCautare'] = 'In intervalul selectat au fost gasite: ';

  },
  /* handler:onEnter */

/* handler:onLeave */
  async onLeave(___arguments) {
    var currentUser;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  await Backendless.Data.of('Users').bulkUpdate( (['userEmail = \'',(currentUser['userEmail']),'\'','','',''].join('')), ({ 'online': false,'page': '' }) );

  },  
  /* handler:onLeave */
  /* content */
}));

define('./pages/ArhivaComenzi/components/d0292826e5d48b277e8221d63f75b556/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currentUserName, currentUser;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (currentUser) {
    currentUserName = (currentUser['username']);
  }

  return currentUserName

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/ArhivaComenzi/components/73712c1793d263f9c8dcdfd451233039/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ___arguments.context.appData['currentUser'] = null;

  },  
  /* handler:onClick *//* content */
}));

define('./pages/ArhivaComenzi/components/db8e872ab8c674ae309410e4a91151d6/bundle.js', [], () => ({
  /* content */

  

/* content */
}));




define('./pages/ArhivaComenzi/components/bcd52ba2f5e422b6147ef62387ac8ead/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/ArhivaComenzi/components/da36802a2e9c603706051115b7c476ef/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.appData['selectComanda'] = ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7');
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EditareComanda', ({ 'objectId': (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['objectId']) }));

  },  
/* handler:onClick *//* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['comanda']),'/',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['adresaLivrare'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}));

define('./pages/ArhivaComenzi/components/04a791a6d346897b4f725b27b6c1564e/bundle.js', [], () => ({
  /* content */

  
/* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Decont', null);

  },  
/* handler:onClick *//* handler:onLabelAssignment */
  async onLabelAssignment(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));

  return (['NEDECONTAT: ','',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['sumaNedecontata']))),'lei'].join(''))

  },  
  /* handler:onLabelAssignment *//* content */
}));

define('./pages/ArhivaComenzi/components/8a3ce129581dcdaa654f5e63f753349b/bundle.js', [], () => ({
  /* content */

  
/* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getDate()),'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getMonth()) + 1,'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getFullYear()),' ',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getHours()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getHours()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getHours()),':',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getMinutes()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getMinutes()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getMinutes())].join(''))

  },  
/* handler:onContentAssignment *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare']).valueOf()) - ((new Date()).valueOf()) < 900000 && !((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'LIVRATA') ? (___arguments.context.pageData['pulseFaraLivrator']) : true)

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/ArhivaComenzi/components/4cacfefef14af6ee5ecfabdb0cf41dba/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status'] = 'IN LUCRU';
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onClick *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'PROGRAMATA' ? true : false)

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/ArhivaComenzi/components/2597ccff8f36416d679785267664db41/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'IN LUCRU' ? true : false)

  },  
/* handler:onDisplayAssignment *//* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status'] = 'GATA DE LIVRARE';
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );
  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraGL'] = ((new Date()).valueOf());
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onClick *//* content */
}));

define('./pages/ArhivaComenzi/components/962255c3774a5e8f3b94282fef791836/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrareExtern']) ? 'EXTERN' : 'INTERN')

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/ArhivaComenzi/components/a16b8658eb8a9d0102bd053a09a12b9c/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Livratori', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/ArhivaComenzi/components/28bdcbf353368bf549bcd11f337293a8/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']) == 'FARA LIVRATOR' ? (___arguments.context.pageData['pulseFaraLivrator']) : true)

  },  
/* handler:onDisplayAssignment *//* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.appData['selectComanda'] = ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7');
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EditareComanda', ({ 'objectId': (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['objectId']) }));

  },  
/* handler:onClick *//* content */
}));

define('./pages/ArhivaComenzi/components/64e12ba2d6735d5c4a61fd41ec494173/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']) == 'FARA LIVRATOR' && (___arguments.context.pageData['pulseFaraLivrator']) == true) {
    return false;
  } else if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']) == 'FARA LIVRATOR' && (___arguments.context.pageData['pulseFaraLivrator']) == false) {
    return true;
  } else {
    return false;
  }

  },  
/* handler:onDisplayAssignment *//* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.appData['selectComanda'] = ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7');
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EditareComanda', ({ 'objectId': (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['objectId']) }));

  },  
/* handler:onClick *//* content */
}));

define('./pages/ArhivaComenzi/components/81756e03bbe5c68fd8e68d28a408a626/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.appData['selectComanda'] = ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7');
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EditareComanda', ({ 'objectId': (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['objectId']) }));

  },  
/* handler:onClick *//* content */
}));

define('./pages/ArhivaComenzi/components/6b965a641db16794fa1d78a49b43867c/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Comenzi', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/ArhivaComenzi/components/51a7eb315fd1c9c8e3a33085090c4f9c/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
    var currentUser, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function infoComenzi() {
  ___arguments.context.pageData['km'] = ((await Promise.all((await BackendlessUI.Functions.Custom['fn_ab3cfca3d708348592cd5edcfab17e23'](___arguments.context.pageData, currentUser)).map(async item => {; return ((getObjectProperty(item, 'distance')) / 1000);}))).reduce(function(x, y) {return x + y;}));
  ___arguments.context.pageData['tarifare'] = ((await Promise.all((await BackendlessUI.Functions.Custom['fn_ab3cfca3d708348592cd5edcfab17e23'](___arguments.context.pageData, currentUser)).map(async item => {; return (getObjectProperty(item, 'tarifare'));}))).reduce(function(x, y) {return x + y;}));
  ___arguments.context.pageData['infoComenzi'] = (['Info comenzi(max100 comenzi):\n','Km comenzi: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'km')))),'Km. Medie km/comanda: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'km')) / (getObjectProperty(___arguments.context.pageData, 'showObjects'))))),'Km\nTarifare comenzi: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'tarifare')))),'Lei. Medie tarifare/comanda: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'tarifare')) / (getObjectProperty(___arguments.context.pageData, 'showObjects'))))),'Lei\n'].join(''));
}


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_ab3cfca3d708348592cd5edcfab17e23'](___arguments.context.pageData, currentUser)));
  ___arguments.context.pageData['textCautare'] = 'In intervalul selectat au fost gasite: ';
  await infoComenzi();

  },
  /* handler:onChange *//* content */
}));

define('./pages/ArhivaComenzi/components/94e2deb704cfa6552d4fcf54b4288b0e/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
    var currentUser, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function infoComenzi() {
  ___arguments.context.pageData['km'] = ((await Promise.all((await BackendlessUI.Functions.Custom['fn_ab3cfca3d708348592cd5edcfab17e23'](___arguments.context.pageData, currentUser)).map(async item => {; return ((getObjectProperty(item, 'distance')) / 1000);}))).reduce(function(x, y) {return x + y;}));
  ___arguments.context.pageData['tarifare'] = ((await Promise.all((await BackendlessUI.Functions.Custom['fn_ab3cfca3d708348592cd5edcfab17e23'](___arguments.context.pageData, currentUser)).map(async item => {; return (getObjectProperty(item, 'tarifare'));}))).reduce(function(x, y) {return x + y;}));
  ___arguments.context.pageData['infoComenzi'] = (['Info comenzi(max100 comenzi):\n','Km comenzi: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'km')))),'Km. Medie km/comanda: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'km')) / (getObjectProperty(___arguments.context.pageData, 'showObjects'))))),'Km\nTarifare comenzi: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'tarifare')))),'Lei. Medie tarifare/comanda: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'tarifare')) / (getObjectProperty(___arguments.context.pageData, 'showObjects'))))),'Lei\n'].join(''));
}


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_ab3cfca3d708348592cd5edcfab17e23'](___arguments.context.pageData, currentUser)));
  ___arguments.context.pageData['textCautare'] = 'La cautarea ta, in intervalul selectat, au fost gasite: ';
  await infoComenzi();

  },
  /* handler:onChange *//* content */
}));

define('./pages/ArhivaComenzi/components/f72b19f8d39a4e7e864af03c132711e6/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
    var currentUser, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function infoComenzi() {
  ___arguments.context.pageData['km'] = ((await Promise.all((await BackendlessUI.Functions.Custom['fn_ab3cfca3d708348592cd5edcfab17e23'](___arguments.context.pageData, currentUser)).map(async item => {; return ((getObjectProperty(item, 'distance')) / 1000);}))).reduce(function(x, y) {return x + y;}));
  ___arguments.context.pageData['tarifare'] = ((await Promise.all((await BackendlessUI.Functions.Custom['fn_ab3cfca3d708348592cd5edcfab17e23'](___arguments.context.pageData, currentUser)).map(async item => {; return (getObjectProperty(item, 'tarifare'));}))).reduce(function(x, y) {return x + y;}));
  ___arguments.context.pageData['medieKm'] = ((getObjectProperty(___arguments.context.pageData, 'km')) / (getObjectProperty(___arguments.context.pageData, 'showObjects')));
  ___arguments.context.pageData['medieTarifare'] = ((getObjectProperty(___arguments.context.pageData, 'tarifare')) / (getObjectProperty(___arguments.context.pageData, 'showObjects')));
  ___arguments.context.pageData['infoComenzi'] = (['Info comenzi( se afiseaza max100 comenzi):\n','Km comenzi: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'km')))),'Km. Medie km/comanda: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'medieKm')))),'Km\nTarifare comenzi: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'tarifare')))),'Lei. Medie tarifare/comanda: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'medieTarifare')))),'Lei\n'].join(''));
}


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_ab3cfca3d708348592cd5edcfab17e23'](___arguments.context.pageData, currentUser)));
  ___arguments.context.pageData['textCautare'] = 'In intervalul selectat au fost gasite: ';
  await infoComenzi();

  },
  /* handler:onChange *//* content */
}));

define('./pages/ArhivaComenzi/components/54aac7cbcbec0f31a1070b9f0cf3d32a/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['incasarePos'])

  },  
/* handler:onDisplayAssignment *//* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (['Comision POS: ','','','',Math.round((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['comisionPos']) * 100) / 100,' Lei'].join(''))

  },  
  /* handler:onLabelAssignment */
  /* content */
}));

define('./pages/ArhivaComenzi/components/a36737ac9a042f7d9d4a6ae32d9cdc6f/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
      ___arguments.context.dataModel['paginaCurenta'] = 'Arhiva Comenzi';
  await Backendless.Data.of('DispecerActiv').save( ___arguments.context.dataModel );

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/ArhivaComenzi/components/a56e9f55914fd3d2b262ed74d0820466/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((['https://calldelivery.ro/pdf/get-pdf/',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['awb']),''].join('')), true, null);

  },  
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['optiuneAwb'])

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ArhivaComenzi/components/97a7a7a433d384bd743b6dab6b47cef5/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['',(___arguments.context.pageData['textCautare']),(___arguments.context.pageData['showObjects']),' inregistrari'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}));

define('./pages/ComandaNoua/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser;

/**
 * Describe this function...
 */
async function testMaps() {
  ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ [`destinations`]: ['Aleea Rasinari 4 Cluj-Napoca','',''].join(''),[`origins`]: ['Aleea Rasinari 2 Cluj-Napoca','',''].join('') })));
  ___arguments.context.pageData['testGoogle'] = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['','https://maps.googleapis.com/maps/api/geocode/json?address=','Aleea Rasinari 2 Cluj-Napoca','','&key=AIzaSyDC4mbqOev3A2j8-gaFSZ3GZ_2cQXAORBw&='].join('')))).setEncoding('utf8').send());
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function user() {
  if ((getObjectProperty(___arguments.context.appData, 'user')) == null) {
    console.log('no user load');
    await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
    ___arguments.context.appData['user'] = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  }
  currentUser = (getObjectProperty(___arguments.context.appData, 'user'));
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function updatedDispecer() {
  ___arguments.context.appData['dispecerActiv'] = ((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('dispecer/get')))).setEncoding('utf8').send(({ [`selected`]: ({ [`dispecer`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'username')) }) })))[0]);
  await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(String(getObjectProperty(___arguments.context.appData, 'server')) + String('dispecer/')) + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'dispecerActiv')), '_id'))))).setEncoding('utf8').send(({ [`paginaCurenta`]: 'Comanda noua' }));
  await Backendless.Messaging.publish('dispecerActiv', 'Activ pe comenzi', new Backendless.PublishOptions({ subtopic: 'Dispecer activ' }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb67d460bb595d9b5cb8a86d63b8a5b', true);
  ___arguments.context.pageData['paginaCurenta'] = 'comanda noua';
  await user();
  try {
    await testMaps();

  } catch (error) {
    ___arguments.context.pageData['eroareMaps'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e38f7bd4fb4b108488506bf716aa9bf', true);

  } finally {
    try {
      ___arguments.context.pageData['testAwb'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'awb'));

    } catch (error) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Comenzi', undefined);

    } finally {
      if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'username')) == null) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14654282be67c4ca9d3abddded61c584', false);
        (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://calldelivery.store4.ro', false, undefined);
      } else {
        ___arguments.context.pageData['userEmail'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'userEmail'));
        await updatedDispecer();
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bedee28d86e292249c57a6782cb84a21', (getObjectProperty(___arguments.context.appData, 'dispecerActiv')));
      }

    }

  }

  ;(function() {
    const callback = async () => {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Comenzi', undefined);

    };

    const timerId = 'intarzierePeComandaNoua';
    const timerDelay = 300000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onEnter */
/* handler:onLeave */
  onLeave(___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}


  getRTSubscriptions().remove('createLivratorActivExtern');;
  getRTSubscriptions().remove('UpdateLivratorActiv');;
  stopSetTimeout('intarzierePeComandaNoua');

  },  
  /* handler:onLeave *//* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'DeliveryPro V2.0'

  },  
/* handler:onTitleAssignment *//* handler:onScroll */
  onScroll(___arguments) {
      ___arguments.context.pageData['paginaCurenta'] = 'comanda noua';

  },
  /* handler:onScroll */
  /* content */
}));

define('./pages/ComandaNoua/components/222914427ab8caf9ccb26d9331f9ea99/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var currentLocation, message, appUsername;


  appUsername = ((await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))['username']);
  currentLocation = (___arguments.context.pageData['currentLocation']);
  message = (___arguments.context.dataModel['message']);
  if (message) {
    ___arguments.context.dataModel['message'] = '';
    await Backendless.Messaging.publish('default', ({ 'username': appUsername,'message': message,'lat': (currentLocation['lat']),'lng': (currentLocation['lng']) }), new Backendless.PublishOptions({ subtopic: '' }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
  }

  },  
/* handler:onSubmit *//* content */
}));

define('./pages/ComandaNoua/components/3aed9c98df6f4d3f76466c26cdbbefd4/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'eroareMaps')))

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNoua/components/bcd52ba2f5e422b6147ef62387ac8ead/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['paginaCurenta'] = 'renuntaLaComanda';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Comenzi', undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/ComandaNoua/components/14654282be67c4ca9d3abddded61c584/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var item, toTime, fromTime, destinatarNou, timeOfset, currentUser;

/**
 * Describe this function...
 */
async function checkError() {
  await testMaps();
}

/**
 * Describe this function...
 */
async function testMaps() {
  ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.superdev.ro/maps')).setEncoding('utf8').send(({ [`destinations`]: 'Aleea Rasinari 4 Cluj-Napoca',[`origins`]: 'Aleea Rasinari 2 Cluj-Napoca' })));
  ___arguments.context.pageData['testGoogle'] = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['','https://maps.googleapis.com/maps/api/geocode/json?address=','Aleea Rasinari 2 Cluj-Napoca','','&key=AIzaSyDC4mbqOev3A2j8-gaFSZ3GZ_2cQXAORBw&='].join('')))).setEncoding('utf8').send());
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function tarifareLivrator() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.dataModel['newTarifareLiv'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((8 + (getObjectProperty(___arguments.context.pageData, 'kmSPLLivrator')) * 1.5)));
  } else {
    ___arguments.context.dataModel['newTarifareLiv'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.dataModel, 'newTarifare')) * 0.69)));
  }
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function onSubmit() {
  ___arguments.context.pageData['submit'] = true;
  await setTimeAndUser();
  ___arguments.context.dataModel['newNumarComanda'] = (['[',(getObjectProperty(___arguments.context.appData, 'comenziActive')).length + 1,'#',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masterID')),']',''].join(''));
  ___arguments.context.dataModel['newComanda'] = (getObjectProperty(___arguments.context.dataModel, 'newNumarComanda'));
  ___arguments.context.pageData['newNumeClient'] = '';
  ___arguments.context.dataModel['newAwb'] = (await Backendless.Counters.addAndGet('awb', 1));
  ___arguments.context.dataModel['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.dataModel, 'newStrada')),' ',(getObjectProperty(___arguments.context.dataModel, 'newNumar')),!((getObjectProperty(___arguments.context.dataModel, 'newAnexaNumar')) == '') || !!(getObjectProperty(___arguments.context.dataModel, 'newAnexaNumar')).length ? [' - ',(getObjectProperty(___arguments.context.dataModel, 'newAnexaNumar')),' '].join('') : ' ',''].join(''));
  ___arguments.context.pageData['adresaGoogle'] = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://maps.googleapis.com/maps/api/geocode/json?address=',(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),(getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.dataModel, 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca','&key=AIzaSyDC4mbqOev3A2j8-gaFSZ3GZ_2cQXAORBw&='].join('')))).setEncoding('utf8').send());
  try {
    await distanta_time();
    await tarifareKm();

  } catch (error) {
    (function (message) { alert(message) })('Comanda nu a fost inregistrata. NU ati selectat strada din lista dupa ce ati cautat strada. Va rugam reintroduceti comanda cu mai multa atentie.');

  } finally {
    await distanta_time();
    await tarifareKm();
    await tarifareLivrator();
    ___arguments.context.appData['LivratorActiv'] = 1;
    await setInterval2();
    await NewComandaNoua();
    if (!((getObjectProperty(___arguments.context.appData, 'LivratorActiv')) > 0)) {
      (function (message) { alert(message) })('Momentan nu avem sau nu mai avem livratori Activi. Comanda este inregistrata dar este posibil ca preluarea sa se faca cu intarziere sau chiar sa nu mai poata fi preluata de un livrator.');
    }
    if (getObjectProperty(___arguments.context.dataModel, 'newOptiuneAwb')) {
      await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.superdev.ro/pdf/pdf-email')).setEncoding('utf8').send(({ [`to`]: ['','',(getObjectProperty(___arguments.context.dataModel, 'newEmailRidicare'))].join(''),[`textBody`]: ['Comanda:  ',[(getObjectProperty(___arguments.context.dataModel, 'newComanda')),'/',[(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),' [',(getObjectProperty(___arguments.context.dataModel, 'newCartier')),']'].join(''),'','','','',''].join(''),'Adresa Ridicare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),'Adresa Livrare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),'Ramburs: ',(getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),'Telefon Client: ',(getObjectProperty(___arguments.context.dataModel, 'newTelefonClient')),'Observatii: ',['',String('sc. ') + String(getObjectProperty(___arguments.context.dataModel, 'newScara')),String(' et. ') + String(getObjectProperty(___arguments.context.dataModel, 'newEtaj')),String(' ap. ') + String(getObjectProperty(___arguments.context.dataModel, 'newApartament')),'(',(getObjectProperty(___arguments.context.dataModel, 'newDetaliiLivrare')),')'].join(''),'',['Acceseaza urmatorul link pentru a vizualiza/printa AWB-ul <br> <a href="','https://calldelivery.ro/pdf/get-pdf/',(getObjectProperty(___arguments.context.dataModel, 'newAwb')),'">AWB</a>',(getObjectProperty(___arguments.context.dataModel, 'newAwb')),'</a>'].join(''),' Va multumim ca folositi DeliveryPro App (CallDelivery Team. Tel: 0752621501)) ','Va rugam nu dati replay la acest email '].join(''),[`htmlBody`]: ['Comanda:  ',(getObjectProperty(___arguments.context.dataModel, 'newComanda')),'<br>Adresa Ridicare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),'<br>Adresa Livrare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),'<br> Ramburs: ',(getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),'<br>Telefon Client: ',(getObjectProperty(___arguments.context.dataModel, 'newTelefonClient')),'<br>Observatii: ',(getObjectProperty(___arguments.context.dataModel, 'newDetaliiLivrare')),'',['<br><b>Acceseaza urmatorul link pentru a vizualiza/printa AWB-ul <br> ','<a href="https://cd.superdev.ro/pdf/get-pdf/',(getObjectProperty(___arguments.context.dataModel, 'newAwb')),'">AWB-',(getObjectProperty(___arguments.context.dataModel, 'newAwb')),'</a></b>'].join(''),'<br>Va multumim ca folositi DeliveryPro App (CallDelivery Team. Tel: 0752621501)) ','<br>Va rugam nu raspundeti la acest email '].join(''),[`comanda`]: [(getObjectProperty(___arguments.context.dataModel, 'newComanda')),'/',[(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),' [',(getObjectProperty(___arguments.context.dataModel, 'newCartier')),']/'].join(''),[(new Date((new Date())).getDate()) >= 10 ? (new Date((new Date())).getDate()) : String('0') + String(new Date((new Date())).getDate()),'.',(new Date((new Date())).getMonth() + 1) >= 10 ? (new Date((new Date())).getMonth() + 1) : String('0') + String(new Date((new Date())).getMonth() + 1),'.',(new Date((new Date())).getFullYear()),'',''].join(''),'','','',''].join(''),[`awb`]: (getObjectProperty(___arguments.context.dataModel, 'newAwb')),[`expeditor`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'nume_firma')),[`adresa`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'adresa_firma')),[`cui`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'cui')),[`nirc`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'nirc')),[`aviz`]: (getObjectProperty(___arguments.context.dataModel, 'newAviz')),[`factura`]: (getObjectProperty(___arguments.context.dataModel, 'newFactura')),[`adresaRidicare`]: (getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),[`client`]: (getObjectProperty(___arguments.context.dataModel, 'newNumeClient')),[`customerAccount`]: (getObjectProperty(___arguments.context.dataModel, 'newCustomerAccount')),[`adresaLivrare`]: [(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),'[',(getObjectProperty(___arguments.context.dataModel, 'newCartier')),']'].join(''),[`plataCash`]: (getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),[`telefon`]: (getObjectProperty(___arguments.context.dataModel, 'newTelefonClient')),[`observatii`]: ['',String('sc. ') + String(getObjectProperty(___arguments.context.dataModel, 'newScara')),String(' et. ') + String(getObjectProperty(___arguments.context.dataModel, 'newEtaj')),String(' ap. ') + String(getObjectProperty(___arguments.context.dataModel, 'newApartament')),'(',(getObjectProperty(___arguments.context.dataModel, 'newDetaliiLivrare')),')'].join(''),[`ramburs`]: (getObjectProperty(___arguments.context.dataModel, 'newPlataCash')) }));
      if ((getObjectProperty(___arguments.context.pageData, 'adresaRidicareUser')) == (getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare'))) {
        (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://cd.superdev.ro/pdf/get-pdf/',(getObjectProperty(___arguments.context.dataModel, 'newAwb')),''].join('')), true, undefined);
      }
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'newPlataCash')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'newPlataOp'))) {
      ___arguments.context.pageData['newDecontat'] = true;
    }
    await setInterval2();
    await Backendless.Messaging.sendEmail((['CMD: ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName')),'/Ridicare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare'))].join('')), new Backendless.Bodyparts({ htmlmessage: (['Comanda:  ',(getObjectProperty(___arguments.context.dataModel, 'newComanda')),'<br>Adresa Ridicare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),'<br>Adresa Livrare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),(getObjectProperty(___arguments.context.dataModel, 'newOptiuneAwb')) ? ['<br>Customer Account: ',(getObjectProperty(___arguments.context.dataModel, 'newCustomerAccount')),'<br>Factura: ',(getObjectProperty(___arguments.context.dataModel, 'newFactura')),'<br>Aviz: ',(getObjectProperty(___arguments.context.dataModel, 'newAviz')),'<br>Nume Client: ',(getObjectProperty(___arguments.context.dataModel, 'newNumeClient')),'',''].join('') : '','','','','','','','','<br> Ramburs: ',(getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),'<br>Telefon Client: ',(getObjectProperty(___arguments.context.dataModel, 'newTelefonClient')),'<br>Observatii: ',(getObjectProperty(___arguments.context.dataModel, 'newDetaliiLivrare')),'<br>Va rugam nu raspundeti la acest email ',''].join('')) }), ensureArray('horea.mihaltan@gmail.com'), undefined);
    if (getObjectProperty(___arguments.context.dataModel, 'newLivrareExtern')) {
    }
    await Backendless.Messaging.publish((getObjectProperty(___arguments.context.appData, 'masterName')), 'Atentie, comanda noua!', new Backendless.PublishOptions({ subtopic: '' }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
    await Backendless.Messaging.publish('comenzi', (String('Atentie,\ncomanda noua de la: ') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName'))), new Backendless.PublishOptions({ subtopic: '' }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
    (function (message) { alert(message) })('Comanda a fost inregistrata cu succes');

  }
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Comenzi', undefined);
}

/**
 * Describe this function...
 */
async function setTimeAndUser() {
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  timeOfset = (new Date());
  timeOfset.setTime((new Date(timeOfset.getTime() + (5400 * 1000))));
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'BORHANCI') {
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2000)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3000)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'CLUJ-NAPOCA SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1000)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2000)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1500)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FAGET 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2500)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'BULGARIA-IRIS 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1500)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'DAMBU ROTUND Z2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1000)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'MANASTUR 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1500)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'MANASTUR 3') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1500)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'cautaStrada')) == 'Câmpului' && (getObjectProperty(___arguments.context.dataModel, 'newNumar')) > 200) {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2000)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'cautaStrada')) == 'Horea') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1200)));
  }
}

/**
 * Describe this function...
 */
async function distanta_time() {
  ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.superdev.ro/maps')).setEncoding('utf8').send(({ [`destinations`]: String(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')) + String((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.dataModel, 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'),[`origins`]: [(getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),' Cluj-Napoca',''].join('') })));
  ___arguments.context.pageData['duration'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'duration')), 'text'));
  ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) + 0);
}

/**
 * Describe this function...
 */
async function NewComandaNoua() {
  await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('comenzi')))).setEncoding('utf8').send(({ [`an`]: (new Date((new Date())).getFullYear()),[`documentIncasare`]: '-',[`livrator`]: 'FARA LIVRATOR',[`timpPreparare`]: (getObjectProperty(___arguments.context.dataModel, 'newTimpPreparare')),[`detaliiAdresa`]: ['',String('sc. ') + String(getObjectProperty(___arguments.context.dataModel, 'newScara')),String(' et. ') + String(getObjectProperty(___arguments.context.dataModel, 'newEtaj')),String(' ap. ') + String(getObjectProperty(___arguments.context.dataModel, 'newApartament')),''].join(''),[`bloc`]: (getObjectProperty(___arguments.context.dataModel, 'newBloc')),[`tarifareLiv`]: (getObjectProperty(___arguments.context.dataModel, 'newTarifare')) > 0 ? (getObjectProperty(___arguments.context.dataModel, 'newTarifareLiv')) : 0,[`brand`]: (getObjectProperty(___arguments.context.dataModel, 'newBrand')),[`livratorDescarcat`]: (getObjectProperty(___arguments.context.pageData, 'newLivratorDescarcat')),[`duration`]: (getObjectProperty(___arguments.context.pageData, 'duration')),[`distance`]: (getObjectProperty(___arguments.context.pageData, 'distance')),[`adresaPoint`]: ({ [`type`]: 'Point',[`coordinates`]: [(getObjectProperty((getObjectProperty((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'adresaGoogle')), 'results'))[0]), 'geometry')), 'location')), 'lng')), (getObjectProperty((getObjectProperty((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'adresaGoogle')), 'results'))[0]), 'geometry')), 'location')), 'lat'))] }),[`cursaInclusa`]: (getObjectProperty(___arguments.context.pageData, 'cursaInclusa')),[`industrie`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'industrie')),[`profil`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'profil')),[`ridicareDefault`]: (getObjectProperty(___arguments.context.dataModel, 'newDefaultRidicare')),[`plataOp`]: (getObjectProperty(___arguments.context.dataModel, 'newPlataOp')),[`dataComanda`]: (getObjectProperty(___arguments.context.dataModel, 'newDataComanda')),[`allText`]: (getObjectProperty(___arguments.context.pageData, 'newAllText')),[`logo`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'logo')),[`optiuneAwb`]: (getObjectProperty(___arguments.context.dataModel, 'newOptiuneAwb')),[`decontat`]: (getObjectProperty(___arguments.context.pageData, 'newDecontat')),[`TipMasina`]: (getObjectProperty(___arguments.context.dataModel, 'newTipMasina')),[`masterClient`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName')),[`masterEmail`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterEmail')),[`adresaLivrare`]: (getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),[`awb`]: (getObjectProperty(___arguments.context.dataModel, 'newAwb')),[`comanda`]: (getObjectProperty(___arguments.context.dataModel, 'newComanda')),[`oraLimita`]: (getObjectProperty(___arguments.context.dataModel, 'newProgramare')),[`status`]: (getObjectProperty(___arguments.context.dataModel, 'newStatus')),[`livrareExtern`]: (getObjectProperty(___arguments.context.dataModel, 'newLivrareExtern')),[`adresaRidicare`]: (getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),[`aviz`]: (getObjectProperty(___arguments.context.dataModel, 'newAviz')),[`cartier`]: (getObjectProperty(___arguments.context.dataModel, 'newCartier')),[`comisionPos`]: (getObjectProperty(___arguments.context.dataModel, 'newComisionPos')),[`customerAccount`]: (getObjectProperty(___arguments.context.dataModel, 'newCustomerAccount')),[`programare`]: (getObjectProperty(___arguments.context.dataModel, 'newProgramare')),[`detaliiLivrare`]: (getObjectProperty(___arguments.context.dataModel, 'newDetaliiLivrare')),[`emailClient`]: (getObjectProperty(___arguments.context.dataModel, 'newEmailClient')),[`factura`]: (getObjectProperty(___arguments.context.dataModel, 'newFactura')),[`incasarePos`]: (getObjectProperty(___arguments.context.dataModel, 'newIncasarePos')),[`numeClient`]: (getObjectProperty(___arguments.context.dataModel, 'newNumeClient')),[`numeUser`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'username')),[`plata_cash`]: (getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),[`valoareComanda`]: (getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),[`seIncaseazaCuPOS`]: (getObjectProperty(___arguments.context.dataModel, 'newSeIncaseazaCuPOS')),[`tarifare`]: (getObjectProperty(___arguments.context.dataModel, 'newTarifare')),[`tarifareIntern`]: (getObjectProperty(___arguments.context.dataModel, 'newTarifareIntern')),[`telefonClient`]: (getObjectProperty(___arguments.context.dataModel, 'newTelefonClient')),[`telefonDisp`]: (getObjectProperty(___arguments.context.dataModel, 'newTipLivrare')) == 'RIDICARE' ? (getObjectProperty(___arguments.context.dataModel, 'newTelefonDispecer')) : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'telefonUser')),[`tipLivrare`]: (getObjectProperty(___arguments.context.dataModel, 'newTipLivrare')),[`user`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'userEmail')) }));
  console.log('Comanda noua OK!');
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));
  await corectieDistanta();
  ___arguments.context.pageData['kmDistance'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) / 1000);
  ___arguments.context.pageData['kmSPLLivrator'] = ((getObjectProperty(___arguments.context.pageData, 'kmDistance')) - 1 >= 0 ? (getObjectProperty(___arguments.context.pageData, 'kmDistance')) - 1 : 0);
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'kmDistance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) >= 0 ? (getObjectProperty(___arguments.context.pageData, 'kmDistance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.dataModel['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.dataModel['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function setInterval2() {
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
}


  try {
    await checkError();

  } catch (error) {
    ___arguments.context.pageData['eroareMaps'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e38f7bd4fb4b108488506bf716aa9bf', true);

  } finally {
    await onSubmit();

  }

  },
  /* handler:onSubmit *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'rol')) == 'DISPECER')

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['destinatar'] = '';
  ___arguments.context.dataModel['newBloc'] = 'BLOC';
  ___arguments.context.dataModel['newTimpPreparare'] = (60000 * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'timpPreparare')));

  },
  /* handler:onBeforeMount */
  /* content */
}));



define('./pages/ComandaNoua/components/26f57cd921e753c77b9e2c2117fac3ad/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ProgramareAtentionare'] = (['','Daca optati sa lansati o comanda PROGRAMATA, trebuie sa tineti cont de urmatoarele aspecte:\n','','1) Nu este permisa programarea comenzii la un termen mai mic de 90min.\n','2) Livrarea se va face intr-un interval de +/- 20min fata de ora programata.\n','','','Va multumim\nCallDelivery Team '].join(''));
  if (___arguments.value == 'PROGRAMATA') {
    (function (message) { alert(message) })((getObjectProperty(___arguments.context.pageData, 'ProgramareAtentionare')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('08b82f46b713ddd9f898331485e3e9da', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('08b82f46b713ddd9f898331485e3e9da', false);
  }

  },
  /* handler:onChange *//* content */
}));

define('./pages/ComandaNoua/components/822b57ed13c1f8355ce8d53b30ce0379/bundle.js', [], () => ({
  /* content */

  


/* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc']) == 'CASA')

  },  
  /* handler:onDisabledStateAssignment *//* content */
}));




define('./pages/ComandaNoua/components/c7aebd879ccd2bffd82701b2796feb5c/bundle.js', [], () => ({
  /* content */

  
/* handler:onBlur */
  async ['onBlur'](___arguments) {
    var timeOfset, currentUser, toTime, fromTime, destinaton, origins;

/**
 * Describe this function...
 */
async function setTimeAndUser() {
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  timeOfset = (new Date());
  timeOfset.setTime((new Date(timeOfset.getTime() + (5400 * 1000))));
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function incarcaConstante() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(currentUser, 'adresaRidicare'));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newEmailRidicare')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEmailRidicare'] = (getObjectProperty(((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'\' AND masterClient = \'',(getObjectProperty(currentUser, 'masterName')),'\'',''].join(''))).setProperties('email').setPageSize(1)))[0]), 'email'));
  }
  ___arguments.context.pageData['newDefaultRidicare'] = (getObjectProperty(((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(getObjectProperty(currentUser, 'adresaRidicare')),'\''].join(''))).setProperties('default').setPageSize(1)))[0]), 'default'));
  ___arguments.context.pageData['newIndustrie'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'industrie'));
  if ((getObjectProperty(___arguments.context.pageData, 'newIndustrie')) != 'FOOD') {
    timeOfset.setHours('21');
    timeOfset.setMinutes('0');
    timeOfset.setSeconds('0');
    timeOfset.setMilliseconds('0');
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'] = (timeOfset.valueOf());
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'newIndustrie'));
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) >= 0 ? (getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BULGARIA-IRIS 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DAMBU ROTUND Z2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 3') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')) == 'Câmpului' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')) > 200) {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  }
}

/**
 * Describe this function...
 */
async function distanta_time3() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'','','',''].join(''));
    destinaton = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')) + String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca');
    origins = ({ 'destinations': undefined,'origins': [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('') });
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
      ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
    }
    console.log(['',origins,'',destinaton].join(''));
    console.log(['',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000,'',(getObjectProperty(___arguments.context.pageData, 'distance')),'','',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'kmSPL'))))].join(''));
  }
}

/**
 * Describe this function...
 */
async function distanta_time() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare'));
    destinaton = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DEZMIR' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'APAHIDA' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    await corectieDistanta();
    console.log(['\nAdresa Ridicare:',origins,'\nAdresa Livrare:',destinaton].join(''));
    console.log(['\nDistanta bruta:',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000,'\nDistanta:',(getObjectProperty(___arguments.context.pageData, 'distance')),'Km','\nKm suplimentari:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'kmSPL'))))].join(''));
  }
}


  await setTimeAndUser();
  await incarcaConstante();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d71bbdeabcf19812643310f8e74209b', true);
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) {
    await distanta_time();
    await tarifareKm();
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareIntern'));
  }

  },
  /* handler:onBlur *//* handler:onFocus */
  async ['onFocus'](___arguments) {
    var timeOfset, currentUser, toTime, fromTime, destinaton, origins;

/**
 * Describe this function...
 */
async function setTimeAndUser() {
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  timeOfset = (new Date());
  timeOfset.setTime((new Date(timeOfset.getTime() + (5400 * 1000))));
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function incarcaConstante() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(currentUser, 'adresaRidicare'));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newEmailRidicare')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEmailRidicare'] = (getObjectProperty(((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'\' AND masterClient = \'',(getObjectProperty(currentUser, 'masterName')),'\'',''].join(''))).setProperties('email').setPageSize(1)))[0]), 'email'));
  }
  ___arguments.context.pageData['newDefaultRidicare'] = (getObjectProperty(((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(getObjectProperty(currentUser, 'adresaRidicare')),'\''].join(''))).setProperties('default').setPageSize(1)))[0]), 'default'));
  ___arguments.context.pageData['newIndustrie'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'industrie'));
  if ((getObjectProperty(___arguments.context.pageData, 'newIndustrie')) != 'FOOD') {
    timeOfset.setHours('21');
    timeOfset.setMinutes('0');
    timeOfset.setSeconds('0');
    timeOfset.setMilliseconds('0');
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'] = (timeOfset.valueOf());
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'newIndustrie'));
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) >= 0 ? (getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BULGARIA-IRIS 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DAMBU ROTUND Z2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 3') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')) == 'Câmpului' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')) > 200) {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  }
}

/**
 * Describe this function...
 */
async function distanta_time3() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'','','',''].join(''));
    destinaton = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')) + String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca');
    origins = ({ 'destinations': undefined,'origins': [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('') });
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.superdev.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
      ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
    }
    console.log(['',origins,'',destinaton].join(''));
    console.log(['',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000,'',(getObjectProperty(___arguments.context.pageData, 'distance')),'','',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'kmSPL'))))].join(''));
  }
}

/**
 * Describe this function...
 */
async function distanta_time() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare'));
    destinaton = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DEZMIR' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'APAHIDA' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.superdev.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    await corectieDistanta();
    console.log(['\nAdresa Ridicare:',origins,'\nAdresa Livrare:',destinaton].join(''));
    console.log(['\nDistanta bruta:',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000,'\nDistanta:',(getObjectProperty(___arguments.context.pageData, 'distance')),'Km','\nKm suplimentari:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'kmSPL'))))].join(''));
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == null) {
    (function (message) { alert(message) })('Selecteaza o strada din lista!');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10d5d008a7face6d361888b14c12a003')));
  }
  await setTimeAndUser();
  await incarcaConstante();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d71bbdeabcf19812643310f8e74209b', true);
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) {
    await distanta_time();
    await tarifareKm();
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareIntern'));
  }

  },
  /* handler:onFocus */
  /* content */
}));

define('./pages/ComandaNoua/components/d84cb55112c23314c3ac20c8112417fa/bundle.js', [], () => ({
  /* content */

  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('adresaridicare/get')))).setEncoding('utf8').send(({ [`selected`]: ({ [`masterClient`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masterName')) }) }))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'label')),[`value`]: (getObjectProperty(item, 'adresa')) });})))

  },
  /* handler:onOptionsAssignment *//* handler:onChange */
  async ['onChange'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEmailRidicare'] = (getObjectProperty(((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('adresaridicare/get')))).setEncoding('utf8').send(({ [`selected`]: ({ [`masterClient`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masterName')),[`adresa`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')) }) })))[0]), 'email'));
  ___arguments.context.pageData['newDefaultRidicare'] = (getObjectProperty(((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('adresaridicare/get')))).setEncoding('utf8').send(({ [`selected`]: ({ [`adresa`]: ___arguments.value }) })))[0]), 'default'));

  },
  /* handler:onChange */
/* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}));

define('./pages/ComandaNoua/components/80eca69f2334e502715faeb27781ad9d/bundle.js', [], () => ({
  /* content */

  
/* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newPlataCard')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataCard'] = 0;
  }

  },
  /* handler:onBlur *//* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newPlataOp'))

  },
  /* handler:onDisabledStateAssignment *//* handler:onFocus */
  ['onFocus'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', false);
  ___arguments.context.appData['paginaCurenta'] = 'plata cash(comanda noua)';

  },
  /* handler:onFocus */
  /* content */
}));

define('./pages/ComandaNoua/components/5fd1a311c91d3ce458fef4aa32f4561c/bundle.js', [], () => ({
  /* content */

  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataOp'])

  },  
/* handler:onDisabledStateAssignment *//* content */
}));

define('./pages/ComandaNoua/components/54e331127769e15111770df57071384f/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc']) == 'CASA')

  },  
  /* handler:onDisabledStateAssignment *//* content */
}));

define('./pages/ComandaNoua/components/b5374e59902b4ba89e8bdf76f21e5ab9/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc']) == 'CASA')

  },  
  /* handler:onDisabledStateAssignment *//* content */
}));

define('./pages/ComandaNoua/components/3d71bbdeabcf19812643310f8e74209b/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (!(___arguments.context.pageData['destinatarExistent']) || (___arguments.context.pageData['altaAdresa']))

  },  
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNoua/components/592fd7cd40fcc65678467b9c4f6c8c48/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  ['onChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', false);
  if (___arguments.value) {
    ___arguments.context.pageData['newDecontat'] = true;
    ___arguments.context.pageData['newLivratorDescarcat'] = true;
  } else {
    ___arguments.context.pageData['newDecontat'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataCash'] = 0;
  ___arguments.context.appData['paginaCurenta'] = 'plata op(comanda noua)';

  },
  /* handler:onChange *//* content */
}));

define('./pages/ComandaNoua/components/6dd100bf23d6cfbc8a44bffff2b8121f/bundle.js', [], () => ({
  /* content */

  

/* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (['',(new Date((new Date())).getDate()) < 10 ? String('0') + String(new Date((new Date())).getDate()) : (new Date((new Date())).getDate()),'.',(new Date((new Date())).getMonth()) + 1 < 10 ? String('0') + String((new Date((new Date())).getMonth()) + 1) : (new Date((new Date())).getMonth()) + 1,'.',(new Date((new Date())).getFullYear()) < 10 ? String('0') + String(new Date((new Date())).getFullYear()) : (new Date((new Date())).getFullYear()),'','','',''].join(''))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/ComandaNoua/components/3789060b203b212d25a1d4eb3eb19062/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, destinaton, origins;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function onChange3() {
  if (___arguments.value.length > 9) {
    ___arguments.context.pageData['destinatar'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'destinatarLocal')), async (item) => {


     return ((getObjectProperty(item, 'telefon')) == ___arguments.value);
    }));
    console.log((getObjectProperty(___arguments.context.pageData, 'destinatar')).length);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bedee28d86e292249c57a6782cb84a21', (getObjectProperty(___arguments.context.pageData, 'destinatar')));
    if ((getObjectProperty(___arguments.context.pageData, 'destinatar')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'cartier')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newZona'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'zona'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'numar')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['destinatarBanat'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'destinatarBanat'));
      console.log(['strada: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')),'\nCartier: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'cartier')),'','','','',''].join(''));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'bloc')) == '1' ? 'BLOC' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'bloc')));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newScara'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'scara'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEtaj'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'etaj'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAnexaNumar'] = '';
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newApartament'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'apartament'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),' Cluj-Napoca'].join(''));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b94b968ef4dddba6cf0f2b77deb17397', true);
      ___arguments.context.pageData['destinatarExistent'] = true;
      if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) {
        if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
          await distanta_time();
          await tarifareKm();
        } else {
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 1) {
            if ((getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) + (getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0) {
              ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 0;
            } else {
              ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_baza'));
            }
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 2) {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z2'));
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 3) {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z3'));
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 'extra') {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 60;
          }
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE') {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 39;
          }
        }
      } else {
        ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareIntern'));
      }
    }
    console.log(String('legth of destinatar: ') + String((getObjectProperty(___arguments.context.pageData, 'destinatar')).length));
  }
  await cursaInclusa();
}

/**
 * Describe this function...
 */
async function distanta_time() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare'));
    destinaton = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    await corectieDistanta();
  }
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BULGARIA-IRIS 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DAMBU ROTUND Z2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 3') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')) == 'Câmpului' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')) > 200) {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  }
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) >= 0 ? (getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function cursaInclusa() {
  if ((getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')) == 0) {
    ___arguments.context.pageData['cursaInclusa'] = 'ABONAMENT';
  } else if ((getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) > 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')) == 0) {
    ___arguments.context.pageData['cursaInclusa'] = 'FT';
  }
}

  },
  /* handler:onChange */

/* handler:onFocus */async ['onFocus'](___arguments) {
    var destinaton, origins;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function distanta_time() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare'));
    destinaton = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    await corectieDistanta();
  }
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BULGARIA-IRIS 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DAMBU ROTUND Z2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 3') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')) == 'Câmpului' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')) > 200) {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  }
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) >= 0 ? (getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function cursaInclusa() {
  if ((getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')) == 0) {
    ___arguments.context.pageData['cursaInclusa'] = 'ABONAMENT';
  } else if ((getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) > 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')) == 0) {
    ___arguments.context.pageData['cursaInclusa'] = 'FT';
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', true);

  },
  /* handler:onFocus */
  /* content */
}));

define('./pages/ComandaNoua/components/10d5d008a7face6d361888b14c12a003/bundle.js', [], () => ({
  /* content */

  


/* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function onChange() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11dc147ae458c2c339766691e01f246a', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11dc147ae458c2c339766691e01f246a', (await Backendless.Data.of('straziCluj').find(Backendless.DataQueryBuilder.create().setWhereClause((['STRADA LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')),'%\''].join(''))).setSortBy('STRADA').setPageSize(5))));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['BDStrazi'] = (await Backendless.Data.of('straziCluj').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['STRADA LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')),'%\''].join('')))));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['textStrada'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'BDStrazi')) > 0 ? 'Selecteaza o strada de mai jos!' : String('Aceasta strada nu exista in baza de date.') + String(''));
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function onChange2() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11dc147ae458c2c339766691e01f246a', true);
  if (getValueLength(___arguments.value) > 1) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['strada'] = (getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('strazicluj/search')))).setEncoding('utf8').send(({ [`selected`]: ({ [`STRADA`]: ___arguments.value }),[`limit`]: 10 }))), 'docs'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11dc147ae458c2c339766691e01f246a', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'strada')));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['BDStrazi'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'strada')).length);
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['textStrada'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'BDStrazi')) > 0 ? 'Selecteaza o strada de mai jos!' : String('Aceasta strada nu exista in baza de date.') + String(''));
  }
}


  await onChange2();

  },
  /* handler:onChange */



/* handler:onFocus */
  onFocus(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', false);
  ___arguments.context.appData['paginaCurenta'] = 'cauta strada(comanda noua)';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = null;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = null;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['BDStrazi'] = 0;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAnexaNumar'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newScara'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEtaj'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newApartament'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa7b7278efa4ee82ec1bb8126dac568d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b94b968ef4dddba6cf0f2b77deb17397', false);
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['TextStrada'] = (String('Aceasta strada nu exista in baza de date.') + String('\nTe rog sa introduci o strada corecta!!!!'));

  },
  /* handler:onFocus */
  /* content */
}));




define('./pages/ComandaNoua/components/4ac28c0e9fda7fe49862b824fc5c0aff/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function onClick() {
  ___arguments.context.pageData['stradaSelectata'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'STRADA'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'CARTIER'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'seLivreaza')) == false && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newOptiuneAwb')) == false) {
    (function (message) { alert(message) })((['Din pacate, aceasta adresa se afla in afara ariei noastre de acoperire: strada ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'STRADA')),'(',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'CARTIER')),')'].join('')));
    ___arguments.context.pageData['stradaSelectata'] = null;
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = null;
  }
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'CARTIER'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'STRADA'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'STRADA'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newZona'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'ZONA'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11dc147ae458c2c339766691e01f246a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa7b7278efa4ee82ec1bb8126dac568d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b94b968ef4dddba6cf0f2b77deb17397', true);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'LIVRARE') {
    if ((getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) + (getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 0;
    } else {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_baza'));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 2) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z2'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 3) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z3'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 'extra') {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 60;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE') {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 39;
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName')) == 'ECCO' && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')) == 'VIVO' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')) == 'VIVO')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 23.5;
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName')) == 'PANDORA' && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')) == 'VIVO' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')) == 'VIVO PND')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 39;
  }
  console.log(String('cursa inclusa: ') + String(getObjectProperty(___arguments.context.pageData, 'cursaInclusa')));
}

/**
 * Describe this function...
 */
async function cursaInclusa() {
  if ((getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')) == 0) {
    ___arguments.context.pageData['cursaInclusa'] = 'ABONAMENT';
  } else if ((getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) > 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')) == 0) {
    ___arguments.context.pageData['cursaInclusa'] = 'FT';
  }
}


  await onClick();

  },
  /* handler:onClick *//* content */
}));

define('./pages/ComandaNoua/components/97cd049b1255fdb7af9c95149088a364/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getDestinatar() {
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = (getObjectProperty(___arguments.context.dataModel, 'cartier'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = (getObjectProperty(___arguments.context.dataModel, 'strada'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar'] = (getObjectProperty(___arguments.context.dataModel, 'numar'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newScara'] = (getObjectProperty(___arguments.context.dataModel, 'scara'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEtaj'] = (getObjectProperty(___arguments.context.dataModel, 'etaj'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newApartament'] = (getObjectProperty(___arguments.context.dataModel, 'apartament'));
}


  await getDestinatar();

  return (['Cartier: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),'\nStrada: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' Nr: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'\nSc: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newScara')),' Et: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newEtaj')),' Ap: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newApartament'))].join(''))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/ComandaNoua/components/3ab327259a4af2c50ab4d6c879d6fee1/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'destinatar')).length > 0 && !(getObjectProperty(___arguments.context.pageData, 'altaAdresa')))

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNoua/components/7837663e5d9ffa33f47ebc01eb44ebeb/bundle.js', [], () => ({
  /* content */

  
/* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['paginaCurenta'] = 'alta adresa(comanda noua)';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ab327259a4af2c50ab4d6c879d6fee1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1867365d6c873a4c878a73ff869cbff', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d71bbdeabcf19812643310f8e74209b', true);
  ___arguments.context.pageData['altaAdresa'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = null;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = null;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAnexaNumar'] = ' ';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc'] = 'BLOC';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newScara'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEtaj'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newApartament'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b94b968ef4dddba6cf0f2b77deb17397', false);

  },
  /* handler:onChange */
/* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'altaAdresa'))

  },
  /* handler:onCheckedStateAssignment *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'destinatarBanat')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}));

define('./pages/ComandaNoua/components/189a1e3ff2f1a0537819c06e2da44587/bundle.js', [], () => ({
  /* content */

  


/* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newOptiuneAwb')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'LIVRARE')

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNoua/components/685876ba86cb09ec29d4bf876fc9a83e/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Comanda se ridica de la adresa:\n',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'\nsi se livreaza la adresa: ','\nStrada: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' nr: ',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAnexaNumar')),'\nCartier: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),'\nsc: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newScara')),' et ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newEtaj')),' ap ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newApartament')),'\nValoare ramburs: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newPlataCash')) > 0 ? String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newPlataCash')) + String(' LEI ') : 'COMANDA PLATITA','\n Cost transport: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')),'lei\n','','Distanta: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'distance')))),'km\nE OK?'].join(''))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/ComandaNoua/components/5a5705d3819284e48f7bebd8e8d73b8c/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'LivratorActiv')) == 0)

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNoua/components/214f7e31d2dc9e4e830cfc5862e4685e/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStatus')) == 'PROGRAMATA') && (getObjectProperty(___arguments.context.pageData, 'livratorActivExtern')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern'))) {
    return false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStatus')) == 'PROGRAMATA') {
    return true;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNoua/components/93365cad856d513bee23ef21b57ac111/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'RIDICARE') {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = '';
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataCash'] = 0;
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataCard'] = 0;
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 39;
    ___arguments.context.pageData['newDefaultRidicare'] = false;
  } else if (___arguments.value == 'LIVRARE') {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = '';
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataOp'] = false;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 1) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty(((getObjectProperty(___arguments.context.appData, 'client'))[0]), 'tarifare_baza'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 2) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty(((getObjectProperty(___arguments.context.appData, 'client'))[0]), 'tarifare_Z2'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 3) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty(((getObjectProperty(___arguments.context.appData, 'client'))[0]), 'tarifare_Z3'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 'extra') {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 60;
    }
  }

  },
  /* handler:onChange */
/* content */
}));

define('./pages/ComandaNoua/components/bb7b39973427050e64975e0ea8cc1981/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return true

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNoua/components/454390c205bc9a9bd542c06ad696ad68/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      if (___arguments.value == true) {
    await ( async function (message) { alert(message) })('Sigur vrei sa emiti AWB? Daca nu vrei awb debifeaza optiunea awb!');
  } else if (___arguments.value == false) {
    await ( async function (message) { alert(message) })('Sigur NU vrei sa emiti AWB? Daca vrei awb optiunea awb trebuie sa fie bifata!');
  }

  },
  /* handler:onChange *//* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'awb')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}));

define('./pages/ComandaNoua/components/c23363537faa998c5409b04734794a65/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada']),' ',String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar']) + String(___arguments.value),' Cluj-Napoca'].join(''));

  },  
/* handler:onChange *//* content */
}));

define('./pages/ComandaNoua/components/57fc5783d4bfa3e65618a7547d890969/bundle.js', [], () => ({
  /* content */

  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newDefaultRidicare'] = (getObjectProperty(___arguments.context.pageData, 'newDefaultRidicare'));

  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newDefaultRidicare'))

  },
  /* handler:onCheckedStateAssignment */

/* content */
}));

define('./pages/ComandaNoua/components/ce6d6b7b6b19c69f6437341c05ee6498/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Comenzi', undefined);
  ___arguments.context.appData['paginaCurenta'] = 'renuntaLaComanda';

  },
  /* handler:onClick *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'submit')) == true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}));

define('./pages/ComandaNoua/components/5d07b88655e83d75cf0f4512b616d24e/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  ___arguments.context.getComponentDataStoreByUid('19cc20492d21ccd92e5333a9d2072c64')['paginaCurenta'] = (getObjectProperty(___arguments.context.appData, 'paginaCurenta'));
  stopSetTimeout('setCurrentPage');

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/ComandaNoua/components/050a363d603269da893ff8914c860de2/bundle.js', [], () => ({
  /* content */

  
/* handler:onChange */
  async ['onChange'](___arguments) {
    var destinaton, origins;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function distanta_time() {
  if (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'','','',''].join(''));
    destinaton = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    await corectieDistanta();
    console.log(['\nAdresa Ridicare:',origins,'\nAdresa Livrare:',destinaton].join(''));
    console.log(['\nDistanta bruta:',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000,'\nDistanta:',(getObjectProperty(___arguments.context.pageData, 'distance')),'Km','\nKm suplimentari:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'kmSPL'))))].join(''));
  }
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKm'));
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmLimita')) >= 0 ? (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmLimita'))))) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 4)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 6)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 4)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
  }
}


  if (___arguments.value) {
    (function (message) { alert(message) })('Ai ales ca livrarea sa se faca cu un livrator EXTERN!');
    await distanta_time();
    await tarifareKm();
  } else {
    (function (message) { alert(message) })('Ai ales ca livrarea sa se faca cu un livrator PROPRIU!');
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareIntern'))));
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) ? 'Livrator Extern' : 'Livrator Propriu')

  },
  /* handler:onLabelAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'livrareMixta')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}));

define('./pages/ComandaNoua/components/33a9480e082ed1571181cdf4a94939c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) ? String('Livrarea se face cu:\n') + String('!!! LIVRATOR EXTERN !!!') : String('Livrarea se face cu:\n') + String('!!! LIVRATOR PROPRIU !!!'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/e2bd498eab84fcb81086afbbaec3a164/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('brand/get')))).setEncoding('utf8').send(({ [`selected`]: ({ [`masterClient`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masterName')) }) }))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'brand')),[`value`]: (getObjectProperty(item, 'brand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBrand'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ComandaNoua/components/7e38f7bd4fb4b108488506bf716aa9bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'eroareMaps'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/392c4ef888d691965e010f5ab17a27c1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Din pacate, din cauza unor probleme tehnice legate de server, nu se pot lansa comenzi in acest moment. Echipa tehnica lucreaza in acest moment pentru remedierea problemei.Va rugam reveniti mai tarziu. Pentru urgente va rugam sa luati legatura cu noi la 0752621501 sau sa puneti o copie a comenzii pe grupul de WhatsApp.') + String('\nMultumim pentru intelegere.'))

  },  
  /* handler:onContentAssignment */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (message) { alert(message) })('Din pacate, din cauza unor probleme tehnice legate de server, nu se pot lansa comenzi in acest moment. Echipa tehnica lucreaza in acest moment pentru remedierea problemei.Va rugam reveniti mai tarziu. Pentru urgente va rugam sa luati legatura cu noi la 0752621501 sau sa puneti o copie a comenzii pe grupul de WhatsApp.');

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/ComandaNoua/components/3ed7e258a629ee1a39bec8a8b7dd925a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newLogo'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'logo'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00a5ebdb1bfa53dd1c21d92a187d9215', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cae11318939f537e4525e3c6242d3085', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ed7e258a629ee1a39bec8a8b7dd925a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/cae11318939f537e4525e3c6242d3085/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00a5ebdb1bfa53dd1c21d92a187d9215', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cae11318939f537e4525e3c6242d3085', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ed7e258a629ee1a39bec8a8b7dd925a', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/58655bbf374e436775f6cf282f8c492d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var timeOfset, brand, client, toTime, fromTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function onMount() {
  ___arguments.context.pageData['client'] = (getObjectProperty(___arguments.context.appData, 'client'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBrand'] = brand;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newOptiuneAwb'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'awb'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newLivrareExtern'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'defaultExtern'));
  ___arguments.context.pageData['newDefaultRidicare'] = (getObjectProperty(___arguments.context.appData, 'newDefaultRidicare'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'adresaRidicare'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'] = (timeOfset.valueOf());
}

/**
 * Describe this function...
 */
async function setTimeAndUser() {
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  timeOfset = (new Date());
  timeOfset.setTime((new Date(timeOfset.getTime() + (5400 * 1000))));
  client = (getObjectProperty(___arguments.context.appData, 'client'));
  brand = (getObjectProperty(___arguments.context.appData, 'newBrand'));
}

/**
 * Describe this function...
 */
async function incarcaConstante() {
  await setTimeAndUser();
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.appData, 'adresaRidicareUser'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newLivrareExtern'] = (getObjectProperty(client, 'defaultExtern'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEmailRidicare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'userEmail'));
  ___arguments.context.pageData['adresaRidicareUser'] = (getObjectProperty(___arguments.context.appData, 'adresaRidicareUser'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newComanda'] = (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumarComanda')));
  if ((getObjectProperty(client, 'industrie')) != 'FOOD') {
    timeOfset.setHours('21');
    timeOfset.setMinutes('0');
    timeOfset.setSeconds('0');
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'] = (timeOfset.valueOf());
  }
}


  await setTimeAndUser();
  await onMount();
  await incarcaConstante();

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/ComandaNoua/components/b94b968ef4dddba6cf0f2b77deb17397/bundle.js', [], () => ({
  /* content */

  



/* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['textSubmit'] = 'Please wait...';
  (function (message) { alert(message) })('Ai lansat comanda');
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['submit'] = true;
  ___arguments.context.appData['paginaCurenta'] = 'submit comanda noua';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'destinatarBanat')) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')) == null) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == null) && !((getObjectProperty(___arguments.context.pageData, 'submit')) == true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'textSubmit'))

  },
  /* handler:onLabelAssignment */
  /* content */
}));

define('./pages/ComandaNoua/components/08b82f46b713ddd9f898331485e3e9da/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var timpSetat, timeOfset;


  timpSetat = ___arguments.value - ((new Date()).valueOf());
  console.log(timpSetat);
  if (timpSetat < 5400000) {
    (function (message) { alert(message) })((['ATENTIE!!!\n','Nu este permisa programarea\n','comenzii cu un termen sub 90min!','',''].join('')));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'] = (((new Date()).valueOf()) + 5400000);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ComandaNoua/components/41af4cdab804ba7172df9cbcbb756ade/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '1';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')) + String('1'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/6ef2eff4a177f282e16b225f1ed22e73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '2';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('2'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/4947eae2412576a5c3b34bb2f2e6d995/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '3';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('3'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/17c165b4ab6b2658ad9d29d17354bd7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '4';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('4'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/5ff6f757bbd8ec4c13f8efe6e3395694/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '5';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('5'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/f74df7c2f81810bd17f1c1e7dcf76515/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '6';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('6'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/89caa53445af3881a4a5bcb79c313a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '7';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('7'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/9f66b64e0c76839ea4ced7a9d1c91834/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '8';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('8'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/6bc36c3d375a7e6916bb77c242cec5af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '9';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('9'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/2159226cb12f434dd59690b55224c2ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '0';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('0'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/43fdd191f1f1f62ff7a6a8adb3922a33/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/e1cc1daf951bb2b32602205d381dc0fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var destinaton, origins;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BULGARIA-IRIS 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DAMBU ROTUND Z2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 3') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')) == 'Câmpului' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')) > 200) {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  }
}

/**
 * Describe this function...
 */
async function cursaInclusa() {
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) >= 0 ? (getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function onOK2() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')).length > 9) {
    ___arguments.context.pageData['destinatar'] = (await Backendless.Data.of('Destinatar').find(Backendless.DataQueryBuilder.create().setWhereClause((['telefon = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')),'\''].join(''))).setProperties('telefon').setPageSize(1)));
    if ((await Backendless.Data.of('Destinatar').find(Backendless.DataQueryBuilder.create().setWhereClause((['telefon = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')),'\''].join(''))).setProperties('telefon').setPageSize(1))).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'cartier')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newZona'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'zona'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'numar')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['destinatarBanat'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'destinatarBanat'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'bloc')) == '1' ? 'BLOC' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'bloc')));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newScara'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'scara'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEtaj'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'etaj'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAnexaNumar'] = '';
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newApartament'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'apartament'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),' Cluj-Napoca'].join(''));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b94b968ef4dddba6cf0f2b77deb17397', true);
      ___arguments.context.pageData['destinatarExistent'] = true;
      if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) {
        if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
          await distanta_time();
          await tarifareKm();
        } else {
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 1) {
            if ((getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) + (getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0) {
              ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 0;
            } else {
              ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_baza'));
            }
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 2) {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z2'));
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 3) {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z3'));
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 'extra') {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 60;
          }
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE') {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 39;
          }
        }
      } else {
        ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareIntern'));
      }
    }
  }
  await cursaInclusa();
}

/**
 * Describe this function...
 */
async function onOK() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ab327259a4af2c50ab4d6c879d6fee1', (getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.testenv.ro/api/destinatar/search')).setEncoding('utf8').send(({ 'selected': ({ 'telefon': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')) }) }))), 'docs')));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')).length > 9) {
    ___arguments.context.pageData['destinatar'] = ((getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.testenv.ro/api/destinatar/search')).setEncoding('utf8').send(({ 'selected': ({ 'telefon': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')) }) }))), 'docs'))[0]);
    console.log(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada'));
    if ((getObjectProperty(___arguments.context.pageData, 'destinatar')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'cartier')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newZona'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'zona'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'numar')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['destinatarBanat'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'destinatarBanat'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'bloc')) == '1' ? 'BLOC' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'bloc')));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newScara'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'scara'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEtaj'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'etaj'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAnexaNumar'] = '';
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newApartament'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'apartament'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),' Cluj-Napoca'].join(''));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b94b968ef4dddba6cf0f2b77deb17397', true);
      ___arguments.context.pageData['destinatarExistent'] = true;
      if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) {
        if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
          await distanta_time();
          await tarifareKm();
        } else {
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 1) {
            if ((getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) + (getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0) {
              ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 0;
            } else {
              ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_baza'));
            }
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 2) {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z2'));
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 3) {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z3'));
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 'extra') {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 60;
          }
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE') {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 39;
          }
        }
      } else {
        ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareIntern'));
      }
    }
  }
  await cursaInclusa();
}

/**
 * Describe this function...
 */
async function distanta_time() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare'));
    destinaton = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    await corectieDistanta();
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/938d55b190428c188d21db2cdf4dcb3c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ComandaNoua/components/a60a82adddfefda1c635aa2e3d1931fc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Selecteaza un timp estimat de preparare.\n','Daca nu selectezi altceva, timpul de preparare va fi setat la:<b> ',(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTimpPreparare']) / 60000,':00 min'].join(''))

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (((___arguments.context.appData['client'])['industrie']) == 'FOOD')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/d205da3f2e6276e1c4a146ac240e55cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (((___arguments.context.appData['client'])['industrie']) == 'FOOD')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/66f527b544ecadeacf5af6ccdad9d84e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'dezactivatTemporar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/1ea60abc1e1a13b141cf63893eb7f20d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'incasarePOS')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newPlataOp')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataOp'])

  },  
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/2cfe7dc1b39d1cf8c1923fc19d27fd64/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Ne pare rau dar\n acest client este inregistrat in sistem cu incidente la livrare.\nIn consecinta, ne rezervam dreptul de a nu livra comenzi acestui destinatar.\n\nVa multumim pentru intelegere.(CallDelivery Team)\n[',(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada']),']'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/ae67e4d2f85d1c24f61a2eea3ad9679d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'destinatarBanat'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/32c68ff2a27d235cff06a48c6b1b11b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Comenzi', null);
  ___arguments.context.appData['paginaCurenta'] = 'ClientBanat';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNoua/components/584feb15fad56731a33ab1d14adfe9db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newOptiuneAwb')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'LIVRARE')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/193b5e2beedcb264adc85fd4eb746667/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newOptiuneAwb')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'LIVRARE')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/cfd79664f40bbe9d7ea85bad924bd5ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newOptiuneAwb')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'LIVRARE')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/a033e0d6818e6d2590756a8e8bcdccb7/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newOptiuneAwb')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'LIVRARE')

  },
  /* handler:onDisplayAssignment */
  /* content */
}));

define('./pages/ComandaNoua/components/0099f3abfe3ea396c63a29f9137fd528/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/9995632f8481827c45ba174b383caf2e/bundle.js', [], () => ({
  /* content */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = '';

  },
  /* handler:onFocus */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/1ae4af26e615556c086f3af636a76cbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Comanda va fi tarifata cu: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')),'LEI'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/ComandaNoua/components/aeb67d460bb595d9b5cb8a86d63b8a5b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['textSubmit'] = 'OK, Salveaza!';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/ComandaNouaSig/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    /**
 * Describe this function...
 */
async function testMaps() {
  ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': ['Aleea Rasinari 4 Cluj-Napoca','',''].join(''),'origins': ['Aleea Rasinari 2 Cluj-Napoca','',''].join('') })));
  ___arguments.context.pageData['testGoogle'] = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['','https://maps.googleapis.com/maps/api/geocode/json?address=','Aleea Rasinari 2 Cluj-Napoca','','&key=AIzaSyDC4mbqOev3A2j8-gaFSZ3GZ_2cQXAORBw&='].join('')))).setEncoding('utf8').send());
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function user() {
}


  try {
    await testMaps();

  } catch (error) {
    ___arguments.context.pageData['eroareMaps'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e38f7bd4fb4b108488506bf716aa9bf', true);

  } finally {
    try {
      ___arguments.context.pageData['testAwb'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'awb'));

    } catch (error) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Comenzi', undefined);

    } finally {
      await user();
      if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'username')) == null) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14654282be67c4ca9d3abddded61c584', false);
        (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://calldelivery.store4.ro', false, undefined);
      } else {
        await user();
        ___arguments.context.pageData['userEmail'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'userEmail'));
        await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://cd.testenv.ro/api/dispecer/') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'dispecerActiv')), '_id'))))).setEncoding('utf8').send(({ 'paginaCurenta': 'comanda noua' }));
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bedee28d86e292249c57a6782cb84a21', (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.testenv.ro/api/dispecer/get')).setEncoding('utf8').send(({ 'selected': ({ '_id': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'dispecerActiv')), '_id')) }) }))));
      }

    }

  }
  ___arguments.context.pageData['destinatarLocal'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.testenv.ro/api/destinatar/get')).setEncoding('utf8').send());

  ;(function() {
    const callback = async () => {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Comenzi', undefined);

    };

    const timerId = 'intarzierePeComandaNoua';
    const timerDelay = 300000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onEnter */
/* handler:onLeave */
  onLeave(___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}


  getRTSubscriptions().remove('createLivratorActivExtern');;
  getRTSubscriptions().remove('UpdateLivratorActiv');;
  stopSetTimeout('intarzierePeComandaNoua');

  },  
  /* handler:onLeave *//* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'DeliveryPro V2.0'

  },  
/* handler:onTitleAssignment *//* handler:onScroll */
  onScroll(___arguments) {
      ___arguments.context.pageData['paginaCurenta'] = 'comanda noua';

  },
  /* handler:onScroll */
  /* content */
}));

define('./pages/ComandaNouaSig/components/222914427ab8caf9ccb26d9331f9ea99/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var currentLocation, message, appUsername;


  appUsername = ((await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))['username']);
  currentLocation = (___arguments.context.pageData['currentLocation']);
  message = (___arguments.context.dataModel['message']);
  if (message) {
    ___arguments.context.dataModel['message'] = '';
    await Backendless.Messaging.publish('default', ({ 'username': appUsername,'message': message,'lat': (currentLocation['lat']),'lng': (currentLocation['lng']) }), new Backendless.PublishOptions({ subtopic: '' }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
  }

  },  
/* handler:onSubmit *//* content */
}));

define('./pages/ComandaNouaSig/components/db8e872ab8c674ae309410e4a91151d6/bundle.js', [], () => ({
  /* content */

  

/* content */
}));




define('./pages/ComandaNouaSig/components/3aed9c98df6f4d3f76466c26cdbbefd4/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'eroareMaps')))

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/bcd52ba2f5e422b6147ef62387ac8ead/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.appData['paginaCurenta'] = 'renuntaLaComanda';
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Comenzi', null);

  },  
  /* handler:onClick *//* content */
}));

define('./pages/ComandaNouaSig/components/14654282be67c4ca9d3abddded61c584/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var item, toTime, fromTime, destinatarNou, timeOfset, currentUser, comandaNoua;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function tarifareLivrator() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.dataModel['newTarifareLiv'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((8 + (getObjectProperty(___arguments.context.pageData, 'kmSPLLivrator')) * 1.5)));
  } else {
    ___arguments.context.dataModel['newTarifareLiv'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.dataModel, 'newTarifare')) * 0.69)));
  }
}

/**
 * Describe this function...
 */
async function checkError() {
  await testMaps();
}

/**
 * Describe this function...
 */
async function testMaps() {
  ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': 'Aleea Rasinari 4 Cluj-Napoca','origins': 'Aleea Rasinari 2 Cluj-Napoca' })));
  ___arguments.context.pageData['testGoogle'] = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['','https://maps.googleapis.com/maps/api/geocode/json?address=','Aleea Rasinari 2 Cluj-Napoca','','&key=AIzaSyDC4mbqOev3A2j8-gaFSZ3GZ_2cQXAORBw&='].join('')))).setEncoding('utf8').send());
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function onSubmit() {
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Comenzi', undefined);
  await setTimeAndUser();
  ___arguments.context.dataModel['newNumarComanda'] = (['[',(getObjectProperty(___arguments.context.appData, 'comenziActive')).length + 1,'#',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masterID')),']',''].join(''));
  ___arguments.context.dataModel['newComanda'] = (getObjectProperty(___arguments.context.dataModel, 'newNumarComanda'));
  ___arguments.context.pageData['newNumeClient'] = '';
  ___arguments.context.dataModel['newAwb'] = (await Backendless.Counters.addAndGet('awb', 1));
  ___arguments.context.dataModel['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.dataModel, 'newStrada')),' ',(getObjectProperty(___arguments.context.dataModel, 'newNumar')),!((getObjectProperty(___arguments.context.dataModel, 'newAnexaNumar')) == '') || !!(getObjectProperty(___arguments.context.dataModel, 'newAnexaNumar')).length ? [' - ',(getObjectProperty(___arguments.context.dataModel, 'newAnexaNumar')),' '].join('') : ' ',''].join(''));
  ___arguments.context.pageData['adresaGoogle'] = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://maps.googleapis.com/maps/api/geocode/json?address=',(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),(getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.dataModel, 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca','&key=AIzaSyDC4mbqOev3A2j8-gaFSZ3GZ_2cQXAORBw&='].join('')))).setEncoding('utf8').send());
  try {
    await distanta_time();
    await tarifareKm();

  } catch (error) {
    (function (message) { alert(message) })('Comanda nu a fost inregistrata. NU ati selectat strada din lista dupa ce ati cautat strada. Va rugam reintroduceti comanda cu mai multa atentie.');

  } finally {
    await distanta_time();
    await tarifareKm();
    await tarifareLivrator();
    ___arguments.context.appData['LivratorActiv'] = (await Backendless.Data.of('LivratorActiv').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['tipLivrator = \'EXTERN\' AND activ=true',' AND created >=',(fromTime.valueOf()),' AND created <=',(toTime.valueOf()),'','','','',''].join('')))));
    await setInterval2();
    await NewComandaNoua();
    if (!((getObjectProperty(___arguments.context.appData, 'LivratorActiv')) > 0)) {
      (function (message) { alert(message) })('Momentan nu avem sau nu mai avem livratori Activi. Comanda este inregistrata dar este posibil ca preluarea sa se faca cu intarziere sau chiar sa nu mai poata fi preluata de un livrator.');
    }
    if (getObjectProperty(___arguments.context.dataModel, 'newOptiuneAwb')) {
      await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/pdf/pdf-email')).setEncoding('utf8').send(({ 'to': ['','',(getObjectProperty(___arguments.context.dataModel, 'newEmailRidicare'))].join(''),'textBody': ['Comanda:  ',[(getObjectProperty(___arguments.context.dataModel, 'newComanda')),'/',[(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),' [',(getObjectProperty(___arguments.context.dataModel, 'newCartier')),']'].join(''),'','','','',''].join(''),'Adresa Ridicare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),'Adresa Livrare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),'Ramburs: ',(getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),'Telefon Client: ',(getObjectProperty(___arguments.context.dataModel, 'newTelefonClient')),'Observatii: ',['',String('sc. ') + String(getObjectProperty(___arguments.context.dataModel, 'newScara')),String(' et. ') + String(getObjectProperty(___arguments.context.dataModel, 'newEtaj')),String(' ap. ') + String(getObjectProperty(___arguments.context.dataModel, 'newApartament')),'(',(getObjectProperty(___arguments.context.dataModel, 'newDetaliiLivrare')),')'].join(''),'',['Acceseaza urmatorul link pentru a vizualiza/printa AWB-ul <br> <a href="','https://calldelivery.ro/pdf/get-pdf/',(getObjectProperty(___arguments.context.dataModel, 'newAwb')),'">AWB</a>',(getObjectProperty(___arguments.context.dataModel, 'newAwb')),'</a>'].join(''),' Va multumim ca folositi DeliveryPro App (CallDelivery Team. Tel: 0752621501)) ','Va rugam nu dati replay la acest email '].join(''),'htmlBody': ['Comanda:  ',(getObjectProperty(___arguments.context.dataModel, 'newComanda')),'<br>Adresa Ridicare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),'<br>Adresa Livrare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),'<br> Ramburs: ',(getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),'<br>Telefon Client: ',(getObjectProperty(___arguments.context.dataModel, 'newTelefonClient')),'<br>Observatii: ',(getObjectProperty(___arguments.context.dataModel, 'newDetaliiLivrare')),'',['<br><b>Acceseaza urmatorul link pentru a vizualiza/printa AWB-ul <br> ','<a href="https://calldelivery.ro/pdf/get-pdf/',(getObjectProperty(___arguments.context.dataModel, 'newAwb')),'">AWB-',(getObjectProperty(___arguments.context.dataModel, 'newAwb')),'</a></b>'].join(''),'<br>Va multumim ca folositi DeliveryPro App (CallDelivery Team. Tel: 0752621501)) ','<br>Va rugam nu raspundeti la acest email '].join(''),'comanda': [(getObjectProperty(___arguments.context.dataModel, 'newComanda')),'/',[(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),' [',(getObjectProperty(___arguments.context.dataModel, 'newCartier')),']/'].join(''),[(new Date((new Date())).getDate()) >= 10 ? (new Date((new Date())).getDate()) : String('0') + String(new Date((new Date())).getDate()),'.',(new Date((new Date())).getMonth() + 1) >= 10 ? (new Date((new Date())).getMonth() + 1) : String('0') + String(new Date((new Date())).getMonth() + 1),'.',(new Date((new Date())).getFullYear()),'',''].join(''),'','','',''].join(''),'awb': (getObjectProperty(___arguments.context.dataModel, 'newAwb')),'expeditor': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'nume_firma')),'adresa': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'adresa_firma')),'cui': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'cui')),'nirc': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'nirc')),'aviz': (getObjectProperty(___arguments.context.dataModel, 'newAviz')),'factura': (getObjectProperty(___arguments.context.dataModel, 'newFactura')),'adresaRidicare': (getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),'client': (getObjectProperty(___arguments.context.dataModel, 'newNumeClient')),'customerAccount': (getObjectProperty(___arguments.context.dataModel, 'newCustomerAccount')),'adresaLivrare': [(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),'[',(getObjectProperty(___arguments.context.dataModel, 'newCartier')),']'].join(''),'plataCash': (getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),'telefon': (getObjectProperty(___arguments.context.dataModel, 'newTelefonClient')),'observatii': ['',String('sc. ') + String(getObjectProperty(___arguments.context.dataModel, 'newScara')),String(' et. ') + String(getObjectProperty(___arguments.context.dataModel, 'newEtaj')),String(' ap. ') + String(getObjectProperty(___arguments.context.dataModel, 'newApartament')),'(',(getObjectProperty(___arguments.context.dataModel, 'newDetaliiLivrare')),')'].join(''),'ramburs': (getObjectProperty(___arguments.context.dataModel, 'newPlataCash')) }));
      if ((getObjectProperty(___arguments.context.pageData, 'adresaRidicareUser')) == (getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare'))) {
        (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://calldelivery.ro/pdf/get-pdf/',(getObjectProperty(___arguments.context.dataModel, 'newAwb')),''].join('')), true, undefined);
      }
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'newPlataCash')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'newPlataOp'))) {
      ___arguments.context.pageData['newDecontat'] = true;
    }
    if (getObjectProperty(___arguments.context.dataModel, 'newLivrareExtern')) {
      await setInterval2();
      await Backendless.Messaging.sendEmail((['CMD: ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName')),'/Ridicare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare'))].join('')), new Backendless.Bodyparts({ htmlmessage: (['Comanda:  ',(getObjectProperty(___arguments.context.dataModel, 'newComanda')),'<br>Adresa Ridicare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),'<br>Adresa Livrare: ',(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),(getObjectProperty(___arguments.context.dataModel, 'newOptiuneAwb')) ? ['<br>Customer Account: ',(getObjectProperty(___arguments.context.dataModel, 'newCustomerAccount')),'<br>Factura: ',(getObjectProperty(___arguments.context.dataModel, 'newFactura')),'<br>Aviz: ',(getObjectProperty(___arguments.context.dataModel, 'newAviz')),'<br>Nume Client: ',(getObjectProperty(___arguments.context.dataModel, 'newNumeClient')),'',''].join('') : '','','','','','','','','<br> Ramburs: ',(getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),'<br>Telefon Client: ',(getObjectProperty(___arguments.context.dataModel, 'newTelefonClient')),'<br>Observatii: ',(getObjectProperty(___arguments.context.dataModel, 'newDetaliiLivrare')),'','<br>Va rugam nu raspundeti la acest email '].join('')) }), ensureArray((await Promise.all((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['tipLivrator = \'EXTERN\' AND activ=true',' AND created >=',(fromTime.valueOf()),' AND created <=',(toTime.valueOf()),'','','','',''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'emailLivrator'));})))), undefined);
    }
    await Backendless.Messaging.publish((getObjectProperty(___arguments.context.appData, 'masterName')), 'Atentie, comanda noua!', new Backendless.PublishOptions({ subtopic: '' }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
    await Backendless.Messaging.publish('comenzi', (String('Atentie,\ncomanda noua de la: ') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName'))), new Backendless.PublishOptions({ subtopic: '' }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
    (function (message) { alert(message) })('Comanda a fost inregistrata cu succes');

  }
}

/**
 * Describe this function...
 */
async function setTimeAndUser() {
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  timeOfset = (new Date());
  timeOfset.setTime((new Date(timeOfset.getTime() + (5400 * 1000))));
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'BORHANCI') {
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2000)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3000)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'CLUJ-NAPOCA SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1000)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2000)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1500)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FAGET 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2500)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'BULGARIA-IRIS 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1500)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'DAMBU ROTUND Z2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1000)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'MANASTUR 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1500)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'MANASTUR 3') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1500)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'cautaStrada')) == 'Câmpului' && (getObjectProperty(___arguments.context.dataModel, 'newNumar')) > 200) {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2000)));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'cautaStrada')) == 'Horea') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1200)));
  }
}

/**
 * Describe this function...
 */
async function comandaNoua2() {
  comandaNoua = (await Backendless.Data.of('Comenzi').save( ({ 'timpPreparare': (getObjectProperty(___arguments.context.dataModel, 'newTimpPreparare')),'detaliiAdresa': ['',String('sc. ') + String(getObjectProperty(___arguments.context.dataModel, 'newScara')),String(' et. ') + String(getObjectProperty(___arguments.context.dataModel, 'newEtaj')),String(' ap. ') + String(getObjectProperty(___arguments.context.dataModel, 'newApartament')),''].join(''),'bloc': (getObjectProperty(___arguments.context.dataModel, 'newBloc')),'tarifareLiv': (getObjectProperty(___arguments.context.dataModel, 'newTarifare')) > 0 ? (getObjectProperty(___arguments.context.dataModel, 'newTarifareLiv')) : 0,'brand': (getObjectProperty(___arguments.context.dataModel, 'newBrand')),'livratorDescarcat': (getObjectProperty(___arguments.context.pageData, 'newLivratorDescarcat')),'duration': (getObjectProperty(___arguments.context.pageData, 'duration')),'distance': (getObjectProperty(___arguments.context.pageData, 'distance')),'adresaPoint': ({ 'type': 'Point','coordinates': [(getObjectProperty((getObjectProperty((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'adresaGoogle')), 'results'))[0]), 'geometry')), 'location')), 'lng')), (getObjectProperty((getObjectProperty((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'adresaGoogle')), 'results'))[0]), 'geometry')), 'location')), 'lat'))] }),'cursaInclusa': (getObjectProperty(___arguments.context.pageData, 'cursaInclusa')),'industrie': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'industrie')),'profil': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'profil')),'ridicareDefault': (getObjectProperty(___arguments.context.dataModel, 'newDefaultRidicare')),'plataOp': (getObjectProperty(___arguments.context.dataModel, 'newPlataOp')),'dataComanda': (getObjectProperty(___arguments.context.dataModel, 'newDataComanda')),'allText': (getObjectProperty(___arguments.context.pageData, 'newAllText')),'logo': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'logo')),'optiuneAwb': (getObjectProperty(___arguments.context.dataModel, 'newOptiuneAwb')),'decontat': (getObjectProperty(___arguments.context.pageData, 'newDecontat')),'TipMasina': (getObjectProperty(___arguments.context.dataModel, 'newTipMasina')),'masterClient': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName')),'masterEmail': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterEmail')),'adresaLivrare': (getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),'awb': (getObjectProperty(___arguments.context.dataModel, 'newAwb')),'comanda': (getObjectProperty(___arguments.context.dataModel, 'newComanda')),'oraLimita': (getObjectProperty(___arguments.context.dataModel, 'newProgramare')),'status': (getObjectProperty(___arguments.context.dataModel, 'newStatus')),'livrareExtern': (getObjectProperty(___arguments.context.dataModel, 'newLivrareExtern')),'adresaRidicare': (getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),'aviz': (getObjectProperty(___arguments.context.dataModel, 'newAviz')),'cartier': (getObjectProperty(___arguments.context.dataModel, 'newCartier')),'comisionPos': (getObjectProperty(___arguments.context.dataModel, 'newComisionPos')),'customerAccount': (getObjectProperty(___arguments.context.dataModel, 'newCustomerAccount')),'programare': (getObjectProperty(___arguments.context.dataModel, 'newProgramare')),'detaliiLivrare': (getObjectProperty(___arguments.context.dataModel, 'newDetaliiLivrare')),'emailClient': (getObjectProperty(___arguments.context.dataModel, 'newEmailClient')),'factura': (getObjectProperty(___arguments.context.dataModel, 'newFactura')),'incasarePos': (getObjectProperty(___arguments.context.dataModel, 'newIncasarePos')),'numeClient': (getObjectProperty(___arguments.context.dataModel, 'newNumeClient')),'numeUser': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'username')),'plata_cash': (getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),'seIncaseazaCuPOS': (getObjectProperty(___arguments.context.dataModel, 'newSeIncaseazaCuPOS')),'tarifare': (getObjectProperty(___arguments.context.dataModel, 'newTarifare')),'tarifareIntern': (getObjectProperty(___arguments.context.dataModel, 'newTarifareIntern')),'telefonClient': (getObjectProperty(___arguments.context.dataModel, 'newTelefonClient')),'telefonDisp': (getObjectProperty(___arguments.context.dataModel, 'newTipLivrare')) == 'RIDICARE' ? (getObjectProperty(___arguments.context.dataModel, 'newTelefonDispecer')) : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'telefonUser')),'tipLivrare': (getObjectProperty(___arguments.context.dataModel, 'newTipLivrare')),'user': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'userEmail')) }) ));
}

/**
 * Describe this function...
 */
async function distanta_time() {
  ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': String(getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')) + String((getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.dataModel, 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.dataModel, 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'),'origins': [(getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),' Cluj-Napoca',''].join('') })));
  ___arguments.context.pageData['duration'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'duration')), 'text'));
  ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) + 0);
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));
  await corectieDistanta();
  ___arguments.context.pageData['kmDistance'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) / 1000);
  ___arguments.context.pageData['kmSPLLivrator'] = ((getObjectProperty(___arguments.context.pageData, 'kmDistance')) - 1 >= 0 ? (getObjectProperty(___arguments.context.pageData, 'kmDistance')) - 1 : 0);
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'kmDistance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) >= 0 ? (getObjectProperty(___arguments.context.pageData, 'kmDistance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.dataModel['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.dataModel['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function NewComandaNoua() {
  await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.testenv.ro/api/comenzi')).setEncoding('utf8').send(({ 'an': (new Date((new Date())).getFullYear()),'documentIncasare': '-','livrator': 'FARA LIVRATOR','timpPreparare': (getObjectProperty(___arguments.context.dataModel, 'newTimpPreparare')),'detaliiAdresa': ['',String('sc. ') + String(getObjectProperty(___arguments.context.dataModel, 'newScara')),String(' et. ') + String(getObjectProperty(___arguments.context.dataModel, 'newEtaj')),String(' ap. ') + String(getObjectProperty(___arguments.context.dataModel, 'newApartament')),''].join(''),'bloc': (getObjectProperty(___arguments.context.dataModel, 'newBloc')),'tarifareLiv': (getObjectProperty(___arguments.context.dataModel, 'newTarifare')) > 0 ? (getObjectProperty(___arguments.context.dataModel, 'newTarifareLiv')) : 0,'brand': (getObjectProperty(___arguments.context.dataModel, 'newBrand')),'livratorDescarcat': (getObjectProperty(___arguments.context.pageData, 'newLivratorDescarcat')),'duration': (getObjectProperty(___arguments.context.pageData, 'duration')),'distance': (getObjectProperty(___arguments.context.pageData, 'distance')),'adresaPoint': ({ 'type': 'Point','coordinates': [(getObjectProperty((getObjectProperty((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'adresaGoogle')), 'results'))[0]), 'geometry')), 'location')), 'lng')), (getObjectProperty((getObjectProperty((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'adresaGoogle')), 'results'))[0]), 'geometry')), 'location')), 'lat'))] }),'cursaInclusa': (getObjectProperty(___arguments.context.pageData, 'cursaInclusa')),'industrie': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'industrie')),'profil': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'profil')),'ridicareDefault': (getObjectProperty(___arguments.context.dataModel, 'newDefaultRidicare')),'plataOp': (getObjectProperty(___arguments.context.dataModel, 'newPlataOp')),'dataComanda': (getObjectProperty(___arguments.context.dataModel, 'newDataComanda')),'allText': (getObjectProperty(___arguments.context.pageData, 'newAllText')),'logo': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'logo')),'optiuneAwb': (getObjectProperty(___arguments.context.dataModel, 'newOptiuneAwb')),'decontat': (getObjectProperty(___arguments.context.pageData, 'newDecontat')),'TipMasina': (getObjectProperty(___arguments.context.dataModel, 'newTipMasina')),'masterClient': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName')),'masterEmail': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterEmail')),'adresaLivrare': (getObjectProperty(___arguments.context.dataModel, 'newAdresaLivrare')),'awb': (getObjectProperty(___arguments.context.dataModel, 'newAwb')),'comanda': (getObjectProperty(___arguments.context.dataModel, 'newComanda')),'oraLimita': (getObjectProperty(___arguments.context.dataModel, 'newProgramare')),'status': (getObjectProperty(___arguments.context.dataModel, 'newStatus')),'livrareExtern': (getObjectProperty(___arguments.context.dataModel, 'newLivrareExtern')),'adresaRidicare': (getObjectProperty(___arguments.context.dataModel, 'newAdresaRidicare')),'aviz': (getObjectProperty(___arguments.context.dataModel, 'newAviz')),'cartier': (getObjectProperty(___arguments.context.dataModel, 'newCartier')),'comisionPos': (getObjectProperty(___arguments.context.dataModel, 'newComisionPos')),'customerAccount': (getObjectProperty(___arguments.context.dataModel, 'newCustomerAccount')),'programare': (getObjectProperty(___arguments.context.dataModel, 'newProgramare')),'detaliiLivrare': (getObjectProperty(___arguments.context.dataModel, 'newDetaliiLivrare')),'emailClient': (getObjectProperty(___arguments.context.dataModel, 'newEmailClient')),'factura': (getObjectProperty(___arguments.context.dataModel, 'newFactura')),'incasarePos': (getObjectProperty(___arguments.context.dataModel, 'newIncasarePos')),'numeClient': (getObjectProperty(___arguments.context.dataModel, 'newNumeClient')),'numeUser': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'username')),'plata_cash': (getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),'valoareComanda': (getObjectProperty(___arguments.context.dataModel, 'newPlataCash')),'seIncaseazaCuPOS': (getObjectProperty(___arguments.context.dataModel, 'newSeIncaseazaCuPOS')),'tarifare': (getObjectProperty(___arguments.context.dataModel, 'newTarifare')),'tarifareIntern': (getObjectProperty(___arguments.context.dataModel, 'newTarifareIntern')),'telefonClient': (getObjectProperty(___arguments.context.dataModel, 'newTelefonClient')),'telefonDisp': (getObjectProperty(___arguments.context.dataModel, 'newTipLivrare')) == 'RIDICARE' ? (getObjectProperty(___arguments.context.dataModel, 'newTelefonDispecer')) : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'telefonUser')),'tipLivrare': (getObjectProperty(___arguments.context.dataModel, 'newTipLivrare')),'user': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'userEmail')) }));
  console.log('Comanda noua OK!');
}

/**
 * Describe this function...
 */
async function setInterval2() {
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
}


  try {
    await checkError();

  } catch (error) {
    ___arguments.context.pageData['eroareMaps'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e38f7bd4fb4b108488506bf716aa9bf', true);

  } finally {
    await onSubmit();

  }

  },
  /* handler:onSubmit *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'rol')) == 'DISPECER')

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['destinatar'] = '';
  ___arguments.context.dataModel['newBloc'] = 'BLOC';
  ___arguments.context.dataModel['newTimpPreparare'] = (60000 * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'timpPreparare')));

  },
  /* handler:onBeforeMount */
  /* content */
}));



define('./pages/ComandaNouaSig/components/26f57cd921e753c77b9e2c2117fac3ad/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
    var text;


  ___arguments.context.pageData['ProgramareAtentionare'] = (['','Daca optati sa lansati o comanda PROGRAMATA, trebuie sa tineti cont de urmatoarele aspecte:\n','','1) Nu este permisa programarea comenzii la un termen mai mic de 90min.\n','2) Livrarea se va face intr-un interval de +/- 20min fata de ora programata.\n','','','Va multumim\nCallDelivery Team '].join(''));
  if (___arguments.value == 'PROGRAMATA') {
    ;await ( async function (message){ alert(message) })((___arguments.context.pageData['ProgramareAtentionare']));
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('08b82f46b713ddd9f898331485e3e9da', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('08b82f46b713ddd9f898331485e3e9da', false);
  }

  },  
  /* handler:onChange *//* content */
}));

define('./pages/ComandaNouaSig/components/822b57ed13c1f8355ce8d53b30ce0379/bundle.js', [], () => ({
  /* content */

  


/* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc']) == 'CASA')

  },  
  /* handler:onDisabledStateAssignment *//* content */
}));




define('./pages/ComandaNouaSig/components/c7aebd879ccd2bffd82701b2796feb5c/bundle.js', [], () => ({
  /* content */

  
/* handler:onBlur */
  async ['onBlur'](___arguments) {
    var timeOfset, currentUser, toTime, fromTime, destinaton, origins;

/**
 * Describe this function...
 */
async function setTimeAndUser() {
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  timeOfset = (new Date());
  timeOfset.setTime((new Date(timeOfset.getTime() + (5400 * 1000))));
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function incarcaConstante() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(currentUser, 'adresaRidicare'));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newEmailRidicare')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEmailRidicare'] = (getObjectProperty(((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'\' AND masterClient = \'',(getObjectProperty(currentUser, 'masterName')),'\'',''].join(''))).setProperties('email').setPageSize(1)))[0]), 'email'));
  }
  ___arguments.context.pageData['newDefaultRidicare'] = (getObjectProperty(((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(getObjectProperty(currentUser, 'adresaRidicare')),'\''].join(''))).setProperties('default').setPageSize(1)))[0]), 'default'));
  ___arguments.context.pageData['newIndustrie'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'industrie'));
  if ((getObjectProperty(___arguments.context.pageData, 'newIndustrie')) != 'FOOD') {
    timeOfset.setHours('21');
    timeOfset.setMinutes('0');
    timeOfset.setSeconds('0');
    timeOfset.setMilliseconds('0');
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'] = (timeOfset.valueOf());
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'newIndustrie'));
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) >= 0 ? (getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BULGARIA-IRIS 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DAMBU ROTUND Z2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 3') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')) == 'Câmpului' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')) > 200) {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  }
}

/**
 * Describe this function...
 */
async function distanta_time3() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'','','',''].join(''));
    destinaton = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')) + String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca');
    origins = ({ 'destinations': undefined,'origins': [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('') });
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
      ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
    }
    console.log(['',origins,'',destinaton].join(''));
    console.log(['',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000,'',(getObjectProperty(___arguments.context.pageData, 'distance')),'','',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'kmSPL'))))].join(''));
  }
}

/**
 * Describe this function...
 */
async function distanta_time() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare'));
    destinaton = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DEZMIR' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'APAHIDA' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    await corectieDistanta();
    console.log(['\nAdresa Ridicare:',origins,'\nAdresa Livrare:',destinaton].join(''));
    console.log(['\nDistanta bruta:',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000,'\nDistanta:',(getObjectProperty(___arguments.context.pageData, 'distance')),'Km','\nKm suplimentari:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'kmSPL'))))].join(''));
  }
}


  await setTimeAndUser();
  await incarcaConstante();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d71bbdeabcf19812643310f8e74209b', true);
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) {
    await distanta_time();
    await tarifareKm();
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareIntern'));
  }

  },
  /* handler:onBlur *//* handler:onFocus */
  async ['onFocus'](___arguments) {
    var timeOfset, currentUser, toTime, fromTime, destinaton, origins;

/**
 * Describe this function...
 */
async function setTimeAndUser() {
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  timeOfset = (new Date());
  timeOfset.setTime((new Date(timeOfset.getTime() + (5400 * 1000))));
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function incarcaConstante() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(currentUser, 'adresaRidicare'));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newEmailRidicare')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEmailRidicare'] = (getObjectProperty(((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'\' AND masterClient = \'',(getObjectProperty(currentUser, 'masterName')),'\'',''].join(''))).setProperties('email').setPageSize(1)))[0]), 'email'));
  }
  ___arguments.context.pageData['newDefaultRidicare'] = (getObjectProperty(((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(getObjectProperty(currentUser, 'adresaRidicare')),'\''].join(''))).setProperties('default').setPageSize(1)))[0]), 'default'));
  ___arguments.context.pageData['newIndustrie'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'industrie'));
  if ((getObjectProperty(___arguments.context.pageData, 'newIndustrie')) != 'FOOD') {
    timeOfset.setHours('21');
    timeOfset.setMinutes('0');
    timeOfset.setSeconds('0');
    timeOfset.setMilliseconds('0');
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'] = (timeOfset.valueOf());
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'newIndustrie'));
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) >= 0 ? (getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BULGARIA-IRIS 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DAMBU ROTUND Z2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 3') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')) == 'Câmpului' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')) > 200) {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  }
}

/**
 * Describe this function...
 */
async function distanta_time3() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'','','',''].join(''));
    destinaton = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')) + String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca');
    origins = ({ 'destinations': undefined,'origins': [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('') });
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.superdev.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
      ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
    }
    console.log(['',origins,'',destinaton].join(''));
    console.log(['',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000,'',(getObjectProperty(___arguments.context.pageData, 'distance')),'','',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'kmSPL'))))].join(''));
  }
}

/**
 * Describe this function...
 */
async function distanta_time() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare'));
    destinaton = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DEZMIR' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'APAHIDA' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.superdev.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    await corectieDistanta();
    console.log(['\nAdresa Ridicare:',origins,'\nAdresa Livrare:',destinaton].join(''));
    console.log(['\nDistanta bruta:',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000,'\nDistanta:',(getObjectProperty(___arguments.context.pageData, 'distance')),'Km','\nKm suplimentari:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'kmSPL'))))].join(''));
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == null) {
    (function (message) { alert(message) })('Selecteaza o strada din lista!');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10d5d008a7face6d361888b14c12a003')));
  }
  await setTimeAndUser();
  await incarcaConstante();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d71bbdeabcf19812643310f8e74209b', true);
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) {
    await distanta_time();
    await tarifareKm();
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareIntern'));
  }

  },
  /* handler:onFocus */
  /* content */
}));

define('./pages/ComandaNouaSig/components/d84cb55112c23314c3ac20c8112417fa/bundle.js', [], () => ({
  /* content */

  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function user() {
}


  await user();

  return (await Promise.all((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterClient = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masterName')),'\'',''].join(''))).setSortBy('adresa asc').setPageSize(10))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'label')),'value': (getObjectProperty(item, 'adresa')) });})))

  },
  /* handler:onOptionsAssignment *//* handler:onChange */
  async ['onChange'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEmailRidicare'] = (getObjectProperty(((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'\' AND masterClient = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masterName')),'\'',''].join(''))).setProperties('email').setPageSize(1)))[0]), 'email'));
  ___arguments.context.pageData['newDefaultRidicare'] = (getObjectProperty(((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',___arguments.value,'\''].join(''))).setProperties('default').setPageSize(1)))[0]), 'default'));

  },
  /* handler:onChange */
/* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}));

define('./pages/ComandaNouaSig/components/80eca69f2334e502715faeb27781ad9d/bundle.js', [], () => ({
  /* content */

  
/* handler:onBlur */
  onBlur(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataCard']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataCard'] = 0;
  }

  },  
/* handler:onBlur *//* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataOp'])

  },  
/* handler:onDisabledStateAssignment *//* handler:onFocus */
  onFocus(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', false);
  ___arguments.context.appData['paginaCurenta'] = 'plata cash(comanda noua)';

  },  
  /* handler:onFocus */
  /* content */
}));

define('./pages/ComandaNouaSig/components/5fd1a311c91d3ce458fef4aa32f4561c/bundle.js', [], () => ({
  /* content */

  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataOp'])

  },  
/* handler:onDisabledStateAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/54e331127769e15111770df57071384f/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc']) == 'CASA')

  },  
  /* handler:onDisabledStateAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/b5374e59902b4ba89e8bdf76f21e5ab9/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc']) == 'CASA')

  },  
  /* handler:onDisabledStateAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/3d71bbdeabcf19812643310f8e74209b/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (!(___arguments.context.pageData['destinatarExistent']) || (___arguments.context.pageData['altaAdresa']))

  },  
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/592fd7cd40fcc65678467b9c4f6c8c48/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  ['onChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', false);
  if (___arguments.value) {
    ___arguments.context.pageData['newDecontat'] = true;
    ___arguments.context.pageData['newLivratorDescarcat'] = true;
  } else {
    ___arguments.context.pageData['newDecontat'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataCash'] = 0;
  ___arguments.context.appData['paginaCurenta'] = 'plata op(comanda noua)';

  },
  /* handler:onChange *//* content */
}));

define('./pages/ComandaNouaSig/components/6dd100bf23d6cfbc8a44bffff2b8121f/bundle.js', [], () => ({
  /* content */

  

/* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newDataComanda'] = (['',(new Date((new Date())).getDate()) < 10 ? String('0') + String(new Date((new Date())).getDate()) : (new Date((new Date())).getDate()),'.',(new Date((new Date())).getMonth()) + 1 < 10 ? String('0') + String((new Date((new Date())).getMonth()) + 1) : (new Date((new Date())).getMonth()) + 1,'.',(new Date((new Date())).getFullYear()) < 10 ? String('0') + String(new Date((new Date())).getFullYear()) : (new Date((new Date())).getFullYear()),'','','',''].join(''));

  return (['',(new Date((new Date())).getDate()) < 10 ? String('0') + String(new Date((new Date())).getDate()) : (new Date((new Date())).getDate()),'.',(new Date((new Date())).getMonth()) + 1 < 10 ? String('0') + String((new Date((new Date())).getMonth()) + 1) : (new Date((new Date())).getMonth()) + 1,'.',(new Date((new Date())).getFullYear()) < 10 ? String('0') + String(new Date((new Date())).getFullYear()) : (new Date((new Date())).getFullYear()),'','','',''].join(''))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/3789060b203b212d25a1d4eb3eb19062/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, destinaton, origins;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function onChange3() {
  if (___arguments.value.length > 9) {
    ___arguments.context.pageData['destinatar'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'destinatarLocal')), async (item) => {


     return ((getObjectProperty(item, 'telefon')) == ___arguments.value);
    }));
    console.log((getObjectProperty(___arguments.context.pageData, 'destinatar')).length);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bedee28d86e292249c57a6782cb84a21', (getObjectProperty(___arguments.context.pageData, 'destinatar')));
    if ((getObjectProperty(___arguments.context.pageData, 'destinatar')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'cartier')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newZona'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'zona'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'numar')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['destinatarBanat'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'destinatarBanat'));
      console.log(['strada: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')),'\nCartier: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'cartier')),'','','','',''].join(''));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'bloc')) == '1' ? 'BLOC' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'bloc')));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newScara'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'scara'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEtaj'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'etaj'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAnexaNumar'] = '';
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newApartament'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'apartament'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),' Cluj-Napoca'].join(''));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b94b968ef4dddba6cf0f2b77deb17397', true);
      ___arguments.context.pageData['destinatarExistent'] = true;
      if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) {
        if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
          await distanta_time();
          await tarifareKm();
        } else {
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 1) {
            if ((getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) + (getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0) {
              ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 0;
            } else {
              ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_baza'));
            }
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 2) {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z2'));
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 3) {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z3'));
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 'extra') {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 60;
          }
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE') {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 39;
          }
        }
      } else {
        ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareIntern'));
      }
    }
    console.log(String('legth of destinatar: ') + String((getObjectProperty(___arguments.context.pageData, 'destinatar')).length));
  }
  await cursaInclusa();
}

/**
 * Describe this function...
 */
async function distanta_time() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare'));
    destinaton = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    await corectieDistanta();
  }
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BULGARIA-IRIS 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DAMBU ROTUND Z2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 3') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')) == 'Câmpului' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')) > 200) {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  }
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) >= 0 ? (getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function cursaInclusa() {
  if ((getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')) == 0) {
    ___arguments.context.pageData['cursaInclusa'] = 'ABONAMENT';
  } else if ((getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) > 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')) == 0) {
    ___arguments.context.pageData['cursaInclusa'] = 'FT';
  }
}

  },
  /* handler:onChange */

/* handler:onBlur */
  async ['onBlur'](___arguments) {
    var timeOfset, currentUser, toTime, fromTime;

/**
 * Describe this function...
 */
async function setTimeAndUser() {
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  timeOfset = (new Date());
  timeOfset.setTime((new Date(timeOfset.getTime() + (5400 * 1000))));
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function incarcaConstante() {
  await setTimeAndUser();
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'adresaRidicare'));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newEmailRidicare')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEmailRidicare'] = (getObjectProperty(((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'\' AND masterClient = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masterName')),'\'',''].join(''))).setProperties('email').setPageSize(1)))[0]), 'email'));
  }
  ___arguments.context.pageData['newDefaultRidicare'] = (getObjectProperty(((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'adresaRidicare')),'\''].join(''))).setProperties('default').setPageSize(1)))[0]), 'default'));
  ___arguments.context.pageData['newIndustrie'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'industrie'));
  if ((getObjectProperty(___arguments.context.pageData, 'newIndustrie')) != 'FOOD') {
    timeOfset.setHours('21');
    timeOfset.setMinutes('0');
    timeOfset.setSeconds('0');
    timeOfset.setMilliseconds('0');
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'] = (timeOfset.valueOf());
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'newIndustrie'));
}

  },
  /* handler:onBlur *//* handler:onFocus */
  async ['onFocus'](___arguments) {
    var destinaton, origins;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function distanta_time() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare'));
    destinaton = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    await corectieDistanta();
  }
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BULGARIA-IRIS 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DAMBU ROTUND Z2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 3') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')) == 'Câmpului' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')) > 200) {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  }
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) >= 0 ? (getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function cursaInclusa() {
  if ((getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')) == 0) {
    ___arguments.context.pageData['cursaInclusa'] = 'ABONAMENT';
  } else if ((getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) > 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')) == 0) {
    ___arguments.context.pageData['cursaInclusa'] = 'FT';
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', true);

  },
  /* handler:onFocus */
  /* content */
}));

define('./pages/ComandaNouaSig/components/10d5d008a7face6d361888b14c12a003/bundle.js', [], () => ({
  /* content */

  


/* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function onChange() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11dc147ae458c2c339766691e01f246a', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11dc147ae458c2c339766691e01f246a', (await Backendless.Data.of('straziCluj').find(Backendless.DataQueryBuilder.create().setWhereClause((['STRADA LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')),'%\''].join(''))).setSortBy('STRADA').setPageSize(5))));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['BDStrazi'] = (await Backendless.Data.of('straziCluj').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['STRADA LIKE \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')),'%\''].join('')))));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['textStrada'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'BDStrazi')) > 0 ? 'Selecteaza o strada de mai jos!' : String('Aceasta strada nu exista in baza de date.') + String(''));
}

/**
 * Describe this function...
 */
async function onChange2() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11dc147ae458c2c339766691e01f246a', true);
  if (___arguments.value.length > 3) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['strada'] = (getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.testenv.ro/api/strazicluj/search')).setEncoding('utf8').send(({ 'selected': ({ 'STRADA': ___arguments.value }),'limit': 10 }))), 'docs'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11dc147ae458c2c339766691e01f246a', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'strada')));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['BDStrazi'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'strada')).length);
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['textStrada'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'BDStrazi')) > 0 ? 'Selecteaza o strada de mai jos!' : String('Aceasta strada nu exista in baza de date.') + String(''));
  }
}


  await onChange2();

  },
  /* handler:onChange */



/* handler:onFocus */
  onFocus(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', false);
  ___arguments.context.appData['paginaCurenta'] = 'cauta strada(comanda noua)';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = null;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = null;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['BDStrazi'] = 0;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAnexaNumar'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newScara'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEtaj'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newApartament'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa7b7278efa4ee82ec1bb8126dac568d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b94b968ef4dddba6cf0f2b77deb17397', false);
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['TextStrada'] = (String('Aceasta strada nu exista in baza de date.') + String('\nTe rog sa introduci o strada corecta!!!!'));

  },
  /* handler:onFocus */
  /* content */
}));




define('./pages/ComandaNouaSig/components/4ac28c0e9fda7fe49862b824fc5c0aff/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function onClick() {
  ___arguments.context.pageData['stradaSelectata'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'STRADA'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'CARTIER'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'seLivreaza')) == false && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newOptiuneAwb')) == false) {
    (function (message) { alert(message) })((['Din pacate, aceasta adresa se afla in afara ariei noastre de acoperire: strada ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'STRADA')),'(',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'CARTIER')),')'].join('')));
    ___arguments.context.pageData['stradaSelectata'] = null;
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = null;
  }
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'CARTIER'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'STRADA'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'STRADA'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newZona'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f957a57c633d195335ead3449264924e'), 'ZONA'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11dc147ae458c2c339766691e01f246a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa7b7278efa4ee82ec1bb8126dac568d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b94b968ef4dddba6cf0f2b77deb17397', true);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'LIVRARE') {
    if ((getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) + (getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 0;
    } else {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_baza'));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 2) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z2'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 3) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z3'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 'extra') {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 60;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE') {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 39;
  }
  console.log(String('cursa inclusa: ') + String(getObjectProperty(___arguments.context.pageData, 'cursaInclusa')));
}

/**
 * Describe this function...
 */
async function cursaInclusa() {
  if ((getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')) == 0) {
    ___arguments.context.pageData['cursaInclusa'] = 'ABONAMENT';
  } else if ((getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) > 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')) == 0) {
    ___arguments.context.pageData['cursaInclusa'] = 'FT';
  }
}


  await onClick();

  },
  /* handler:onClick *//* content */
}));

define('./pages/ComandaNouaSig/components/97cd049b1255fdb7af9c95149088a364/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getDestinatar() {
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = (getObjectProperty(___arguments.context.dataModel, 'cartier'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = (getObjectProperty(___arguments.context.dataModel, 'strada'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar'] = (getObjectProperty(___arguments.context.dataModel, 'numar'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newScara'] = (getObjectProperty(___arguments.context.dataModel, 'scara'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEtaj'] = (getObjectProperty(___arguments.context.dataModel, 'etaj'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newApartament'] = (getObjectProperty(___arguments.context.dataModel, 'apartament'));
}


  await getDestinatar();

  return (['Cartier: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),'\nStrada: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' Nr: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'\nSc: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newScara')),' Et: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newEtaj')),' Ap: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newApartament'))].join(''))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/3ab327259a4af2c50ab4d6c879d6fee1/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'destinatar')).length > 0 && !(getObjectProperty(___arguments.context.pageData, 'altaAdresa')))

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/7837663e5d9ffa33f47ebc01eb44ebeb/bundle.js', [], () => ({
  /* content */

  
/* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['paginaCurenta'] = 'alta adresa(comanda noua)';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ab327259a4af2c50ab4d6c879d6fee1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1867365d6c873a4c878a73ff869cbff', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d71bbdeabcf19812643310f8e74209b', true);
  ___arguments.context.pageData['altaAdresa'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = null;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = null;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAnexaNumar'] = ' ';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc'] = 'BLOC';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newScara'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEtaj'] = '';
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newApartament'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b94b968ef4dddba6cf0f2b77deb17397', false);

  },
  /* handler:onChange */
/* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'altaAdresa'))

  },
  /* handler:onCheckedStateAssignment *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'destinatarBanat')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}));

define('./pages/ComandaNouaSig/components/189a1e3ff2f1a0537819c06e2da44587/bundle.js', [], () => ({
  /* content */

  


/* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newOptiuneAwb')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'LIVRARE')

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/685876ba86cb09ec29d4bf876fc9a83e/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Comanda se ridica de la adresa:\n',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'\nsi se livreaza la adresa: ','\nStrada: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' nr: ',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAnexaNumar')),'\nCartier: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),'\nsc: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newScara')),' et ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newEtaj')),' ap ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newApartament')),'\nValoare ramburs: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newPlataCash')) > 0 ? String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newPlataCash')) + String(' LEI ') : 'COMANDA PLATITA','\n Cost transport: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')),'lei\n','','Distanta: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'distance')))),'km\nE OK?'].join(''))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/5a5705d3819284e48f7bebd8e8d73b8c/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'LivratorActiv')) == 0)

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/214f7e31d2dc9e4e830cfc5862e4685e/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStatus')) == 'PROGRAMATA') && (getObjectProperty(___arguments.context.pageData, 'livratorActivExtern')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern'))) {
    return false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStatus')) == 'PROGRAMATA') {
    return true;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/e32b890df715a2cbed49a603663e4b84/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Comanda va fi\nlivrata ce tarziu la:\n') + String([(new Date((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'])).getDate()),'/',(new Date((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'])).getMonth()) + 1,'/',(new Date((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'])).getFullYear()),' la ora: ',(new Date((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'])).getHours()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'])).getHours()) : (new Date((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'])).getHours()),':',(new Date((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'])).getMinutes()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'])).getMinutes()) : (new Date((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'])).getMinutes())].join('')))

  },  
  /* handler:onContentAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/93365cad856d513bee23ef21b57ac111/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'RIDICARE') {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = '';
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataCash'] = 0;
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataCard'] = 0;
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 39;
    ___arguments.context.pageData['newDefaultRidicare'] = false;
  } else if (___arguments.value == 'LIVRARE') {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = '';
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataOp'] = false;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 1) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty(((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newMaster')),'\''].join(''))).setProperties('tarifare_baza').setPageSize(1)))[0]), 'tarifare_baza'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 2) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty(((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newMaster')),'\''].join(''))).setProperties('tarifare_Z2').setPageSize(1)))[0]), 'tarifare_Z2'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 3) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty(((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newMaster')),'\''].join(''))).setProperties('tarifare_Z3').setPageSize(1)))[0]), 'tarifare_Z3'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 'extra') {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 60;
    }
  }

  },
  /* handler:onChange */
/* content */
}));

define('./pages/ComandaNouaSig/components/bb7b39973427050e64975e0ea8cc1981/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return true

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/ComandaNouaSig/components/454390c205bc9a9bd542c06ad696ad68/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      if (___arguments.value == true) {
    await ( async function (message) { alert(message) })('Sigur vrei sa emiti AWB? Daca nu vrei awb debifeaza optiunea awb!');
  } else if (___arguments.value == false) {
    await ( async function (message) { alert(message) })('Sigur NU vrei sa emiti AWB? Daca vrei awb optiunea awb trebuie sa fie bifata!');
  }

  },
  /* handler:onChange *//* handler:onDisabledStateAssignment */
  async onDisabledStateAssignment(___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function user() {
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.pageData['awb'] = (getObjectProperty(((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(getObjectProperty(currentUser, 'masterName')),'\''].join(''))).setProperties('awb').setPageSize(1)))[0]), 'awb'));
}


  await user();

  return (!(getObjectProperty(___arguments.context.pageData, 'awb')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}));

define('./pages/ComandaNouaSig/components/c23363537faa998c5409b04734794a65/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada']),' ',String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar']) + String(___arguments.value),' Cluj-Napoca'].join(''));

  },  
/* handler:onChange *//* content */
}));

define('./pages/ComandaNouaSig/components/57fc5783d4bfa3e65618a7547d890969/bundle.js', [], () => ({
  /* content */

  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newDefaultRidicare'] = (getObjectProperty(___arguments.context.pageData, 'newDefaultRidicare'));

  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newDefaultRidicare'))

  },
  /* handler:onCheckedStateAssignment */

/* content */
}));

define('./pages/ComandaNouaSig/components/ce6d6b7b6b19c69f6437341c05ee6498/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Comenzi', null);
  ___arguments.context.appData['paginaCurenta'] = 'renuntaLaComanda';

  },
  /* handler:onClick *//* content */
}));

define('./pages/ComandaNouaSig/components/5d07b88655e83d75cf0f4512b616d24e/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.getComponentDataStoreByUid('19cc20492d21ccd92e5333a9d2072c64')['paginaCurenta'] = (getObjectProperty(___arguments.context.appData, 'paginaCurenta'));
  await Backendless.Data.of('DispecerActiv').save( ___arguments.context.getComponentDataStoreByUid('19cc20492d21ccd92e5333a9d2072c64') );

  ;(function() {
    const callback = async () => {
        ___arguments.context.getComponentDataStoreByUid('19cc20492d21ccd92e5333a9d2072c64')['paginaCurenta'] = (getObjectProperty(___arguments.context.appData, 'paginaCurenta'));
    await Backendless.Data.of('DispecerActiv').save( ___arguments.context.getComponentDataStoreByUid('19cc20492d21ccd92e5333a9d2072c64') );

    };

    const timerId = 'setCurrentPage';
    const timerDelay = 10000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  onBeforeUnmount(___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('setCurrentPage');

  },  
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/ComandaNouaSig/components/050a363d603269da893ff8914c860de2/bundle.js', [], () => ({
  /* content */

  
/* handler:onChange */
  async ['onChange'](___arguments) {
    var destinaton, origins;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function distanta_time() {
  if (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),'','','',''].join(''));
    destinaton = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    await corectieDistanta();
    console.log(['\nAdresa Ridicare:',origins,'\nAdresa Livrare:',destinaton].join(''));
    console.log(['\nDistanta bruta:',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000,'\nDistanta:',(getObjectProperty(___arguments.context.pageData, 'distance')),'Km','\nKm suplimentari:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.pageData, 'kmSPL'))))].join(''));
  }
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKm'));
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmLimita')) >= 0 ? (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmLimita'))))) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 4)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 6)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 4)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
  }
}


  if (___arguments.value) {
    (function (message) { alert(message) })('Ai ales ca livrarea sa se faca cu un livrator EXTERN!');
    await distanta_time();
    await tarifareKm();
  } else {
    (function (message) { alert(message) })('Ai ales ca livrarea sa se faca cu un livrator PROPRIU!');
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'client')), 'tarifareIntern'))));
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newLivrareExtern']) ? 'Livrator Extern' : 'Livrator Propriu')

  },  
  /* handler:onLabelAssignment */
  /* handler:onDisabledStateAssignment */
  async onDisabledStateAssignment(___arguments) {
    var currentUser;

/**
 * Describe this function...
 */
async function user() {
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.pageData['livrareMixta'] = (((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setProperties('livrareMixta').setPageSize(1)))[0])['livrareMixta']);
}


  await user();

  return (!(___arguments.context.pageData['livrareMixta']))

  },  
  /* handler:onDisabledStateAssignment */
  /* content */
}));

define('./pages/ComandaNouaSig/components/33a9480e082ed1571181cdf4a94939c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) ? String('Livrarea se face cu:\n') + String('!!! LIVRATOR EXTERN !!!') : String('Livrarea se face cu:\n') + String('!!! LIVRATOR PROPRIU !!!'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/e2bd498eab84fcb81086afbbaec3a164/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item, currentUser;

/**
 * Describe this function...
 */
async function user() {
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
}


  await user();

  return ((await Backendless.Data.of('BrandClient').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterClient = \'',(currentUser['masterName']),'\'',''].join(''))).setSortBy('brand asc').setPageSize(10))).map(item => {; return ({ 'label': (item['brand']),'value': (item['brand']) });}))

  },  
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBrand'] = ___arguments.value;

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/ComandaNouaSig/components/7e38f7bd4fb4b108488506bf716aa9bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'eroareMaps'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/392c4ef888d691965e010f5ab17a27c1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Din pacate, din cauza unor probleme tehnice legate de server, nu se pot lansa comenzi in acest moment. Echipa tehnica lucreaza in acest moment pentru remedierea problemei.Va rugam reveniti mai tarziu. Pentru urgente va rugam sa luati legatura cu noi la 0752621501 sau sa puneti o copie a comenzii pe grupul de WhatsApp.') + String('\nMultumim pentru intelegere.'))

  },  
  /* handler:onContentAssignment */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      (function (message) { alert(message) })('Din pacate, din cauza unor probleme tehnice legate de server, nu se pot lansa comenzi in acest moment. Echipa tehnica lucreaza in acest moment pentru remedierea problemei.Va rugam reveniti mai tarziu. Pentru urgente va rugam sa luati legatura cu noi la 0752621501 sau sa puneti o copie a comenzii pe grupul de WhatsApp.');

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/ComandaNouaSig/components/3ed7e258a629ee1a39bec8a8b7dd925a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newLogo'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'logo'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00a5ebdb1bfa53dd1c21d92a187d9215', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cae11318939f537e4525e3c6242d3085', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ed7e258a629ee1a39bec8a8b7dd925a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/cae11318939f537e4525e3c6242d3085/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00a5ebdb1bfa53dd1c21d92a187d9215', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cae11318939f537e4525e3c6242d3085', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ed7e258a629ee1a39bec8a8b7dd925a', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/58655bbf374e436775f6cf282f8c492d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var timeOfset, client, brand, currentUser, toTime, fromTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function onMount() {
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBrand'] = brand;
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newOptiuneAwb'] = (getObjectProperty(client, 'awb'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newLivrareExtern'] = (getObjectProperty(client, 'defaultExtern'));
  ___arguments.context.pageData['newDefaultRidicare'] = (getObjectProperty(___arguments.context.appData, 'newDefaultRidicare'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.appData, 'adresaRidicareUser'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'] = (timeOfset.valueOf());
}

/**
 * Describe this function...
 */
async function setTimeAndUser() {
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  timeOfset = (new Date());
  timeOfset.setTime((new Date(timeOfset.getTime() + (5400 * 1000))));
  client = (getObjectProperty(___arguments.context.appData, 'client'));
  brand = (getObjectProperty(___arguments.context.appData, 'newBrand'));
}

/**
 * Describe this function...
 */
async function incarcaConstante() {
  await setTimeAndUser();
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.appData, 'adresaRidicareUser'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newLivrareExtern'] = (getObjectProperty(client, 'defaultExtern'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEmailRidicare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'adresaRidicare')), 'email'));
  ___arguments.context.pageData['adresaRidicareUser'] = (getObjectProperty(___arguments.context.appData, 'adresaRidicareUser'));
  ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newComanda'] = (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumarComanda')));
  if ((getObjectProperty(client, 'industrie')) != 'FOOD') {
    timeOfset.setHours('21');
    timeOfset.setMinutes('0');
    timeOfset.setSeconds('0');
    timeOfset.setMilliseconds('0');
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'] = (timeOfset.valueOf());
  }
}


  await setTimeAndUser();
  await onMount();
  await incarcaConstante();

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/ComandaNouaSig/components/b94b968ef4dddba6cf0f2b77deb17397/bundle.js', [], () => ({
  /* content */

  



/* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.appData['paginaCurenta'] = 'submit comanda noua';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (!(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['destinatarBanat']) && !((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada']) == null) && !((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier']) == null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}));

define('./pages/ComandaNouaSig/components/08b82f46b713ddd9f898331485e3e9da/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var timpSetat, timeOfset;


  timpSetat = ___arguments.value - ((new Date()).valueOf());
  console.log(timpSetat);
  if (timpSetat < 5400000) {
    (function (message) { alert(message) })((['ATENTIE!!!\n','Nu este permisa programarea\n','comenzii cu un termen sub 90min!','',''].join('')));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newProgramare'] = (((new Date()).valueOf()) + 5400000);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ComandaNouaSig/components/41af4cdab804ba7172df9cbcbb756ade/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '1';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')) + String('1'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/6ef2eff4a177f282e16b225f1ed22e73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '2';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('2'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/4947eae2412576a5c3b34bb2f2e6d995/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '3';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('3'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/17c165b4ab6b2658ad9d29d17354bd7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '4';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('4'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/5ff6f757bbd8ec4c13f8efe6e3395694/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '5';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('5'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/f74df7c2f81810bd17f1c1e7dcf76515/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '6';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('6'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/89caa53445af3881a4a5bcb79c313a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '7';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('7'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/9f66b64e0c76839ea4ced7a9d1c91834/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '8';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('8'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/6bc36c3d375a7e6916bb77c242cec5af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '9';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('9'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/2159226cb12f434dd59690b55224c2ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) == null) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '0';
  } else {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = (String(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient']) + String('0'));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/43fdd191f1f1f62ff7a6a8adb3922a33/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTelefonClient'] = '';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/e1cc1daf951bb2b32602205d381dc0fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var destinaton, origins;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function corectieDistanta() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BORHANCI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MUNCII') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 3)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FAGET 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BULGARIA-IRIS 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'DAMBU ROTUND Z2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 2') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'MANASTUR 3') {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 1.5)));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'cautaStrada')) == 'Câmpului' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')) > 200) {
    ___arguments.context.pageData['distance'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.pageData, 'distance')) + 2)));
  }
}

/**
 * Describe this function...
 */
async function cursaInclusa() {
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));
  ___arguments.context.pageData['kmSPL'] = ((getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) >= 0 ? (getObjectProperty(___arguments.context.pageData, 'distance')) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) : 0);
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) < 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL1')))));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) && (getObjectProperty(___arguments.context.pageData, 'kmSPL')) >= 8 - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmLimita'))) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmBaza')) + (getObjectProperty(___arguments.context.pageData, 'kmSPL')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKmSPL2')))));
  }
}

/**
 * Describe this function...
 */
async function onOK2() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')).length > 9) {
    ___arguments.context.pageData['destinatar'] = (await Backendless.Data.of('Destinatar').find(Backendless.DataQueryBuilder.create().setWhereClause((['telefon = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')),'\''].join(''))).setProperties('telefon').setPageSize(1)));
    if ((await Backendless.Data.of('Destinatar').find(Backendless.DataQueryBuilder.create().setWhereClause((['telefon = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')),'\''].join(''))).setProperties('telefon').setPageSize(1))).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'cartier')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newZona'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'zona'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'numar')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['destinatarBanat'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'destinatarBanat'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'bloc')) == '1' ? 'BLOC' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'bloc')));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newScara'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'scara'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEtaj'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'etaj'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAnexaNumar'] = '';
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newApartament'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'apartament'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),' Cluj-Napoca'].join(''));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b94b968ef4dddba6cf0f2b77deb17397', true);
      ___arguments.context.pageData['destinatarExistent'] = true;
      if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) {
        if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
          await distanta_time();
          await tarifareKm();
        } else {
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 1) {
            if ((getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) + (getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0) {
              ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 0;
            } else {
              ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_baza'));
            }
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 2) {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z2'));
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 3) {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z3'));
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 'extra') {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 60;
          }
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE') {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 39;
          }
        }
      } else {
        ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareIntern'));
      }
    }
  }
  await cursaInclusa();
}

/**
 * Describe this function...
 */
async function onOK() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ab327259a4af2c50ab4d6c879d6fee1', (getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.testenv.ro/api/destinatar/search')).setEncoding('utf8').send(({ 'selected': ({ 'telefon': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')) }) }))), 'docs')));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')).length > 9) {
    ___arguments.context.pageData['destinatar'] = ((getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.testenv.ro/api/destinatar/search')).setEncoding('utf8').send(({ 'selected': ({ 'telefon': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTelefonClient')) }) }))), 'docs'))[0]);
    console.log(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada'));
    if ((getObjectProperty(___arguments.context.pageData, 'destinatar')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['cautaStrada'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'strada')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newCartier'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'cartier')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newZona'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'zona'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newNumar'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'numar')).trim());
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['destinatarBanat'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'destinatarBanat'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newBloc'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'bloc')) == '1' ? 'BLOC' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'bloc')));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newScara'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'scara'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newEtaj'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'etaj'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAnexaNumar'] = '';
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newApartament'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'destinatar')), 'apartament'));
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),' Cluj-Napoca'].join(''));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b94b968ef4dddba6cf0f2b77deb17397', true);
      ___arguments.context.pageData['destinatarExistent'] = true;
      if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newLivrareExtern')) {
        if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
          await distanta_time();
          await tarifareKm();
        } else {
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 1) {
            if ((getObjectProperty(___arguments.context.pageData, 'comenziFaraTermenRamase')) + (getObjectProperty(___arguments.context.pageData, 'curseAbonamentRamase')) > 0) {
              ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 0;
            } else {
              ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_baza'));
            }
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 2) {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z2'));
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 3) {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifare_Z3'));
          } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newZona')) == 'extra') {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 60;
          }
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE') {
            ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = 39;
          }
        }
      } else {
        ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTarifare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareIntern'));
      }
    }
  }
  await cursaInclusa();
}

/**
 * Describe this function...
 */
async function distanta_time() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm')) {
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newStrada')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newNumar')),'',''].join(''));
    ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare'));
    destinaton = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FLORESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'BACIU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'SOMESENI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'sat POPESTI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'FELEACU' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')) == 'CHINTENI' ? [' comuna ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newCartier')),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newAdresaRidicare')),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'distanceGoogle')), 'distance')), 'value')) / 1000 + 0);
    await corectieDistanta();
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/938d55b190428c188d21db2cdf4dcb3c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9696345363cfe65f7e37cbeb728f106', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ComandaNouaSig/components/a60a82adddfefda1c635aa2e3d1931fc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Selecteaza un timp estimat de preparare.\n','Daca nu selectezi altceva, timpul de preparare va fi setat la:<b> ',(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newTimpPreparare']) / 60000,':00 min'].join(''))

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (((___arguments.context.appData['client'])['industrie']) == 'FOOD')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/d205da3f2e6276e1c4a146ac240e55cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (((___arguments.context.appData['client'])['industrie']) == 'FOOD')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/66f527b544ecadeacf5af6ccdad9d84e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'dezactivatTemporar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/1ea60abc1e1a13b141cf63893eb7f20d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (((___arguments.context.appData['client'])['incasarePOS']) && !(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataOp']))

  },  
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newPlataOp'])

  },  
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/2cfe7dc1b39d1cf8c1923fc19d27fd64/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Ne pare rau dar\n acest client este inregistrat in sistem cu incidente la livrare.\nIn consecinta, ne rezervam dreptul de a nu livra comenzi acestui destinatar.\n\nVa multumim pentru intelegere.(CallDelivery Team)\n[',(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newStrada']),']'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/ae67e4d2f85d1c24f61a2eea3ad9679d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'destinatarBanat'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/32c68ff2a27d235cff06a48c6b1b11b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Comenzi', null);
  ___arguments.context.appData['paginaCurenta'] = 'ClientBanat';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ComandaNouaSig/components/584feb15fad56731a33ab1d14adfe9db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newOptiuneAwb')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'LIVRARE')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/193b5e2beedcb264adc85fd4eb746667/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newOptiuneAwb')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'LIVRARE')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/cfd79664f40bbe9d7ea85bad924bd5ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newOptiuneAwb')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'LIVRARE')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/a033e0d6818e6d2590756a8e8bcdccb7/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newOptiuneAwb')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'LIVRARE')

  },
  /* handler:onDisplayAssignment */
  /* content */
}));

define('./pages/ComandaNouaSig/components/0099f3abfe3ea396c63a29f9137fd528/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/9995632f8481827c45ba174b383caf2e/bundle.js', [], () => ({
  /* content */
  /* handler:onFocus */
  onFocus(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584')['newAdresaRidicare'] = '';

  },
  /* handler:onFocus */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTipLivrare')) == 'RIDICARE')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ComandaNouaSig/components/1ae4af26e615556c086f3af636a76cbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Comanda va fi tarifata cu: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14654282be67c4ca9d3abddded61c584'), 'newTarifare')),'LEI'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Comenzi/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, toTime, fromTime, message, logoutTime, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function atentionarePlata() {
  ___arguments.context.pageData['clientActiv'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'activ'));
  if ((new Date((new Date())).getDay()) == 1 && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'areRestantePlata'))) {
    (function (message) { alert(message) })('Atentie, figurati in evidentele noastre cu restante la plata facturilor. Va rugam sa efectuati platile restante. Va multumim. CallDelivery Team');
  } else if ((new Date((new Date())).getDay()) == 2 && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'areRestantePlata'))) {
    (function (message) { alert(message) })('Atentie, azi e ultima zi de plata a facturilor restante. Daca ai restante la plata facturilor, contul tau ar putea fi suspendat pana la stingerea soldului. Multumim pentru intelegere.');
  } else if ((new Date((new Date())).getDay()) > 2 && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'areRestantePlata'))) {
    (function (message) { alert(message) })('Contul dumeavoastra este dezactivat pentru neplata facturilor restante. Va rugam sa efectuati platile si sa ne contactati la 0752621501 pentru confirmare.');
    ___arguments.context.pageData['clientActiv'] = false;
  }
}

/**
 * Dezactiveaza in mod Developer
 */
async function goToLinkOK() {
  if (((function () { return window.location.href })()) == 'https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/ui-builder/containers/Dispecer/index.html?page=Comenzi') {
    (function (message) { alert(message) })((String('Nu esti pe link-ul  corect. Fa un nou Bookmark la link-ul: https://calldelivery.ro') + String('')));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://calldelivery.ro', false, undefined);
  }
}

/**
 * OnPage enter
 * functie: Dezactivare
 */
async function dezactivare() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'dezactivatTemporar')) {
    ___arguments.context.pageData['showTextDezactivare'] = (['In acest moment capacitatea de livrare a livratorilor nostri ','este depasita si nu mai putem prelua alte comenzi.\n','Imediat ce livratorii nostri se vor elibera veti putea lansa alte comenzi.\n','Va multumim pentru intelegere!\n','CallDelivery Team',''].join(''));
  } else if (!(getObjectProperty(___arguments.context.appData, 'clientActiv'))) {
    ___arguments.context.pageData['showTextDezactivare'] = (['Contul dumneavoastra a fost dezactivat temporar ','pentru inactivitate sau pentru ca figurati cu restante la plata facturilor.\n','Va rugam sa luati legatura cu noi la 0752621501 pentru rezolvarea situatiei create.\n','Contul dumneavoastra se va reactiva imediat  ce situatia se va regla.\n','CallDelivery Team.',''].join(''));
  }
}

/**
 * Describe this function...
 */
async function user() {
  if ((getObjectProperty(___arguments.context.appData, 'user')) == null) {
    console.log('no user load');
    await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
    ___arguments.context.appData['user'] = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
    currentUser = (getObjectProperty(___arguments.context.appData, 'user'));
    currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  }
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'username'));
  currentUser = (getObjectProperty(___arguments.context.appData, 'user'));
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

/**
 * Describe this function...
 */
async function setings() {
  getRTSubscriptions().remove('updateSetariApp');
  ___arguments.context.appData['setariApp'] = ((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('setari/get')))).setEncoding('utf8').send(({ [`selected`]: ({ [`masterAdmin`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masteradmin')) }) })))[0]);
}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function cleanRT() {
  getRTSubscriptions().remove('RTComenzi');
  getRTSubscriptions().remove('updateSetariApp');
  getRTSubscriptions().remove('updateActivareClient');
  getRTSubscriptions().remove('updateComenzi');
  getRTSubscriptions().remove('createComanda');
  getRTSubscriptions().remove('LivratorActivNou');
  getRTSubscriptions().remove('LivratorActivUpdate');
  getRTSubscriptions().remove('LivratorActivDelete');
  getRTSubscriptions().remove('createLivratorActivExtern');
  getRTSubscriptions().remove('updateLivratorActivExtern');
  getRTSubscriptions().remove('DeleteComenzi');
  stopSetTimeout('timerLogout');
  stopSetTimeout('timerLogout1');
  stopSetTimeout('timerCounter');
}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function onMount() {
  await user();
  if ((getObjectProperty(___arguments.context.appData, 'client')) == null) {
    ___arguments.context.appData['client'] = ((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('client/get')))).setEncoding('utf8').send(({ [`selected`]: ({ [`masterName`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masterName')) }) })))[0]);
    ___arguments.context.appData['newBrand'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'brand'));
    ___arguments.context.appData['adresaRidicare'] = ((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('adresaridicare/get')))).setEncoding('utf8').send(({ [`selected`]: ({ [`adresa`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'adresaRidicare')) }) })))[0]);
    ___arguments.context.appData['dispecerActiv'] = ((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('dispecer/get')))).setEncoding('utf8').send(({ [`selected`]: ({ [`dispecer`]: (getObjectProperty(___arguments.context.appData, 'userName')) }) })))[0]);
    ___arguments.context.appData['newDefaultRidicare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'adresaRidicare')), 'default'));
    ___arguments.context.appData['clientActiv'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'activ'));
    ___arguments.context.appData['awb'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'awb'));
    ___arguments.context.appData['livrareMixta'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'livrareMixta'));
  }
  console.log(String('loaded Client: ') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName')));
}

/**
 * Describe this function...
 */
async function updatedDispecer() {
  ___arguments.context.appData['dispecerActiv'] = ((getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('dispecer/search')))).setEncoding('utf8').send(({ [`selected`]: ({ [`dispecer`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'username')) }) }))), 'docs'))[0]);
  await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(String(getObjectProperty(___arguments.context.appData, 'server')) + String('dispecer/')) + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'dispecerActiv')), '_id'))))).setEncoding('utf8').send(({ [`paginaCurenta`]: 'Comenzi' }));
  await Backendless.Messaging.publish('dispecerActiv', 'Activ pe comenzi', new Backendless.PublishOptions({ subtopic: 'Dispecer activ' }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
}

/**
 * Describe this function...
 */
async function interval() {
  fromTime = (new Date());
  toTime = (new Date());
  logoutTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  logoutTime.setHours('22');
  logoutTime.setMinutes('15');
  logoutTime.setSeconds('0');
  logoutTime.setMilliseconds('0');
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function countere() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (getObjectProperty(___arguments.context.appData, 'comenziActive')));
  ___arguments.context.appData['counterToateAzi'] = ((getObjectProperty(___arguments.context.appData, 'comenziActive')).length);
  ___arguments.context.appData['counterIL'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'IN LUCRU');
  })).length);
  ___arguments.context.appData['counterR'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'RIDICATA');
  })).length);
  ___arguments.context.appData['counterILiv'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'IN LIVRARE');
  })).length);
  ___arguments.context.appData['counterLiv'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'LIVRATA');
  })).length);
  ___arguments.context.appData['counterProgramate'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'PROGRAMATA');
  })).length);
  ___arguments.context.appData['counterAnulate'] = ((getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('comenzi/search')))).setEncoding('utf8').send(({ [`ranges`]: ({ [`programare`]: ({ [`min`]: (fromTime.valueOf()),[`max`]: (toTime.valueOf()) }) }),[`selected`]: ({ [`masterClient`]: (getObjectProperty(currentUser, 'masterName')),[`status`]: 'ANULATA' }) }))), 'docs')).length);
}


  ___arguments.context.appData['server'] = 'https://cd.superdev.ro/api/';
  console.log(getObjectProperty(___arguments.context.appData, 'server'));
  await cleanRT();
  await onMount();
  ___arguments.context.pageData['showComandaNoua'] = false;
  ___arguments.context.appData['Title'] = 'CallDeliveryApp V2.0';
  try {
    await setings();
    await onMount();

  } catch (error) {
    (function (message) { alert(message) })('Esti delogat.\nTe rog sa te loghezi din nou!');
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/dispecer/index.html?page=login', false, undefined);

  } finally {
    await setings();
    if ((getObjectProperty(___arguments.context.appData, 'client')) == null) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/dispecer/index.html?page=login', false, undefined);
    }
    await dezactivare();
    await atentionarePlata();
    ___arguments.context.appData['userEmail'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'userEmail'));
    ___arguments.context.appData['adresaRidicareUser'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'adresaRidicare'));
    ___arguments.context.appData['userName'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'username'));
    ___arguments.context.appData['masterEmail'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masterEmail'));
    ___arguments.context.appData['masterName'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masterName'));
    ___arguments.context.pageData['paginaCurenta'] = 'ComenziNew';
    console.log(String('user name: ') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'username')));
    await updatedDispecer();
    console.log(String('_id nou" ') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'dispecerActiv')), '_id')));
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'rol')) == 'MASTERADMIN') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://calldelivery.ro', false, undefined);
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'rol')) == 'LIVRATOR') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://calldelivery.ro', false, undefined);
    }
    await interval();
    ___arguments.context.pageData['livratorActivGet'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('livratoractiv/get')))).setEncoding('utf8').send(({ [`ranges`]: ({ [`created`]: ({ [`min`]: (fromTime.valueOf()),[`max`]: (toTime.valueOf()) }) }),[`selected`]: ({ [`activ`]: true }) })));
    ___arguments.context.pageData['nrLivratorActiv'] = ((getObjectProperty(___arguments.context.pageData, 'livratorActivGet')).length);
    ___arguments.context.appData['LivratorActiv'] = ((getObjectProperty(___arguments.context.pageData, 'livratorActivGet')).length);
    getRTSubscriptions().remove('LivratorActiv');

    ;(function(selector) {
      const callback = async message => {
          ___arguments.context.pageData['livratorActivGet'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('livratoractiv/get')))).setEncoding('utf8').send(({ [`ranges`]: ({ [`created`]: ({ [`min`]: (fromTime.valueOf()),[`max`]: (toTime.valueOf()) }) }),[`selected`]: ({ [`activ`]: true }) })));
      ___arguments.context.pageData['nrLivratorActiv'] = ((getObjectProperty(___arguments.context.pageData, 'livratorActivGet')).length);
      ___arguments.context.appData['LivratorActiv'] = ((getObjectProperty(___arguments.context.pageData, 'livratorActivGet')).length);
      console.log(String(message) + String(''));

      };

      const channel = getChannelInstance('livratorActiv');

      const options = [callback];

      if (selector) {
         options.unshift(selector);
      }

      channel.addMessageListener.apply(channel, options);

      getRTSubscriptions().add('LivratorActiv', () => channel.removeMessageListener.apply(channel, options));
    })('');
    ___arguments.context.pageData['showComandaNoua'] = true;
    ___arguments.context.pageData['filtruStatus'] = 'TOATE';
    ___arguments.context.pageData['fromTime'] = (fromTime.valueOf());
    ___arguments.context.pageData['toTime'] = (toTime.valueOf());

    ;(function() {
      const callback = async () => {
          ___arguments.context.pageData['pulseFaraLivrator'] = true;
      await new Promise(r => setTimeout(r, 3000 || 0));
      ___arguments.context.pageData['pulseFaraLivrator'] = false;

      };

      const timerId = 'pulseFaraLivrator';
      const timerDelay = 2000;

      runSetTimeout(timerId, callback, timerDelay)
    })()
    ___arguments.context.pageData['sumaNedecontata'] = 0;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('04cb1b29602b356bc67c30de63f593b3', (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('dispecer/get')))).setEncoding('utf8').send(({ [`selected`]: ({ [`userEmail`]: (getObjectProperty(___arguments.context.appData, 'userEmail')) }) }))));
    ___arguments.context.appData['comenziActive'] = (await BackendlessUI.Functions.Custom['fn_6b866624272cc426fbdc68d6122f46f8'](___arguments.context.appData, ___arguments.context.pageData, (fromTime.valueOf()), (toTime.valueOf()), (getObjectProperty(currentUser, 'masterName'))));
    await countere();
    getRTSubscriptions().remove('RTComenzi');

    ;(function(selector) {
      const callback = async message => {
          ___arguments.context.appData['comenziActive'] = (await BackendlessUI.Functions.Custom['fn_6b866624272cc426fbdc68d6122f46f8'](___arguments.context.appData, ___arguments.context.pageData, (fromTime.valueOf()), (toTime.valueOf()), (getObjectProperty(currentUser, 'masterName'))));
      await countere();

      };

      const channel = getChannelInstance((getObjectProperty(currentUser, 'masterName')));

      const options = [callback];

      if (selector) {
         options.unshift(selector);
      }

      channel.addMessageListener.apply(channel, options);

      getRTSubscriptions().add('RTComenzi', () => channel.removeMessageListener.apply(channel, options));
    })('');
    console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName'));
    console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'cui'));
    console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'nirc'));
    console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'nume_firma'));
    console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'adresa_firma'));
    console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));

  }

  },
  /* handler:onEnter */
/* handler:onLeave */
  async ['onLeave'](___arguments) {
    var currentUser;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function onLeave() {
  getRTSubscriptions().remove('updateSetariApp');
  getRTSubscriptions().remove('updateActivareClient');
  getRTSubscriptions().remove('updateComenzi');
  getRTSubscriptions().remove('createComanda');
  getRTSubscriptions().remove('LivratorActivNou');
  getRTSubscriptions().remove('LivratorActivUpdate');
  getRTSubscriptions().remove('LivratorActivDelete');
  getRTSubscriptions().remove('createLivratorActivExtern');
  getRTSubscriptions().remove('updateLivratorActivExtern');
  getRTSubscriptions().remove('DeleteComenzi');
  stopSetTimeout('timerLogout');
  stopSetTimeout('timerLogout1');
  stopSetTimeout('timerCounter');
}


  await onLeave();

  },
  /* handler:onLeave *//* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'Title'))

  },
  /* handler:onTitleAssignment *//* content */
}));

define('./pages/Comenzi/components/73712c1793d263f9c8dcdfd451233039/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
    var currentUser;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  await Backendless.UserService.logout();
  ___arguments.context.appData['currentUser'] = null;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },
  /* handler:onClick *//* content */
}));

define('./pages/Comenzi/components/bcd52ba2f5e422b6147ef62387ac8ead/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  onClick(___arguments) {
    
  },  
  /* handler:onClick *//* content */
}));

define('./pages/Comenzi/components/da36802a2e9c603706051115b7c476ef/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'status')) == 'LIVRATA')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ce2983dcac9718bc2661ea97e95a709', true);
  }

  },
  /* handler:onClick *//* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'comanda')),'',['(',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'cartier')),')-'].join(''),(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'adresaLivrare')),'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'bloc')) == 'BLOC' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'detaliiAdresa')) : '','','','','',['[',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'tarifare')),']'].join('')].join(''))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/Comenzi/components/11ff92dd151418d4164a38ac3bbeabf3/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function testMaps() {
  ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.superdev.ro/maps')).setEncoding('utf8').send(({ [`destinations`]: 'Aleea Rasinari 4 Cluj-Napoca',[`origins`]: 'Aleea Rasinari 2 Cluj-Napoca' })));
  ___arguments.context.pageData['testGoogle'] = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['','https://maps.googleapis.com/maps/api/geocode/json?address=','Aleea Rasinari 2 Cluj-Napoca','','&key=AIzaSyDC4mbqOev3A2j8-gaFSZ3GZ_2cQXAORBw&='].join('')))).setEncoding('utf8').send());
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function onLeave() {
  getRTSubscriptions().remove('updateNrComenzi');
  getRTSubscriptions().remove('updateComenzi');
  getRTSubscriptions().remove('createComanda');
  getRTSubscriptions().remove('createLivratorActivExtern');
  getRTSubscriptions().remove('updateLivratorActivExtern');
  getRTSubscriptions().remove('DeleteComenzi');
  getRTSubscriptions().remove('LivratorActivNou');
  getRTSubscriptions().remove('LivratorActivUpdate');
  getRTSubscriptions().remove('LivratorActivDelete');
  stopSetTimeout('timerLogout');
  stopSetTimeout('timerLogout1');
  stopSetTimeout('timerCounter');
}

/**
 * Describe this function...
 */
async function setInterval2() {
}

/**
 * Describe this function...
 */
async function calculCurse() {
}

/**
 * Describe this function...
 */
async function consumCurseIncluse() {
}


  try {
    await testMaps();

  } catch (error) {
    (function (message) { alert(message) })('Din pacate, din cauza unor probleme tehnice legate de server, nu se pot lansa comenzi in acest moment. Echipa tehnica lucreaza in acest moment pentru remedierea problemei.Va rugam reveniti mai tarziu. Pentru urgente va rugam sa luati legatura cu noi la 0752621501 sau sa puneti o copie a comenzii pe grupul de WhatsApp.');
    ___arguments.context.pageData['error'] = true;

  } finally {
    if (getObjectProperty(___arguments.context.pageData, 'error')) {
    } else {
      await onLeave();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ComandaNoua', undefined);
    }

  }

  },
  /* handler:onClick */
/* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var currentUser, endTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  endTime = (new Date());
  endTime.setHours('22');
  endTime.setMinutes('0');
  endTime.setSeconds('0');
  endTime.setMilliseconds('0');
  ___arguments.context.pageData['endTime'] = (endTime.valueOf());
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'telefonUser')) == 'admin' && (getObjectProperty(___arguments.context.pageData, 'nrLivratorActiv')) > 0) {
    ___arguments.context.pageData['showButonComandaNoua'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'nrLivratorActiv')) > 0 && (getObjectProperty(___arguments.context.pageData, 'endTime')) > (new Date())) {
    ___arguments.context.pageData['showButonComandaNoua'] = true;
  } else {
    ___arguments.context.pageData['showButonComandaNoua'] = false;
  }

  return (getObjectProperty(___arguments.context.pageData, 'showButonComandaNoua'))

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi/components/743be205cd4fb02920eab46326fe74a2/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, logoutTime, toTime, fromTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function onClick() {
  ___arguments.context.pageData['filtruStatus'] = 'IN LUCRU';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  ___arguments.context.appData['comenziActive'] = (await BackendlessUI.Functions.Custom['fn_6b866624272cc426fbdc68d6122f46f8'](___arguments.context.appData, ___arguments.context.pageData, (fromTime.valueOf()), (toTime.valueOf()), (getObjectProperty(___arguments.context.appData, 'masterName'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'IN LUCRU');
  })), -1, async (item) => {


   return (getObjectProperty(item, 'programare'));
  })));
}

/**
 * Describe this function...
 */
async function interval() {
  fromTime = (new Date());
  toTime = (new Date());
  logoutTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  logoutTime.setHours('22');
  logoutTime.setMinutes('15');
  logoutTime.setSeconds('0');
  logoutTime.setMilliseconds('0');
}


  await interval();
  await onClick();

  },
  /* handler:onClick *//* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['IN LUCRU(',(getObjectProperty(___arguments.context.appData, 'counterIL')),')'].join(''))

  },
  /* handler:onLabelAssignment *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'counterIL')) > 0)

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi/components/6ca4753ad184c287740c3cb65d534339/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['filtruStatus'] = 'PROGRAMATA';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'PROGRAMATA');
  })), -1, async (item) => {


   return (getObjectProperty(item, 'programare'));
  })));

  },
  /* handler:onClick *//* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['PROGRAMATE (',(getObjectProperty(___arguments.context.appData, 'counterProgramate')),')'].join(''))

  },
  /* handler:onLabelAssignment *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'counterProgramate'))

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi/components/4bb3ec747f27eb92cd6fb5ee83afc83f/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['filtruStatus'] = 'RIDICATA';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'RIDICATA');
  })), -1, async (item) => {


   return (getObjectProperty(item, 'programare'));
  })));

  },
  /* handler:onClick *//* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['RIDICATE (',(getObjectProperty(___arguments.context.appData, 'counterR')),')'].join(''))

  },
  /* handler:onLabelAssignment *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'counterR')) > 0)

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi/components/b1c7b00dfd06c6faf251e4f28359c3fe/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['filtruStatus'] = 'IN LIVRARE';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'IN LIVRARE');
  })), -1, async (item) => {


   return (getObjectProperty(item, 'programare'));
  })));

  },
  /* handler:onClick *//* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['IN LIVRARE (',(getObjectProperty(___arguments.context.appData, 'counterILiv')),')'].join(''))

  },
  /* handler:onLabelAssignment *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'counterILiv')) > 0)

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi/components/d4bbcc298e994b8be052ae051ec6520c/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, toTime, fromTime, logoutTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function onClick() {
  ___arguments.context.pageData['filtruStatus'] = 'TOATE';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  await interval();
  ___arguments.context.appData['comenziActive'] = (await BackendlessUI.Functions.Custom['fn_6b866624272cc426fbdc68d6122f46f8'](___arguments.context.appData, ___arguments.context.pageData, (fromTime.valueOf()), (toTime.valueOf()), (getObjectProperty(___arguments.context.appData, 'masterName'))));
  await countere();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await asyncListSort((getObjectProperty(___arguments.context.appData, 'comenziActive')), -1, async (item) => {


   return (getObjectProperty(item, 'programare'));
  })));
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function countere() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (getObjectProperty(___arguments.context.appData, 'comenziActive')));
  ___arguments.context.appData['counterToateAzi'] = ((getObjectProperty(___arguments.context.appData, 'comenziActive')).length);
  ___arguments.context.appData['counterIL'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'IN LUCRU');
  })).length);
  ___arguments.context.appData['counterR'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'RIDICATA');
  })).length);
  ___arguments.context.appData['counterILiv'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'IN LIVRARE');
  })).length);
  ___arguments.context.appData['counterLiv'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'LIVRATA');
  })).length);
  ___arguments.context.appData['counterProgramate'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'PROGRAMATA');
  })).length);
  ___arguments.context.appData['counterAnulate'] = ((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('comenzi/get')))).setEncoding('utf8').send(({ [`ranges`]: ({ [`programare`]: ({ [`min`]: (fromTime.valueOf()),[`max`]: (toTime.valueOf()) }) }),[`selected`]: ({ [`masterClient`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'masterName')),[`status`]: 'ANULATA' }) }))).length);
}

/**
 * Describe this function...
 */
async function interval() {
  fromTime = (new Date());
  toTime = (new Date());
  logoutTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  logoutTime.setHours('22');
  logoutTime.setMinutes('15');
  logoutTime.setSeconds('0');
  logoutTime.setMilliseconds('0');
}


  await onClick();

  },
  /* handler:onClick *//* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['TOATE PT AZI (',(getObjectProperty(___arguments.context.appData, 'counterToateAzi')),')'].join(''))

  },
  /* handler:onLabelAssignment */
/* content */
}));

define('./pages/Comenzi/components/04a791a6d346897b4f725b27b6c1564e/bundle.js', [], () => ({
  /* content */

  

/* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var currentUser;

  },
  /* handler:onLabelAssignment *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.pageData['sumaNedecontata']) > 0) {
    return (___arguments.context.pageData['pulseFaraLivrator']);
  } else {
    return false;
  }

  },  
/* handler:onDisplayAssignment */
/* content */
}));

define('./pages/Comenzi/components/f16cf98b8331e03f6ade6a5c03164c7b/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, toTime, fromTime, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['filtruStatus'] = 'LIVRATA';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'LIVRATA');
  })), -1, async (item) => {


   return (getObjectProperty(item, 'programare'));
  })));

  },
  /* handler:onClick *//* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Livrate azi (',(getObjectProperty(___arguments.context.appData, 'counterLiv')),')'].join(''))

  },
  /* handler:onLabelAssignment *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'counterLiv')) > 0)

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi/components/28bdcbf353368bf549bcd11f337293a8/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'livrator')) == 'FARA LIVRATOR' ? (getObjectProperty(___arguments.context.pageData, 'pulseFaraLivrator')) : true)

  },
  /* handler:onDisplayAssignment */
/* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'status')) == 'LIVRATA')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', true);
  }

  },
  /* handler:onClick *//* content */
}));

define('./pages/Comenzi/components/64e12ba2d6735d5c4a61fd41ec494173/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']) == 'FARA LIVRATOR' && (___arguments.context.pageData['pulseFaraLivrator']) == true) {
    return false;
  } else if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']) == 'FARA LIVRATOR' && (___arguments.context.pageData['pulseFaraLivrator']) == false) {
    return true;
  } else {
    return false;
  }

  },  
/* handler:onDisplayAssignment *//* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', true);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Comenzi/components/fbc633330bdb78ec260729c2f78c32b1/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    var toTime, fromTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  ___arguments.context.pageData['filtruStatus'] = 'ANULATA';
  ___arguments.context.pageData['cautaComanda'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('comenzi/get')))).setEncoding('utf8').send(({ [`ranges`]: ({ [`programare`]: ({ [`min`]: (fromTime.valueOf()),[`max`]: (toTime.valueOf()) }) }),[`selected`]: ({ [`masterClient`]: (getObjectProperty(___arguments.context.appData, 'masterName')),[`status`]: 'ANULATA' }) }))));

  },
  /* handler:onClick *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'counterAnulate')) > 0)

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi/components/9941b43a927281ef08063bed3cf97da8/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ArhivaComenzi', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Comenzi/components/467a622b1ebb0ef371c8523e83fdce57/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
    function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['locatiaLivrator'] = (((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['livrator = \'',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']),'\' AND activ = TRUE','','',''].join(''))).setProperties('shareLocation').setSortBy('created desc').setPageSize(1)))[0])['shareLocation']);
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((subsequenceFromEndLast((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['locatiaLivrator']), 40)), true, null);

  },  
  /* handler:onClick */
/* content */
}));

define('./pages/Comenzi/components/cc6e5f6784f41dd25d3407cd2a471d5b/bundle.js', [], () => ({
  /* content */

  
/* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'status')) == 'LIVRATA')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', true);
  }

  },
  /* handler:onClick *//* content */
}));

define('./pages/Comenzi/components/92f796fabc43d5d2e6dacde5cac34b05/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async ['onChange'](___arguments) {
    var currentUser, toTime, fromTime, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function countere() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (getObjectProperty(___arguments.context.pageData, 'comenziActive')));
  ___arguments.context.appData['counterToateAzi'] = ((getObjectProperty(___arguments.context.pageData, 'comenziActive')).length);
  ___arguments.context.appData['counterIL'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'IN LUCRU');
  })).length);
  ___arguments.context.appData['counterR'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'RIDICATA');
  })).length);
  ___arguments.context.appData['counterILiv'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'IN LIVRARE');
  })).length);
  ___arguments.context.appData['counterLiv'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'LIVRATA');
  })).length);
  ___arguments.context.appData['counterProgramate'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'PROGRAMATA');
  })).length);
  ___arguments.context.appData['counterAnulate'] = (getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('comenzi/search')))).setEncoding('utf8').send(({ [`ranges`]: ({ [`programare`]: ({ [`min`]: (fromTime.valueOf()),[`max`]: (toTime.valueOf()) }) }),[`selected`]: ({ [`masterClient`]: (getObjectProperty(currentUser, 'masterName')),[`status`]: 'ANULATA' }) }))), 'docs'));
}


  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['emailLivrator'] = (getObjectProperty(((await Backendless.Data.of('Livratori').find(Backendless.DataQueryBuilder.create().setWhereClause((['livrator = \'',___arguments.value,'\''].join(''))).setProperties('emailLivrator').setPageSize(1)))[0]), 'emailLivrator'));
  await BackendlessUI.Functions.Custom['fn_48ca14785afeef6f05dd11f72b6a3c4f']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), '_id')), ({ [`emailLivrator`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'emailLivrator')),[`livrator`]: ___arguments.value }));
  await countere();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', true);

  },
  /* handler:onChange *//* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, toTime, fromTime, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  if (!(await Promise.all((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))).setSortBy('livrator asc').setGroupBy('livrator').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'livrator')),[`value`]: (getObjectProperty(item, 'livrator')) });}))).length) {
    return [];
  } else {
    return (await Promise.all((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))).setSortBy('livrator asc').setGroupBy('livrator').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'livrator')),[`value`]: (getObjectProperty(item, 'livrator')) });})));
  }

  },
  /* handler:onOptionsAssignment *//* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);

  },
  /* handler:onVisibilityChange *//* content */
}));

define('./pages/Comenzi/components/61a9b97acc4eecc3f96c1ec8a41aa6f3/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'status')) == 'LIVRATA')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ce2983dcac9718bc2661ea97e95a709', true);
  }

  },
  /* handler:onClick *//* content */
}));

define('./pages/Comenzi/components/dada151a20a580fbe28cd846b07a412a/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function goToDetail() {
  ___arguments.context.appData['selectComanda'] = ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7');
  getRTSubscriptions().remove('LivratorActivNou');
  getRTSubscriptions().remove('LivratorActivUpdate');
  getRTSubscriptions().remove('LivratorActivDelete');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('EditareComandaNew', ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), '_id')) }));
}


  await goToDetail();

  },
  /* handler:onClick *//* content */
}));

define('./pages/Comenzi/components/e49fe3cc6d3de256d5964aa790a7b5c5/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick *//* content */
}));

define('./pages/Comenzi/components/f0deedfdc66148ed83a8aad41fc69cf6/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ce2983dcac9718bc2661ea97e95a709', true);

  },
  /* handler:onClick *//* content */
}));

define('./pages/Comenzi/components/7ce2983dcac9718bc2661ea97e95a709/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'status')) == 'LIVRATA')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ce2983dcac9718bc2661ea97e95a709', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', true);
  }

  },
  /* handler:onClick *//* content */
}));

define('./pages/Comenzi/components/af9aa7521883169e2d06bd6665415ebd/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async ['onChange'](___arguments) {
    var currentUser, toTime, fromTime, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function countere() {
  ___arguments.context.appData['comenziActive'] = (await BackendlessUI.Functions.Custom['fn_6b866624272cc426fbdc68d6122f46f8'](___arguments.context.appData, ___arguments.context.pageData, (fromTime.valueOf()), (toTime.valueOf()), (getObjectProperty(currentUser, 'masterName'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (getObjectProperty(___arguments.context.pageData, 'comenziActive')));
  ___arguments.context.appData['counterToateAzi'] = ((getObjectProperty(___arguments.context.pageData, 'comenziActive')).length);
  ___arguments.context.appData['counterIL'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'IN LUCRU');
  })).length);
  ___arguments.context.appData['counterR'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'RIDICATA');
  })).length);
  ___arguments.context.appData['counterILiv'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'IN LIVRARE');
  })).length);
  ___arguments.context.appData['counterLiv'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'LIVRATA');
  })).length);
  ___arguments.context.appData['counterProgramate'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'comenziActive')), async (item) => {


   return ((getObjectProperty(item, 'status')) == 'PROGRAMATA');
  })).length);
  ___arguments.context.appData['counterAnulate'] = (getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String(getObjectProperty(___arguments.context.appData, 'server')) + String('comenzi/search')))).setEncoding('utf8').send(({ [`ranges`]: ({ [`programare`]: ({ [`min`]: (fromTime.valueOf()),[`max`]: (toTime.valueOf()) }) }),[`selected`]: ({ [`masterClient`]: (getObjectProperty(currentUser, 'masterName')),[`status`]: 'ANULATA' }) }))), 'docs'));
}


  await BackendlessUI.Functions.Custom['fn_48ca14785afeef6f05dd11f72b6a3c4f']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), '_id')), ({ [`status`]: ___arguments.value }), ___arguments.context.appData);
  await countere();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcc33a0121a7515ac7b4ad64c199ef8a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ce2983dcac9718bc2661ea97e95a709', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);

  },
  /* handler:onChange *//* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'livrator')) == 'FARA LIVRATOR')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}));

define('./pages/Comenzi/components/2d874835a2834dd4ce9300e1855b7a31/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10e8745a18ddd4014d2d04e3c6a97448', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', true);

  },  
/* handler:onClick */
/* content */
}));

define('./pages/Comenzi/components/0e224a779158820edeeb882d6049d37e/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('DispecerActiv').bulkUpdate( (['userEmail = \'',(getObjectProperty(___arguments.context.pageData, 'userEmail')),'\'','','',''].join('')), ({ [`paginaCurenta`]: 'AWB' }) );
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://cd.superdev.ro/pdf/get-pdf/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'awb')),''].join('')), true, undefined);

  },
  /* handler:onClick *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'optiuneAwb'))

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi/components/65d636b2d51c309a418d96b3354cb338/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['notificare']) == 'NOTIFICAT')

  },  
/* handler:onDisplayAssignment */
/* content */
}));

define('./pages/Comenzi/components/2667ddefdd3bebfba61c41076a32e0db/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['notificare']) == 'CONFIRMAT')

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi/components/36071111c67cdf5a8f412311202da00f/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var ceas;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([['<b>COMENZI[new]\nTOATE PT AZI(',(getObjectProperty(___arguments.context.appData, 'counterToateAzi')),')</b> '].join(''),(getObjectProperty(___arguments.context.pageData, 'ora')) < 10 ? String('0') + String(getObjectProperty(___arguments.context.pageData, 'ora')) : (getObjectProperty(___arguments.context.pageData, 'ora')),':',(getObjectProperty(___arguments.context.pageData, 'min')) < 10 ? String('0') + String(getObjectProperty(___arguments.context.pageData, 'min')) : (getObjectProperty(___arguments.context.pageData, 'min')),':',(getObjectProperty(___arguments.context.pageData, 'sec')) < 10 ? String('0') + String(getObjectProperty(___arguments.context.pageData, 'sec')) : (getObjectProperty(___arguments.context.pageData, 'sec')),'',''].join(''))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/Comenzi/components/afa5936736519101d284a42ee7514b79/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'tipLivrare')) == 'RIDICARE')

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi/components/9cf694d1705b950ec1988cab6f2ba51d/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'adreseRidicareMultiple'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}));

define('./pages/Comenzi/components/17c64fd5847c5791504458a4624289b7/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Decont', null);

  },  
/* handler:onClick *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.pageData['sumaNedecontata']) > 0)

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi/components/5a6584ba73283cd8d5ce60297291a589/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'telefonUser')) == 'admin' && (getObjectProperty(___arguments.context.pageData, 'nrLivratorActiv')) > 0) {
    ___arguments.context.pageData['showOut'] = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'nrLivratorActiv')) > 0 && (getObjectProperty(___arguments.context.pageData, 'endTime')) > (new Date())) {
    ___arguments.context.pageData['showOut'] = false;
  } else {
    ___arguments.context.pageData['showOut'] = true;
  }

  return (getObjectProperty(___arguments.context.pageData, 'showOut'))

  },
  /* handler:onDisplayAssignment *//* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'nrLivratorActiv')) == 0) {
    ___arguments.context.pageData['showText'] = '<b>Ne pare rau, dar in acest moment\nnu avem livratori activi!</b>';
  } else if ((getObjectProperty(___arguments.context.pageData, 'endTime')) < (new Date())) {
    ___arguments.context.pageData['showText'] = '<b>Suntem in afara programului.\nPreluam comenzi doar pana la ora 22.00 !</b>';
  }

  return (getObjectProperty(___arguments.context.pageData, 'showText'))

  },
  /* handler:onContentAssignment */
  /* content */
}));

define('./pages/Comenzi/components/4a4ed1bb2f4aaa6d77ed812e78dc8924/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'incasarePos')) > 0)

  },
  /* handler:onDisplayAssignment *//* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Comision POS: ','','','',Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'comisionPos')) * 100) / 100,' Lei'].join(''))

  },
  /* handler:onLabelAssignment */
  /* content */
}));

define('./pages/Comenzi/components/993774b5eeca60910d18bb86c8b1d442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('131998d407f1946a6af77847987b803c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi/components/131998d407f1946a6af77847987b803c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('131998d407f1946a6af77847987b803c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('993774b5eeca60910d18bb86c8b1d442', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi/components/a995cd07ba763cef39944e02768671d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('131998d407f1946a6af77847987b803c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('993774b5eeca60910d18bb86c8b1d442', true);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('131998d407f1946a6af77847987b803c', false);

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/Comenzi/components/1ce87ecf56de7c01bffa61d1dc291cc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('TextSMS', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi/components/99a9889ba79757d6978b55088647a4f6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.dataModel['paginaCurenta'] = 'Comenzi';

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Comenzi/components/e3db76478f83de873bd3e5ca11176e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('99a9889ba79757d6978b55088647a4f6'), 'masterClient')),'(ridicare: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('99a9889ba79757d6978b55088647a4f6'), 'adresaRidicare')),') ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('99a9889ba79757d6978b55088647a4f6'), 'masterName')),'',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Comenzi/components/f47fce8dbcaf12268c831c9d03eda3d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'distance')) / 1000)))) + String('Km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Comenzi/components/4a0a3e5d497261d239e501e3ae4a0807/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'livrareExtern')) && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'multiBrand')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi/components/bcc33a0121a7515ac7b4ad64c199ef8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'status')) == 'LIVRATA')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcc33a0121a7515ac7b4ad64c199ef8a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi/components/8118480483f7235912e6fa2a251141da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Livratori', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi/components/835b602e0386b55a9e5c21ade2d2b2e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('131998d407f1946a6af77847987b803c', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi/components/0fbf7f94b9aaa5f41f73ced6464b9ce7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['','','','',((___arguments.context.appData['setariApp'])['textAnunt']),''].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Comenzi/components/0c3a41a7a0cf22169bbba7778d1c89bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pulseFaraLivrator')) && (getObjectProperty(___arguments.context.pageData, 'clientActiv'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c3a41a7a0cf22169bbba7778d1c89bd'))['background-color'] = 'red';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c3a41a7a0cf22169bbba7778d1c89bd'))['background-color'] = 'green';
  }

  return ((getObjectProperty(___arguments.context.pageData, 'showComandaNoua')) && !(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'dezactivatTemporar')) && (getObjectProperty(___arguments.context.pageData, 'clientActiv')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi/components/5e5171b60889a0faf34c38fdc4919155/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('131998d407f1946a6af77847987b803c', false);

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((getObjectProperty(___arguments.context.appData, 'setariApp')), 'appActiva')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi/components/290da3498f4648fc2c7b55d17d09f364/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'clientActiv')) || (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'dezactivatTemporar')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi/components/6b1c7743f5034d643525d29d0fa82ff4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showTextDezactivare'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Comenzi/components/932caf6ba075e097061ee816f98c2745/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    /**
 * Describe this function...
 */
async function onClick() {
  ___arguments.context.pageData['filtruStatus'] = 'GO';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));
}


  await onClick();

  },  
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (['GO IN PREPARARE (',(___arguments.context.appData['counterGO']),')'].join(''))

  },  
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['pulseFaraLivrator']) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('932caf6ba075e097061ee816f98c2745'))['background-color'] = 'green';
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('932caf6ba075e097061ee816f98c2745'))['background-color'] = '#3D3D3D';
  }

  return ((___arguments.context.appData['counterGO']) > 0)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi/components/85ecfcbae9eb3111460c5094250ca54b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pulseFaraLivrator')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'status')) == 'GO') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85ecfcbae9eb3111460c5094250ca54b'))['background-color'] = 'green';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85ecfcbae9eb3111460c5094250ca54b'))['background-color'] = '#202020';
  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi/components/f225757c7c81df7e4396adea32067991/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48d863719ee6e8497d63ff54c807dc7b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f225757c7c81df7e4396adea32067991', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi/components/f33211f4d186da87173edd6859b37f2b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48d863719ee6e8497d63ff54c807dc7b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f225757c7c81df7e4396adea32067991', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi/components/d57a8b7ef1e4483f83df30ae83275969/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var currentUser;

/**
 * Describe this function...
 */
async function onClick() {
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.pageData['filtruStatus'] = 'TOATE';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_cff56ffe779e610ecf21eb93303266a5'](currentUser)));
}


  await onClick();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi/components/40d4d80a23a8e7ee32eb74ec66f83d64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Comenzi-BKL', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi/components/4d7a208c0fa14c1b3f1b6971f8f31204/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var ceas;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function ceas2() {
  stopSetTimeout('ceas');

  ;(function() {
    const callback = async () => {
        ceas = (new Date());
    ___arguments.context.pageData['ora'] = (new Date(ceas).getHours());
    ___arguments.context.pageData['min'] = (new Date(ceas).getMinutes());
    ___arguments.context.pageData['sec'] = (new Date(ceas).getSeconds());

    };

    const timerId = 'ceas';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
}


  await ceas2();

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/Comenzi-BKL/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, object, toTime, fromTime, logoutTime, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function atentionarePlata() {
  ___arguments.context.pageData['clientActiv'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'activ'));
  if ((new Date((new Date())).getDay()) == 1 && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'areRestantePlata'))) {
    (function (message) { alert(message) })('Atentie, figurati in evidentele noastre cu restante la plata facturilor. Va rugam sa efectuati platile restante. Va multumim. CallDelivery Team');
  } else if ((new Date((new Date())).getDay()) == 2 && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'areRestantePlata'))) {
    (function (message) { alert(message) })('Atentie, azi e ultima zi de plata a facturilor restante. Daca ai restante la plata facturilor, contul tau ar putea fi suspendat pana la stingerea soldului. Multumim pentru intelegere.');
  } else if ((new Date((new Date())).getDay()) > 2 && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'areRestantePlata'))) {
    await Backendless.Data.of('Client').bulkUpdate( (['masterName = \'',(getObjectProperty(currentUser, 'masterName')),'\''].join('')), ({ 'activ': false }) );
    (function (message) { alert(message) })('Contul dumeavoastra este dezactivat pentru neplata facturilor restante. Va rugam sa efectuati platile si sa ne contactati la 0752621501 pentru confirmare.');
    ___arguments.context.pageData['clientActiv'] = false;
  }
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

/**
 * Describe this function...
 */
async function dezactivare() {
  if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'dezactivatTemporar')) {
    ___arguments.context.pageData['showTextDezactivare'] = (['In acest moment capacitatea de livrare a livratorilor nostri ','este depasita si nu mai putem prelua alte comenzi.\n','Imediat ce livratorii nostri se vor elibera veti putea lansa alte comenzi.\n','Va multumim pentru intelegere!\n','CallDelivery Team',''].join(''));
  } else if (!(getObjectProperty(___arguments.context.pageData, 'clientActiv'))) {
    ___arguments.context.pageData['showTextDezactivare'] = (['Contul dumneavoastra a fost dezactivat temporar ','pentru inactivitate sau pentru ca figurati cu restante la plata facturilor.\n','Va rugam sa luati legatura cu noi la 0752621501 pentru rezolvarea situatiei create.\n','Contul dumneavoastra se va reactiva imediat  ce situatia se va regla.\n','CallDelivery Team.',''].join(''));
  }

  ;(function(whereClause) {
    const callback = async object => {
        ___arguments.context.appData['client'] = ((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(getObjectProperty(currentUser, 'masterName')),'\''].join(''))).setPageSize(1)))[0]);
    ___arguments.context.pageData['clientActiv'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'activ'));
    if (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'dezactivatTemporar')) {
      ___arguments.context.pageData['showTextDezactivare'] = (['In acest moment capacitatea de livrare a livratorilor nostri ','este depasita si nu mai putem prelua alte comenzi.\n','Imediat ce livratorii nostri se vor elibera veti putea lansa alte comenzi.\n','Va multumim pentru intelegere!\n','CallDelivery Team',''].join(''));
    } else if (!(getObjectProperty(___arguments.context.pageData, 'clientActiv'))) {
      ___arguments.context.pageData['showTextDezactivare'] = (['Contul dumneavoastra a fost dezactivat temporar ','pentru inactivitate sau pentru ca figurati cu restante la plata facturilor.\n','Va rugam sa luati legatura cu noi la 0752621501 pentru rezolvarea situatiei create.\n','Contul dumneavoastra se va reactiva imediat  ce situatia se va regla.\n','CallDelivery Team.',''].join(''));
    }

    };

    const rtHandlers = Backendless.Data.of('Client').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add('updateActivareClient', () => rtHandlers.removeUpdateListener(callback));

  })('');
    }

/**
 * Dezactiveaza in mod Developer
 */
async function goToLinkOK() {
  if (((function () { return window.location.href })()) == 'https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/ui-builder/containers/Dispecer/index.html?page=Comenzi') {
    (function (message) { alert(message) })((String('Nu esti pe link-ul  corect. Fa un nou Bookmark la link-ul: https://calldelivery.ro') + String('')));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://calldelivery.ro', false, undefined);
  }
}

/**
 * Describe this function...
 */
async function setings() {
  getRTSubscriptions().remove('updateSetariApp');
  ___arguments.context.appData['setariApp'] = ((await Backendless.Data.of('setariApp').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterAdmin = \'',(getObjectProperty(currentUser, 'masteradmin')),'\''].join(''))).setPageSize(1)))[0]);

  ;(function(whereClause) {
    const callback = async object => {
        ___arguments.context.appData['setariApp'] = ((await Backendless.Data.of('setariApp').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterAdmin = \'',(getObjectProperty(currentUser, 'masteradmin')),'\''].join(''))).setPageSize(1)))[0]);

    };

    const rtHandlers = Backendless.Data.of('setariApp').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add('updateSetariApp', () => rtHandlers.removeUpdateListener(callback));

  })('');
    }

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function cleanRT() {
  getRTSubscriptions().remove('updateSetariApp');
  getRTSubscriptions().remove('updateActivareClient');
  getRTSubscriptions().remove('updateComenzi');
  getRTSubscriptions().remove('createComanda');
  getRTSubscriptions().remove('LivratorActivNou');
  getRTSubscriptions().remove('LivratorActivUpdate');
  getRTSubscriptions().remove('LivratorActivDelete');
  getRTSubscriptions().remove('createLivratorActivExtern');
  getRTSubscriptions().remove('updateLivratorActivExtern');
  getRTSubscriptions().remove('DeleteComenzi');
  stopSetTimeout('timerLogout');
  stopSetTimeout('timerLogout1');
  stopSetTimeout('timerCounter');
}

/**
 * Describe this function...
 */
async function onMount() {
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if ((getObjectProperty(___arguments.context.appData, 'client')) == null) {
    ___arguments.context.appData['client'] = ((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(getObjectProperty(currentUser, 'masterName')),'\''].join(''))).setPageSize(1)))[0]);
    ___arguments.context.appData['newBrand'] = (getObjectProperty(((await Backendless.Data.of('BrandClient').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterClient = \'',(getObjectProperty(currentUser, 'masterName')),'\' AND default = TRUE'].join(''))).setPageSize(1)))[0]), 'brand'));
    ___arguments.context.appData['adresaRidicare'] = ((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['adresa = \'',(getObjectProperty(currentUser, 'adresaRidicare')),'\'','','',''].join(''))).setPageSize(1)))[0]);
    ___arguments.context.appData['newDefaultRidicare'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'adresaRidicare')), 'default'));
    ___arguments.context.pageData['clientActiv'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'activ'));
  }
  console.log(String('loaded Client: ') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName')));
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function infoComenzi() {
  ___arguments.context.appData['comenziAzi'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\' AND programare >=',(fromTime.valueOf()),' AND programare <=',(toTime.valueOf()),'','','',''].join('')))));
  ___arguments.context.appData['kmAzi'] = ((getObjectProperty(___arguments.context.appData, 'comenziAzi')) > 0 ? (await Promise.all((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\' AND programare>=',(fromTime.valueOf()),' AND programare<=',(toTime.valueOf()),'','','',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'distance')) / 1000);}))).reduce(function(x, y) {return x + y;}) : 0);
  ___arguments.context.appData['tarifareAzi'] = ((getObjectProperty(___arguments.context.appData, 'comenziAzi')) > 0 ? (await Promise.all((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterClient = \'',(getObjectProperty(currentUser, 'masterName')),'\' AND programare >=',(fromTime.valueOf()),' AND programare <=',(toTime.valueOf()),'','','',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tarifare'));}))).reduce(function(x, y) {return x + y;}) : 0);
  ___arguments.context.appData['sumarZi'] = (['Sumar ziua curenta:\n','Total comenzi azi: ',Math.round((getObjectProperty(___arguments.context.appData, 'comenziAzi')) * 100) / 100,'\nKm comenzi: ',Math.round((getObjectProperty(___arguments.context.appData, 'kmAzi')) * 100) / 100,'Km.\nMedie km/comanda: ',Math.round(((getObjectProperty(___arguments.context.appData, 'kmAzi')) / (getObjectProperty(___arguments.context.appData, 'comenziAzi'))) * 100) / 100,'Km\nTarifare comenzi: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((getObjectProperty(___arguments.context.appData, 'tarifareAzi')))),'Lei.\nMedie tarifare/comanda: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((getObjectProperty(___arguments.context.appData, 'tarifareAzi')) / (getObjectProperty(___arguments.context.appData, 'comenziAzi'))))),'Lei'].join(''));
}

/**
 * Describe this function...
 */
async function countere() {
  ___arguments.context.appData['counterAnulate'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'ANULATA\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
  ___arguments.context.appData['counterToateAzi'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND programare >= ',(fromTime.valueOf()),' AND status != \'ANULATA\' AND programare <= ',(toTime.valueOf())].join('')))));
  ___arguments.context.appData['counterProgramate'] = (await Backendless.Data.of('ComenziActive').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'PROGRAMATA\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
  ___arguments.context.appData['counterIL'] = (await Backendless.Data.of('ComenziActive').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'IN LUCRU\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
  ___arguments.context.appData['counterGO'] = (await Backendless.Data.of('ComenziActive').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'GO\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
  ___arguments.context.appData['counterR'] = (await Backendless.Data.of('ComenziActive').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'RIDICATA\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
  ___arguments.context.appData['counterILiv'] = (await Backendless.Data.of('ComenziActive').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'IN LIVRARE\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
  ___arguments.context.appData['counterLiv'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'LIVRATA\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
}


  await cleanRT();
  ___arguments.context.pageData['showComandaNoua'] = false;
  ___arguments.context.appData['Title'] = 'CallDeliveryApp V2.0';
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  try {
    await setings();
    await onMount();

  } catch (error) {
    (function (message) { alert(message) })('Esti delogat.\nTe rog sa te loghezi din nou!');
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/dispecer/index.html?page=login', false, undefined);

  } finally {
    await setings();
    if (!(await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/dispecer/index.html?page=login', false, undefined);
    }
    await onMount();
    await dezactivare();
    await atentionarePlata();
    ___arguments.context.appData['userEmail'] = (getObjectProperty(currentUser, 'userEmail'));
    ___arguments.context.appData['userName'] = (getObjectProperty(currentUser, 'username'));
    ___arguments.context.appData['masterEmail'] = (getObjectProperty(currentUser, 'masterEmail'));
    ___arguments.context.pageData['paginaCurenta'] = 'Comenzi';
    await Backendless.Data.of('DispecerActiv').bulkUpdate( (['userEmail = \'',(getObjectProperty(currentUser, 'userEmail')),'\'','','',''].join('')), ({ 'paginaCurenta': 'Comenzi' }) );
    if ((getObjectProperty(currentUser, 'rol')) == 'MASTERADMIN') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://calldelivery.ro', false, undefined);
    } else if ((getObjectProperty(currentUser, 'rol')) == 'LIVRATOR') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://calldelivery.ro', false, undefined);
    }
    fromTime = (new Date());
    toTime = (new Date());
    logoutTime = (new Date());
    fromTime.setHours('0');
    fromTime.setMinutes('0');
    fromTime.setSeconds('0');
    fromTime.setMilliseconds('0');
    toTime.setHours('23');
    toTime.setMinutes('59');
    toTime.setSeconds('59');
    toTime.setMilliseconds('999');
    logoutTime.setHours('22');
    logoutTime.setMinutes('15');
    logoutTime.setSeconds('0');
    logoutTime.setMilliseconds('0');
    ___arguments.context.pageData['nrLivratorActiv'] = (await Backendless.Data.of('LivratorActiv').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['created >',(fromTime.valueOf()),' AND created <',(toTime.valueOf()),' AND activ = TRUE'].join('')))));
    ___arguments.context.appData['LivratorActiv'] = (await Backendless.Data.of('LivratorActiv').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['tipLivrator = \'EXTERN\' AND activ=true',' AND created >=',(fromTime.valueOf()),' AND created <=',(toTime.valueOf()),'','','','',''].join('')))));
    ___arguments.context.pageData['showComandaNoua'] = true;
    ___arguments.context.pageData['filtruStatus'] = 'TOATE';
    ___arguments.context.pageData['fromTime'] = (fromTime.valueOf());
    ___arguments.context.pageData['toTime'] = (toTime.valueOf());
    ___arguments.context.pageData['sumaNedecontata'] = (await BackendlessUI.Functions.Custom['fn_eb0fab0b577e4258db7644dcf6560004']((getObjectProperty(currentUser, 'masterEmail'))));

    ;(function() {
      const callback = async () => {
          ___arguments.context.pageData['pulseFaraLivrator'] = true;
      await new Promise(r => setTimeout(r, 3000 || 0));
      ___arguments.context.pageData['pulseFaraLivrator'] = false;

      };

      const timerId = 'pulseFaraLivrator';
      const timerDelay = 2000;

      runSetTimeout(timerId, callback, timerDelay)
    })()
    await infoComenzi();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('04cb1b29602b356bc67c30de63f593b3', (await Backendless.Data.of('DispecerActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['userEmail =\'',(getObjectProperty(___arguments.context.appData, 'userEmail')),'\'','','','','',''].join(''))).setPageSize(1))));
    ___arguments.context.pageData['showObjects'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\' AND programare >=',(fromTime.valueOf()),' AND programare <=',(toTime.valueOf()),'','',!((getObjectProperty(___arguments.context.pageData, 'cautaComanda')) == null) ? [' AND search LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'cautaComanda')),'%\''].join('') : null,''].join('')))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('ComenziActive').find(Backendless.DataQueryBuilder.create().setWhereClause(([' masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\'','  AND programare >=',(fromTime.valueOf()),' AND programare <=',(toTime.valueOf()),'','','','',''].join(''))).setSortBy('created desc').setPageSize(100))));
    ___arguments.context.appData['counterToateAzi'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND programare >= ',(fromTime.valueOf()),' AND status != \'ANULATA\' AND programare <= ',(toTime.valueOf())].join('')))));
    ___arguments.context.appData['counterProgramate'] = (await Backendless.Data.of('ComenziActive').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'PROGRAMATA\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
    ___arguments.context.appData['counterIL'] = (await Backendless.Data.of('ComenziActive').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'IN LUCRU\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
    ___arguments.context.appData['counterGO'] = (await Backendless.Data.of('ComenziActive').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'GO\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
    ___arguments.context.appData['counterR'] = (await Backendless.Data.of('ComenziActive').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'RIDICATA\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
    ___arguments.context.appData['counterILiv'] = (await Backendless.Data.of('ComenziActive').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'IN LIVRARE\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
    ___arguments.context.appData['counterLiv'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'LIVRATA\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));
    ___arguments.context.appData['counterAnulate'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(getObjectProperty(currentUser, 'masterEmail')),'\'',' AND status = \'ANULATA\'  AND programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf())].join('')))));

    ;(function(whereClause) {
      const callback = async object => {
          (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('ComenziActive').find(Backendless.DataQueryBuilder.create().setWhereClause((['programare >=',(fromTime.valueOf()),' AND programare <=',(toTime.valueOf()),' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\'',''].join(''))).setSortBy('programare desc').setPageSize(100))));
      await countere();

      };

      const rtHandlers = Backendless.Data.of('Comenzi').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addCreateListener.apply(rtHandlers, options);

      getRTSubscriptions().add('createComanda', () => rtHandlers.removeCreateListener(callback));

    })((['programare >=',(fromTime.valueOf()),' AND programare <=',(toTime.valueOf()),' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\'',''].join('')));

    ;(function(whereClause) {
      const callback = async object => {
          console.log('comanda update');
      console.log(object);
      if ((getObjectProperty(___arguments.context.pageData, 'filtruStatus')) == 'TOATE' || (getObjectProperty(___arguments.context.pageData, 'filtruStatus')) == null) {
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['programare >=',(fromTime.valueOf()),' AND programare <=',(toTime.valueOf()),' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\'',' AND status != \'ANULATA\''].join(''))).setSortBy('programare desc').setPageSize(100))));
      } else if ((getObjectProperty(___arguments.context.pageData, 'filtruStatus')) == 'LIVRATA') {
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_d98d91bd0f197b0a281b6509b663adc7'](___arguments.context.appData, ___arguments.context.pageData)));
      } else {
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));
      }
      await countere();
      ___arguments.context.appData['sumaNedecontata'] = (await BackendlessUI.Functions.Custom['fn_eb0fab0b577e4258db7644dcf6560004']((getObjectProperty(currentUser, 'masterEmail'))));

      };

      const rtHandlers = Backendless.Data.of('Comenzi').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addUpdateListener.apply(rtHandlers, options);

      getRTSubscriptions().add('updateComenzi', () => rtHandlers.removeUpdateListener(callback));

    })((['programare >=',(fromTime.valueOf()),' AND programare <=',(toTime.valueOf()),' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\'',' AND status != \'ANULATA\''].join('')));

    ;(function(whereClause) {
      const callback = async object => {
          console.log('comanda stearsa');
      console.log(object);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
      if ((getObjectProperty(___arguments.context.pageData, 'filtruStatus')) == 'TOATE' || (getObjectProperty(___arguments.context.pageData, 'filtruStatus')) == null) {
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['programare >=',(fromTime.valueOf()),' AND programare <=',(toTime.valueOf()),' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\'',' AND status != \'ANULATA\''].join(''))).setSortBy('programare desc').setPageSize(100))));
      } else if ((getObjectProperty(___arguments.context.pageData, 'filtruStatus')) == 'LIVRATA') {
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_d98d91bd0f197b0a281b6509b663adc7'](___arguments.context.appData, ___arguments.context.pageData)));
      } else {
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));
      }
      await countere();
      ___arguments.context.appData['sumaNedecontata'] = (await BackendlessUI.Functions.Custom['fn_eb0fab0b577e4258db7644dcf6560004']((getObjectProperty(currentUser, 'masterEmail'))));

      };

      const rtHandlers = Backendless.Data.of('Comenzi').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addDeleteListener.apply(rtHandlers, options);

      getRTSubscriptions().add('DeleteComenzi', () => rtHandlers.removeDeleteListener(callback));

    })((['programare >=',(fromTime.valueOf()),' AND programare <=',(toTime.valueOf()),' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\'',' AND status != \'ANULATA\''].join('')));
      console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'masterName'));
    console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'cui'));
    console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'nirc'));
    console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'nume_firma'));
    console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'adresa_firma'));
    console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'tarifareKm'));

  }

  },
  /* handler:onEnter */
/* handler:onLeave */
  async onLeave(___arguments) {
    var currentUser;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function onLeave() {
  getRTSubscriptions().remove('updateSetariApp');;
  getRTSubscriptions().remove('updateActivareClient');;
  getRTSubscriptions().remove('updateComenzi');;
  getRTSubscriptions().remove('createComanda');;
  getRTSubscriptions().remove('LivratorActivNou');;
  getRTSubscriptions().remove('LivratorActivUpdate');;
  getRTSubscriptions().remove('LivratorActivDelete');;
  getRTSubscriptions().remove('createLivratorActivExtern');;
  getRTSubscriptions().remove('updateLivratorActivExtern');;
  getRTSubscriptions().remove('DeleteComenzi');;
  stopSetTimeout('timerLogout');
  stopSetTimeout('timerLogout1');
  stopSetTimeout('timerCounter');
  await Backendless.Data.of('DispecerActiv').bulkUpdate( (['userEmail = \'',(getObjectProperty(currentUser, 'userEmail')),'\'','','',''].join('')), ({ 'paginaCurenta': 'Out' }) );
}


  await onLeave();

  },
  /* handler:onLeave *//* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return (___arguments.context.appData['Title'])

  },  
/* handler:onTitleAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/73712c1793d263f9c8dcdfd451233039/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
    var currentUser;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  await Backendless.UserService.logout();
  ___arguments.context.appData['currentUser'] = null;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },
  /* handler:onClick *//* content */
}));

define('./pages/Comenzi-BKL/components/bcd52ba2f5e422b6147ef62387ac8ead/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  onClick(___arguments) {
    
  },  
  /* handler:onClick *//* content */
}));

define('./pages/Comenzi-BKL/components/da36802a2e9c603706051115b7c476ef/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  onClick(___arguments) {
      if (!((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'LIVRATA')) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10e8745a18ddd4014d2d04e3c6a97448', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ce2983dcac9718bc2661ea97e95a709', true);
  }

  },  
/* handler:onClick *//* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['comanda']),'',['(',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']),')-'].join(''),(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['adresaLivrare']),'',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['bloc']) == 'BLOC' ? (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['detaliiAdresa']) : '','','','','',['[',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifare']),']'].join('')].join(''))

  },  
  /* handler:onContentAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/11ff92dd151418d4164a38ac3bbeabf3/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
    /**
 * Describe this function...
 */
async function testMaps() {
  ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).setEncoding('utf8').send(({ 'destinations': 'Aleea Rasinari 4 Cluj-Napoca','origins': 'Aleea Rasinari 2 Cluj-Napoca' })));
  ___arguments.context.pageData['testGoogle'] = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['','https://maps.googleapis.com/maps/api/geocode/json?address=','Aleea Rasinari 2 Cluj-Napoca','','&key=AIzaSyDC4mbqOev3A2j8-gaFSZ3GZ_2cQXAORBw&='].join('')))).setEncoding('utf8').send());
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

/**
 * Describe this function...
 */
async function onLeave() {
  getRTSubscriptions().remove('updateNrComenzi');
  getRTSubscriptions().remove('updateComenzi');
  getRTSubscriptions().remove('createComanda');
  getRTSubscriptions().remove('createLivratorActivExtern');
  getRTSubscriptions().remove('updateLivratorActivExtern');
  getRTSubscriptions().remove('DeleteComenzi');
  getRTSubscriptions().remove('LivratorActivNou');
  getRTSubscriptions().remove('LivratorActivUpdate');
  getRTSubscriptions().remove('LivratorActivDelete');
  stopSetTimeout('timerLogout');
  stopSetTimeout('timerLogout1');
  stopSetTimeout('timerCounter');
}

/**
 * Describe this function...
 */
async function setInterval2() {
}

/**
 * Describe this function...
 */
async function calculCurse() {
}

/**
 * Describe this function...
 */
async function consumCurseIncluse() {
}


  try {
    await testMaps();

  } catch (error) {
    (function (message) { alert(message) })('Din pacate, din cauza unor probleme tehnice legate de server, nu se pot lansa comenzi in acest moment. Echipa tehnica lucreaza in acest moment pentru remedierea problemei.Va rugam reveniti mai tarziu. Pentru urgente va rugam sa luati legatura cu noi la 0752621501 sau sa puneti o copie a comenzii pe grupul de WhatsApp.');
    ___arguments.context.pageData['error'] = true;

  } finally {
    if (getObjectProperty(___arguments.context.pageData, 'error')) {
    } else {
      await onLeave();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ComandaNoua', undefined);
    }

  }

  },
  /* handler:onClick */
/* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var currentUser, endTime;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  endTime = (new Date());
  endTime.setHours('22');
  endTime.setMinutes('0');
  endTime.setSeconds('0');
  endTime.setMilliseconds('0');
  ___arguments.context.pageData['endTime'] = (endTime.valueOf());
  if ((currentUser['telefonUser']) == 'admin' && (___arguments.context.pageData['nrLivratorActiv']) > 0) {
    ___arguments.context.pageData['showButonComandaNoua'] = true;
  } else if ((___arguments.context.pageData['nrLivratorActiv']) > 0 && (___arguments.context.pageData['endTime']) > (new Date())) {
    ___arguments.context.pageData['showButonComandaNoua'] = true;
  } else {
    ___arguments.context.pageData['showButonComandaNoua'] = false;
  }

  return (___arguments.context.pageData['showButonComandaNoua'])

  },  
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/743be205cd4fb02920eab46326fe74a2/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
    /**
 * Describe this function...
 */
async function onClick() {
  ___arguments.context.pageData['filtruStatus'] = 'IN LUCRU';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));
}


  await onClick();

  },  
  /* handler:onClick *//* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (['IN ASTEPTARE(',(___arguments.context.appData['counterIL']),')'].join(''))

  },  
  /* handler:onLabelAssignment *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['counterIL']) > 0)

  },  
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/6ca4753ad184c287740c3cb65d534339/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filtruStatus'] = 'PROGRAMATA';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));

  },  
  /* handler:onClick *//* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (['PROGRAMATE (',(___arguments.context.appData['counterProgramate']),')'].join(''))

  },  
  /* handler:onLabelAssignment *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (___arguments.context.appData['counterProgramate'])

  },  
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/4bb3ec747f27eb92cd6fb5ee83afc83f/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filtruStatus'] = 'RIDICATA';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));

  },  
  /* handler:onClick *//* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (['RIDICATE (',(___arguments.context.appData['counterR']),')'].join(''))

  },  
  /* handler:onLabelAssignment *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['counterR']) > 0)

  },  
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/b1c7b00dfd06c6faf251e4f28359c3fe/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filtruStatus'] = 'IN LIVRARE';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));

  },  
  /* handler:onClick *//* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (['IN LIVRARE (',(___arguments.context.appData['counterILiv']),')'].join(''))

  },  
  /* handler:onLabelAssignment *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['counterILiv']) > 0)

  },  
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/d4bbcc298e994b8be052ae051ec6520c/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
    var currentUser;

/**
 * Describe this function...
 */
async function onClick() {
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.pageData['filtruStatus'] = 'TOATE';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_cff56ffe779e610ecf21eb93303266a5'](currentUser)));
}


  await onClick();

  },  
  /* handler:onClick *//* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (['TOATE PT AZI (',(___arguments.context.appData['counterToateAzi']),')'].join(''))

  },  
  /* handler:onLabelAssignment */
/* content */
}));

define('./pages/Comenzi-BKL/components/04a791a6d346897b4f725b27b6c1564e/bundle.js', [], () => ({
  /* content */

  

/* handler:onLabelAssignment */
  async onLabelAssignment(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));

  return (['NEDECONTAT: ','',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['sumaNedecontata']))),'lei'].join(''))

  },  
  /* handler:onLabelAssignment *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.pageData['sumaNedecontata']) > 0) {
    return (___arguments.context.pageData['pulseFaraLivrator']);
  } else {
    return false;
  }

  },  
/* handler:onDisplayAssignment */
/* content */
}));

define('./pages/Comenzi-BKL/components/8a3ce129581dcdaa654f5e63f753349b/bundle.js', [], () => ({
  /* content */

  
/* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getDate()),'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getMonth()) + 1,'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getFullYear()),' ',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getHours()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getHours()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getHours()),':',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getMinutes()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getMinutes()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getMinutes())].join(''))

  },  
/* handler:onContentAssignment *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare']).valueOf()) - ((new Date()).valueOf()) < 900000 && !((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'LIVRATA') ? (___arguments.context.pageData['pulseFaraLivrator']) : true)

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/f16cf98b8331e03f6ade6a5c03164c7b/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
    var currentUser, toTime, fromTime;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.pageData['filtruStatus'] = 'LIVRATA';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['oraLivrare >= ',(fromTime.valueOf()),' AND oraLivrare <= ',(toTime.valueOf()),' AND status = \'LIVRATA\' AND masterEmail = \'',(currentUser['masterEmail']),'\''].join(''))).setSortBy('oraLivrare desc').setPageSize(100))));

  },  
  /* handler:onClick *//* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (['Livrate azi (',(___arguments.context.appData['counterLiv']),')'].join(''))

  },  
  /* handler:onLabelAssignment *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['counterLiv']) > 0)

  },  
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/28bdcbf353368bf549bcd11f337293a8/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']) == 'FARA LIVRATOR' ? (___arguments.context.pageData['pulseFaraLivrator']) : true)

  },  
/* handler:onDisplayAssignment */
/* handler:onClick */
  onClick(___arguments) {
      if (!((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'LIVRATA')) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', true);
  }

  },  
/* handler:onClick *//* content */
}));

define('./pages/Comenzi-BKL/components/64e12ba2d6735d5c4a61fd41ec494173/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']) == 'FARA LIVRATOR' && (___arguments.context.pageData['pulseFaraLivrator']) == true) {
    return false;
  } else if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']) == 'FARA LIVRATOR' && (___arguments.context.pageData['pulseFaraLivrator']) == false) {
    return true;
  } else {
    return false;
  }

  },  
/* handler:onDisplayAssignment *//* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', true);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Comenzi-BKL/components/81756e03bbe5c68fd8e68d28a408a626/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10e8745a18ddd4014d2d04e3c6a97448', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ce2983dcac9718bc2661ea97e95a709', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', true);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Comenzi-BKL/components/fbc633330bdb78ec260729c2f78c32b1/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
    var currentUser, toTime, fromTime;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  ___arguments.context.pageData['filtruStatus'] = 'ANULATA';
  ___arguments.context.pageData['cautaComanda'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['programare >= ',(fromTime.valueOf()),' AND programare <= ',(toTime.valueOf()),' AND status = \'ANULATA\' AND masterEmail = \'',(currentUser['masterEmail']),'\''].join(''))).setSortBy('oraLivrare desc').setPageSize(100))));

  },  
  /* handler:onClick *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['counterAnulate']) > 0)

  },  
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/9941b43a927281ef08063bed3cf97da8/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ArhivaComenzi', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Comenzi-BKL/components/467a622b1ebb0ef371c8523e83fdce57/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
    function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['locatiaLivrator'] = (((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['livrator = \'',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']),'\' AND activ = TRUE','','',''].join(''))).setProperties('shareLocation').setSortBy('created desc').setPageSize(1)))[0])['shareLocation']);
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((subsequenceFromEndLast((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['locatiaLivrator']), 40)), true, null);

  },  
  /* handler:onClick */
/* content */
}));

define('./pages/Comenzi-BKL/components/827af72a3d0ef2ff146922b7a0e5e026/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare']) == null) {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['showRidicata'] = 'NERIDICATA';
  } else if (!((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare']) == null) && (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'GO') {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['showRidicata'] = 'IN RIDICARE';
  } else {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['showRidicata'] = (['','','','','','',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getHours()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getHours()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getHours()),':',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getMinutes()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getMinutes()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getMinutes())].join(''));
  }

  return (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['showRidicata'])

  },  
  /* handler:onContentAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/8702b4f46b09ea4bb74ca6ae1d19956e/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['',(___arguments.context.pageData['showObjects']),' comenzi sortate.'].join(''))

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/cc6e5f6784f41dd25d3407cd2a471d5b/bundle.js', [], () => ({
  /* content */

  
/* handler:onClick */
  onClick(___arguments) {
      if (!((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'LIVRATA')) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', true);
  }

  },  
/* handler:onClick *//* content */
}));

define('./pages/Comenzi-BKL/components/92f796fabc43d5d2e6dacde5cac34b05/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['emailLivrator'] = (((await Backendless.Data.of('Livratori').find(Backendless.DataQueryBuilder.create().setWhereClause((['livrator = \'',___arguments.value,'\''].join(''))).setProperties('emailLivrator').setPageSize(10)))[0])['emailLivrator']);
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', true);

  },  
/* handler:onChange *//* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item, toTime, fromTime, currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')
  if (!((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(currentUser['masterName']),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))).setSortBy('livrator asc').setGroupBy('livrator').setPageSize(100))).map(item => {; return ({ 'label': (item['livrator']),'value': (item['livrator']) });})).length) {
    return [];
  } else {
    return ((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(currentUser['masterName']),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))).setSortBy('livrator asc').setGroupBy('livrator').setPageSize(100))).map(item => {; return ({ 'label': (item['livrator']),'value': (item['livrator']) });}));
  }

  },  
/* handler:onOptionsAssignment *//* handler:onVisibilityChange */
  onVisibilityChange(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10e8745a18ddd4014d2d04e3c6a97448', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);

  },  
/* handler:onVisibilityChange *//* content */
}));

define('./pages/Comenzi-BKL/components/61a9b97acc4eecc3f96c1ec8a41aa6f3/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  onClick(___arguments) {
      if (!((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'LIVRATA')) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10e8745a18ddd4014d2d04e3c6a97448', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ce2983dcac9718bc2661ea97e95a709', true);
  }

  },  
/* handler:onClick *//* content */
}));

define('./pages/Comenzi-BKL/components/dada151a20a580fbe28cd846b07a412a/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

/**
 * Describe this function...
 */
async function goToDetail() {
  ___arguments.context.appData['selectComanda'] = ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7');
  getRTSubscriptions().remove('LivratorActivNou');;
  getRTSubscriptions().remove('LivratorActivUpdate');;
  getRTSubscriptions().remove('LivratorActivDelete');;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EditareComanda', ({ 'objectId': (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['objectId']) }));
}


  await goToDetail();

  },  
  /* handler:onClick *//* content */
}));

define('./pages/Comenzi-BKL/components/e49fe3cc6d3de256d5964aa790a7b5c5/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.appData['selectComanda'] = ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7');
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EditareComanda', ({ 'objectId': (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['objectId']) }));

  },  
/* handler:onClick *//* content */
}));

define('./pages/Comenzi-BKL/components/350452e41958f4ae58279ad8a30878f1/bundle.js', [], () => ({
  /* content */

  
/* handler:onBlur */
  onBlur(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10e8745a18ddd4014d2d04e3c6a97448', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);

  },  
/* handler:onBlur *//* handler:onChange */
  async onChange(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ce2983dcac9718bc2661ea97e95a709', true);
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange */
/* content */
}));

define('./pages/Comenzi-BKL/components/f0deedfdc66148ed83a8aad41fc69cf6/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10e8745a18ddd4014d2d04e3c6a97448', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ce2983dcac9718bc2661ea97e95a709', true);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Comenzi-BKL/components/7ce2983dcac9718bc2661ea97e95a709/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  onClick(___arguments) {
      if (!((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'LIVRATA')) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ce2983dcac9718bc2661ea97e95a709', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10e8745a18ddd4014d2d04e3c6a97448', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', true);
  }

  },  
/* handler:onClick *//* content */
}));

define('./pages/Comenzi-BKL/components/af9aa7521883169e2d06bd6665415ebd/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      if (___arguments.value == 'LIVRATA') {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'] = ((new Date()).valueOf());
  } else if (___arguments.value == 'RIDICATA') {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'] = ((new Date()).valueOf());
  }
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcc33a0121a7515ac7b4ad64c199ef8a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ce2983dcac9718bc2661ea97e95a709', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10e8745a18ddd4014d2d04e3c6a97448', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);

  },
  /* handler:onChange *//* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'livrator')) == 'FARA LIVRATOR'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}));

define('./pages/Comenzi-BKL/components/2d874835a2834dd4ce9300e1855b7a31/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10e8745a18ddd4014d2d04e3c6a97448', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', true);

  },  
/* handler:onClick */
/* content */
}));

define('./pages/Comenzi-BKL/components/0e224a779158820edeeb882d6049d37e/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.Data.of('DispecerActiv').bulkUpdate( (['userEmail = \'',(___arguments.context.pageData['userEmail']),'\'','','',''].join('')), ({ 'paginaCurenta': 'AWB' }) );
  ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((['https://calldelivery.ro/pdf/get-pdf/',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['awb']),''].join('')), true, null);

  },  
  /* handler:onClick *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['optiuneAwb'])

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/65d636b2d51c309a418d96b3354cb338/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['notificare']) == 'NOTIFICAT')

  },  
/* handler:onDisplayAssignment */
/* content */
}));

define('./pages/Comenzi-BKL/components/2667ddefdd3bebfba61c41076a32e0db/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['notificare']) == 'CONFIRMAT')

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/36071111c67cdf5a8f412311202da00f/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var ceas;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ceas = (new Date());
  ___arguments.context.pageData['ora'] = (new Date(ceas).getHours());
  ___arguments.context.pageData['min'] = (new Date(ceas).getMinutes());
  ___arguments.context.pageData['sec'] = (new Date(ceas).getSeconds());

  return ([['<b>TOATE PT AZI(',(getObjectProperty(___arguments.context.appData, 'counterToateAzi')),')</b> '].join(''),(getObjectProperty(___arguments.context.pageData, 'ora')) < 10 ? String('0') + String(getObjectProperty(___arguments.context.pageData, 'ora')) : (getObjectProperty(___arguments.context.pageData, 'ora')),':',(getObjectProperty(___arguments.context.pageData, 'min')) < 10 ? String('0') + String(getObjectProperty(___arguments.context.pageData, 'min')) : (getObjectProperty(___arguments.context.pageData, 'min')),':',(getObjectProperty(___arguments.context.pageData, 'sec')) < 10 ? String('0') + String(getObjectProperty(___arguments.context.pageData, 'sec')) : (getObjectProperty(___arguments.context.pageData, 'sec')),'',''].join(''))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/afa5936736519101d284a42ee7514b79/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tipLivrare']) == 'RIDICARE')

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/da9de675d978d5f67cfcfc958cba8711/bundle.js', [], () => ({
  /* content */

  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var currentUser, item;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));

  return ((await Backendless.Data.of('AdresaRidicare').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterClient = \'',(currentUser['masterName']),'\'',''].join(''))).setSortBy('adresa asc').setPageSize(10))).map(item => {; return ({ 'label': (item['adresa']),'value': (item['adresa']) });}))

  },  
/* handler:onOptionsAssignment *//* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('365e9a39864668c31149e817c468caa6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cf694d1705b950ec1988cab6f2ba51d', true);

  },  
/* handler:onChange *//* content */
}));

define('./pages/Comenzi-BKL/components/9cf694d1705b950ec1988cab6f2ba51d/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('365e9a39864668c31149e817c468caa6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cf694d1705b950ec1988cab6f2ba51d', false);

  },
  /* handler:onClick *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'adreseRidicareMultiple'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}));

define('./pages/Comenzi-BKL/components/17c64fd5847c5791504458a4624289b7/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Decont', null);

  },  
/* handler:onClick *//* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.pageData['sumaNedecontata']) > 0)

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/5a6584ba73283cd8d5ce60297291a589/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if ((currentUser['telefonUser']) == 'admin' && (___arguments.context.pageData['nrLivratorActiv']) > 0) {
    ___arguments.context.pageData['showOut'] = false;
  } else if ((___arguments.context.pageData['nrLivratorActiv']) > 0 && (___arguments.context.pageData['endTime']) > (new Date())) {
    ___arguments.context.pageData['showOut'] = false;
  } else {
    ___arguments.context.pageData['showOut'] = true;
  }

  return (___arguments.context.pageData['showOut'])

  },
  /* handler:onDisplayAssignment *//* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if ((___arguments.context.pageData['nrLivratorActiv']) == 0) {
    ___arguments.context.pageData['showText'] = '<b>Ne pare rau, dar in acest moment\nnu avem livratori activi!</b>';
  } else if ((___arguments.context.pageData['endTime']) < (new Date())) {
    ___arguments.context.pageData['showText'] = '<b>Suntem in afara programului.\nPreluam comenzi doar pana la ora 22.00 !</b>';
  }

  return (___arguments.context.pageData['showText'])

  },
  /* handler:onContentAssignment */
  /* content */
}));

define('./pages/Comenzi-BKL/components/be612dd92f714eeccee23c3d220aed0b/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare']) == null ? 'NELIVRATA' : [(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getDate()),'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getMonth()) + 1,'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getFullYear()),' ',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getHours()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getHours()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getHours()),':',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getMinutes()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getMinutes()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getMinutes())].join(''))

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/Comenzi-BKL/components/4a4ed1bb2f4aaa6d77ed812e78dc8924/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['incasarePos']) > 0)

  },  
  /* handler:onDisplayAssignment *//* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (['Comision POS: ','','','',Math.round((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['comisionPos']) * 100) / 100,' Lei'].join(''))

  },  
  /* handler:onLabelAssignment */
  /* content */
}));

define('./pages/Comenzi-BKL/components/993774b5eeca60910d18bb86c8b1d442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('131998d407f1946a6af77847987b803c', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/131998d407f1946a6af77847987b803c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('131998d407f1946a6af77847987b803c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('993774b5eeca60910d18bb86c8b1d442', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/a995cd07ba763cef39944e02768671d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('131998d407f1946a6af77847987b803c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('993774b5eeca60910d18bb86c8b1d442', true);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('131998d407f1946a6af77847987b803c', false);

  },  
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/Comenzi-BKL/components/1ce87ecf56de7c01bffa61d1dc291cc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('TextSMS', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/99a9889ba79757d6978b55088647a4f6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
      ___arguments.context.dataModel['paginaCurenta'] = 'Comenzi';
  await Backendless.Data.of('DispecerActiv').save( ___arguments.context.dataModel );

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/Comenzi-BKL/components/e3db76478f83de873bd3e5ca11176e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('99a9889ba79757d6978b55088647a4f6')['dispecer']),'(ridicare: ',(___arguments.context.getComponentDataStoreByUid('99a9889ba79757d6978b55088647a4f6')['adresaRidicare']),') ',(___arguments.context.getComponentDataStoreByUid('99a9889ba79757d6978b55088647a4f6')['masterName']),'',''].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Comenzi-BKL/components/385911c463d19252250c067dc16248a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('d8420a95d7d6c88c700b61d5a81135bb')['input'] = '';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d8420a95d7d6c88c700b61d5a81135bb', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/486ad72abec6a6956c46d3c121aa449c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    /**
 * Describe this function...
 */
async function tarifareKm() {
}


  if ((___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['ZONA']) == 1) {
    ___arguments.context.getComponentDataStoreByUid('34240c494debd0e3e8aca6bc3ac237e2')['tarifare'] = (___arguments.context.getComponentDataStoreByUid('34240c494debd0e3e8aca6bc3ac237e2')['tarifareZ1']);
  } else if ((___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['ZONA']) == 2) {
    ___arguments.context.getComponentDataStoreByUid('34240c494debd0e3e8aca6bc3ac237e2')['tarifare'] = (___arguments.context.getComponentDataStoreByUid('34240c494debd0e3e8aca6bc3ac237e2')['tarifareZ2']);
  } else if ((___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['ZONA']) == 3) {
    ___arguments.context.getComponentDataStoreByUid('34240c494debd0e3e8aca6bc3ac237e2')['tarifare'] = (___arguments.context.getComponentDataStoreByUid('34240c494debd0e3e8aca6bc3ac237e2')['tarifareZ3']);
  }

  return (['Strada: ',(___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['AFISARE']),' se afla in zona: ',(___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['ZONA']),' tarifat STANDARD cu: ',(___arguments.context.getComponentDataStoreByUid('34240c494debd0e3e8aca6bc3ac237e2')['tarifare']),' Lei/ sau ',(___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['tarifare']),'Lei tarifat la km',''].join(''))

  },  
  /* handler:onContentAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var currentUser;

/**
 * Describe this function...
 */
async function distanta_time() {
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.pageData['newAdresaLivrare'] = ([(___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['STRADA']),' ',(___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['CARTIER']) == 'FLORESTI' || (___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['CARTIER']) == 'BACIU' || (___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['CARTIER']) == 'SOMESENI' || (___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['CARTIER']) == 'FELEACU' || (___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['CARTIER']) == 'sat POPESTI' || (___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['CARTIER']) == 'CHINTENI' ? [' comuna ',(___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['CARTIER']),' jud Cluj'].join('') : ' Cluj-Napoca','',''].join(''));
  ___arguments.context.pageData['newAdresaRidicare'] = ([(currentUser['adresaRidicare']),' Cluj-Napoca','','',''].join(''));
  ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).send(({ 'destinations': String(___arguments.context.pageData['newAdresaLivrare']) + String(''),'origins': [(___arguments.context.pageData['newAdresaRidicare']),' Cluj-Napoca',''].join('') })));
  ___arguments.context.pageData['distance'] = ((((___arguments.context.pageData['distanceGoogle'])['distance'])['value']) / 1000 + 0);
  await tarifareKm();
  console.log(['\nAdresa Ridicare:',(___arguments.context.pageData['newAdresaRidicare']),'\nAdresa Livrare:',(___arguments.context.pageData['newAdresaLivrare'])].join(''));
  console.log(['\nDistanta bruta:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((((___arguments.context.pageData['distanceGoogle'])['distance'])['value']) / 1000))),'\nDistanta:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['distance']))),'Km','\nKm suplimentari:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['kmSPL']))),'\nTarifare:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['tarifare']))),'',''].join(''));
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log((___arguments.context.pageData['client'])['tarifareKm']);
  ___arguments.context.pageData['kmSPL'] = ((___arguments.context.pageData['distance']) - ((___arguments.context.pageData['client'])['tarifareKmLimita']) >= 0 ? (await BackendlessUI.Functions.Custom['roundCuDouaZecimale'](((___arguments.context.pageData['distance']) - ((___arguments.context.pageData['client'])['tarifareKmLimita'])))) : 0);
  if (true && (___arguments.context.pageData['kmSPL']) < 8 - ((___arguments.context.pageData['client'])['tarifareKmLimita']) && (___arguments.context.pageData['kmSPL']) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['tarifare'] = (await BackendlessUI.Functions.Custom['roundCuDouaZecimale']((((___arguments.context.pageData['client'])['tarifareKmBaza']) + (___arguments.context.pageData['kmSPL']) * ((___arguments.context.pageData['client'])['tarifareKmSPL1']))));
  } else if (true && (___arguments.context.pageData['kmSPL']) >= 8 - ((___arguments.context.pageData['client'])['tarifareKmLimita'])) {
    ___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['tarifare'] = (await BackendlessUI.Functions.Custom['roundCuDouaZecimale']((((___arguments.context.pageData['client'])['tarifareKmBaza']) + (___arguments.context.pageData['kmSPL']) * ((___arguments.context.pageData['client'])['tarifareKmSPL2']))));
  }
}


  if ((___arguments.context.getComponentDataStoreByUid('1c6334681f7d344ae1670352d88672d2')['tarifare']) > 0) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d8420a95d7d6c88c700b61d5a81135bb', false);
  } else {
    await distanta_time();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/45a56ea7a8a2ceb9e8e8e09d2f070826/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('65832dd8e9046a56bbbf17a6cd6e6f82', (await Backendless.Data.of('straziCluj').find(Backendless.DataQueryBuilder.create().setWhereClause((['STRADA LIKE \'%',(___arguments.context.getComponentDataStoreByUid('d8420a95d7d6c88c700b61d5a81135bb')['input']),'%\'','',''].join(''))).setPageSize(10))));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45a56ea7a8a2ceb9e8e8e09d2f070826', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73d91a9d3a9f58281ea537ec0e4c2577', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/34240c494debd0e3e8aca6bc3ac237e2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    var currentUser;

/**
 * Describe this function...
 */
async function tarifare() {
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.pageData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.pageData));
  ___arguments.context.pageData['client'] = ((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setPageSize(1)))[0]);
  ___arguments.context.dataModel['tarifareZ1'] = ((___arguments.context.pageData['client'])['tarifare_baza']);
  ___arguments.context.dataModel['tarifareZ2'] = ((___arguments.context.pageData['client'])['tarifare_Z2']);
  ___arguments.context.dataModel['tarifareZ3'] = ((___arguments.context.pageData['client'])['tarifare_Z3']);
}


  await tarifare();

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/Comenzi-BKL/components/3badb4caa3ce21cc4959c4b456b2945a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d8420a95d7d6c88c700b61d5a81135bb', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/f47fce8dbcaf12268c831c9d03eda3d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return (String(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['distance']) / 1000))) + String('Km'))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Comenzi-BKL/components/4a0a3e5d497261d239e501e3ae4a0807/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrareExtern']) && ((___arguments.context.appData['client'])['multiBrand']))

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi-BKL/components/bcc33a0121a7515ac7b4ad64c199ef8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if (!((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'LIVRATA')) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d874835a2834dd4ce9300e1855b7a31', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcc33a0121a7515ac7b4ad64c199ef8a', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10e8745a18ddd4014d2d04e3c6a97448', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da36802a2e9c603706051115b7c476ef', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0deedfdc66148ed83a8aad41fc69cf6', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61a9b97acc4eecc3f96c1ec8a41aa6f3', true);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/8118480483f7235912e6fa2a251141da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Livratori', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/8f220b1f40375dca1e9c9846cc37fb01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    /**
 * Describe this function...
 */
async function search() {
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' ','AND programare >= ',(___arguments.context.pageData['fromTime']),'AND programare <= ',(___arguments.context.pageData['toTime']),[' AND search LIKE \'%',(___arguments.context.getComponentDataStoreByUid('9e8e2a35067aa6b8954b1acc3ce14826')['cautaComanda']),'%\''].join(''),'',''].join(''))).setSortBy('created').setPageSize(5))));
  ___arguments.context.pageData['showObjects'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' ','AND programare >= ',(___arguments.context.pageData['fromTime']),'AND programare <= ',(___arguments.context.pageData['toTime']),[' AND search LIKE \'%',(___arguments.context.getComponentDataStoreByUid('9e8e2a35067aa6b8954b1acc3ce14826')['cautaComanda']),'%\''].join(''),'',''].join('')))));
}


  await search();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/73d91a9d3a9f58281ea537ec0e4c2577/bundle.js', [], () => ({
  /* content */
  /* handler:onFocus */
  onFocus(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('d8420a95d7d6c88c700b61d5a81135bb')['input'] = '';

  },  
  /* handler:onFocus */
  /* content */
}))

define('./pages/Comenzi-BKL/components/279dff5b656e7d822cf103aadbb1864d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e8e2a35067aa6b8954b1acc3ce14826', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('279dff5b656e7d822cf103aadbb1864d', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/41e290327eef8a73859dfaccdcea8808/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e8e2a35067aa6b8954b1acc3ce14826', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('279dff5b656e7d822cf103aadbb1864d', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/835b602e0386b55a9e5c21ade2d2b2e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('131998d407f1946a6af77847987b803c', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/f777034ad6afe2d871e64dc2b51dde36/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('469d308b74debce1852cc04dfcab6d34', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f777034ad6afe2d871e64dc2b51dde36', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/469d308b74debce1852cc04dfcab6d34/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('469d308b74debce1852cc04dfcab6d34', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f777034ad6afe2d871e64dc2b51dde36', true);

  },  
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['sumarZi'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Comenzi-BKL/components/0fbf7f94b9aaa5f41f73ced6464b9ce7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['','','','',((___arguments.context.appData['setariApp'])['textAnunt']),''].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Comenzi-BKL/components/0c3a41a7a0cf22169bbba7778d1c89bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.pageData['pulseFaraLivrator']) && (___arguments.context.pageData['clientActiv'])) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0c3a41a7a0cf22169bbba7778d1c89bd'))['background-color'] = 'red';
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0c3a41a7a0cf22169bbba7778d1c89bd'))['background-color'] = 'green';
  }

  return ((___arguments.context.pageData['showComandaNoua']) && !((___arguments.context.appData['client'])['dezactivatTemporar']) && (___arguments.context.pageData['clientActiv']))

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi-BKL/components/5e5171b60889a0faf34c38fdc4919155/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('131998d407f1946a6af77847987b803c', false);

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((getObjectProperty(___arguments.context.appData, 'setariApp')), 'appActiva')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi-BKL/components/290da3498f4648fc2c7b55d17d09f364/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'clientActiv')) || (getObjectProperty((getObjectProperty(___arguments.context.appData, 'client')), 'dezactivatTemporar')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi-BKL/components/6b1c7743f5034d643525d29d0fa82ff4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showTextDezactivare'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Comenzi-BKL/components/f1d706a116f80461a0d4e59b1ae797a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var timpRamasContent, acum, Intarziere;

/**
 * Describe this function...
 */
async function calculTimp() {
  acum = (new Date());
  timpRamasContent = (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare']) - acum;
  Intarziere = acum - (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare']);
  if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'GO' && timpRamasContent >= 0) {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraR'] = ((new Date(timpRamasContent).getHours()) - 2);
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['minR'] = (new Date(timpRamasContent).getMinutes());
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['secR'] = (new Date(timpRamasContent).getSeconds());
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['timpRidicare'] = (['','',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['minR']) < 10 ? String('0') + String(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['minR']) : (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['minR']),':',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['secR']) < 10 ? String('0') + String(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['secR']) : (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['secR']),''].join(''));
  } else if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'GO' && timpRamasContent < 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f1d706a116f80461a0d4e59b1ae797a5'))['background-color'] = 'red';
    await intarziere();
  } else {
    await intarziere();
  }
  if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'IN LUCRU') {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['textPreparare'] = (String((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['timpPreparare']) / 60000) + String(':00 min'));
  } else if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'GO') {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['textPreparare'] = (String(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['timpRidicare']) + String(' min'));
  }
}

/**
 * Describe this function...
 */
async function intarziere() {
  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraR'] = ((new Date(Intarziere).getHours()) - 2);
  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['minR'] = (new Date(Intarziere).getMinutes());
  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['secR'] = (new Date(Intarziere).getSeconds());
  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['timpRidicare'] = (['','',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['minR']) < 10 ? String('0') + String(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['minR']) : (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['minR']),':',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['secR']) < 10 ? String('0') + String(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['secR']) : (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['secR']),''].join(''));
}


  await calculTimp();

  return (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['textPreparare'])

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'PROGRAMATA' || (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'IN LUCRU') {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['showPreparare'] = true;
  } else if ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'GO') {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['showPreparare'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['showPreparare'] = true;
  }

  return (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['showPreparare'])

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi-BKL/components/932caf6ba075e097061ee816f98c2745/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    /**
 * Describe this function...
 */
async function onClick() {
  ___arguments.context.pageData['filtruStatus'] = 'GO';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_4a898faf6e7a9544faab89f4db4d0f63'](___arguments.context.pageData, ___arguments.context.appData)));
}


  await onClick();

  },  
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (['GO IN PREPARARE (',(___arguments.context.appData['counterGO']),')'].join(''))

  },  
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['pulseFaraLivrator']) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('932caf6ba075e097061ee816f98c2745'))['background-color'] = 'green';
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('932caf6ba075e097061ee816f98c2745'))['background-color'] = '#3D3D3D';
  }

  return ((___arguments.context.appData['counterGO']) > 0)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi-BKL/components/85ecfcbae9eb3111460c5094250ca54b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.pageData['pulseFaraLivrator']) && (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['status']) == 'GO') {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('85ecfcbae9eb3111460c5094250ca54b'))['background-color'] = 'green';
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('85ecfcbae9eb3111460c5094250ca54b'))['background-color'] = '#202020';
  }

  return true

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Comenzi-BKL/components/f225757c7c81df7e4396adea32067991/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48d863719ee6e8497d63ff54c807dc7b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f225757c7c81df7e4396adea32067991', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/f33211f4d186da87173edd6859b37f2b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48d863719ee6e8497d63ff54c807dc7b', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f225757c7c81df7e4396adea32067991', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/d57a8b7ef1e4483f83df30ae83275969/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var currentUser;

/**
 * Describe this function...
 */
async function onClick() {
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.pageData['filtruStatus'] = 'TOATE';
  ___arguments.context.pageData['selectCartier'] = '';
  ___arguments.context.pageData['cautaComanda'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', []);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_cff56ffe779e610ecf21eb93303266a5'](currentUser)));
}


  await onClick();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Comenzi-BKL/components/40d4d80a23a8e7ee32eb74ec66f83d64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Comenzi', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Decont/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async onEnter(___arguments) {
    var currentUser, toTime, fromTime;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  if (!(await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))) {
    ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://calldelivery.ro', false, null);
  }
  await Backendless.Data.of('DispecerActiv').bulkUpdate( (['userEmail = \'',(currentUser['userEmail']),'\'','','',''].join('')), ({ 'paginaCurenta': 'Decont' }) );
  ___arguments.context.pageData['filtruLivrator'] = 'Toti livratorii';
  ___arguments.context.pageData['sumaNedecontata'] = (['Total suma nedecontata: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((await BackendlessUI.Functions.Custom['fn_eb0fab0b577e4258db7644dcf6560004']((currentUser['masterEmail']))))),'lei'].join(''));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_d9dc12d90f53834ce88f0a2e96fa375a'](currentUser)));

  },  
  /* handler:onEnter */
/* content */
}));

define('./pages/Decont/components/d0292826e5d48b277e8221d63f75b556/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currentUserName, currentUser;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (currentUser) {
    currentUserName = (currentUser['username']);
  }

  return currentUserName

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/Decont/components/73712c1793d263f9c8dcdfd451233039/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ___arguments.context.appData['currentUser'] = null;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },
  /* handler:onClick *//* content */
}));

define('./pages/Decont/components/db8e872ab8c674ae309410e4a91151d6/bundle.js', [], () => ({
  /* content */

  

/* content */
}));




define('./pages/Decont/components/bcd52ba2f5e422b6147ef62387ac8ead/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', ___arguments.context.appData);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Decont/components/04a791a6d346897b4f725b27b6c1564e/bundle.js', [], () => ({
  /* content */

  
/* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Comenzi', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Decont/components/944f19b1567cdefaf8c81f671505e72e/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.pageData['sumaNedecontata'] = ((___arguments.context.pageData['filtruLivrator']) == 'Toti livratorii' ? ['Total suma nedecontata: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((await BackendlessUI.Functions.Custom['fn_eb0fab0b577e4258db7644dcf6560004']((currentUser['masterEmail']))))),'lei'].join('') : ['Total suma nedecontata: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((await BackendlessUI.Functions.Custom['fn_4831e40bc784b9e58d67251b83990d16'](___arguments.context.pageData, currentUser)))),'lei'].join(''));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', ((___arguments.context.pageData['filtruLivrator']) == 'Toti livratorii' ? (await BackendlessUI.Functions.Custom['fn_d9dc12d90f53834ce88f0a2e96fa375a'](currentUser)) : (await BackendlessUI.Functions.Custom['fn_b9681bbc770913a33d9ceedb73e585a2'](___arguments.context.pageData))));

  },  
  /* handler:onChange *//* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item, currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));

  return ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause(([' decontat = FALSE AND masterEmail = \'',(currentUser['masterEmail']),'\''].join(''))).setHavingClause('NOT status = \'ANULATA\'').setSortBy('livrator asc').setGroupBy('livrator').setPageSize(100))).map(item => {; return ({ 'value': (item['livrator']),'label': (item['livrator']) });}))

  },  
/* handler:onOptionsAssignment *//* content */
}));

define('./pages/Decont/components/9a6bcb05c93abe598ba72f7e491de2e4/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.pageData['filtruLivrator'] = 'Toti livratorii';
  ___arguments.context.pageData['sumaNedecontata'] = (['Total suma nedecontata: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((await BackendlessUI.Functions.Custom['fn_eb0fab0b577e4258db7644dcf6560004']((currentUser['masterEmail']))))),'lei'].join(''));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await BackendlessUI.Functions.Custom['fn_d9dc12d90f53834ce88f0a2e96fa375a'](currentUser)));

  },  
  /* handler:onClick *//* content */
}));

define('./pages/Decont/components/d3ffa0ca062568aed84d96988912dacc/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.pageData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.pageData));
  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livratorDescarcat'] = ___arguments.value;
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );
  ___arguments.context.pageData['sumaNedecontata'] = ((___arguments.context.pageData['filtruLivrator']) == 'Toti livratorii' ? ['Total suma nedecontata:',(await BackendlessUI.Functions.Custom['fn_eb0fab0b577e4258db7644dcf6560004']((currentUser['masterEmail']))),'lei'].join('') : ['Total suma nedecontata:',(await BackendlessUI.Functions.Custom['fn_4831e40bc784b9e58d67251b83990d16'](___arguments.context.pageData, currentUser)),'lei'].join(''));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', ((___arguments.context.pageData['filtruLivrator']) == 'Toti livratorii' ? (await BackendlessUI.Functions.Custom['fn_d9dc12d90f53834ce88f0a2e96fa375a'](currentUser)) : (await BackendlessUI.Functions.Custom['fn_b9681bbc770913a33d9ceedb73e585a2'](___arguments.context.pageData, currentUser))));

  },  
  /* handler:onChange *//* content */
}));

define('./pages/Decont/components/da36802a2e9c603706051115b7c476ef/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['comanda']),'/',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['adresaLivrare'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}));

define('./pages/EditareComanda/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, toTime, fromTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['','https://cd.testenv.ro/api/comenzi?','where=_id=\'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectComanda')), '_id')),'\'','','','','','','',''].join('')))).setEncoding('utf8').send()));
  ___arguments.context.pageData['client'] = ((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(getObjectProperty(currentUser, 'masterName')),'\''].join(''))).setPageSize(1)))[0]);

  },
  /* handler:onEnter */
/* content */
}));

define('./pages/EditareComanda/components/d0292826e5d48b277e8221d63f75b556/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var currentUserName, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (currentUser) {
    currentUserName = (getObjectProperty(currentUser, 'username'));
  }

  return currentUserName

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/73712c1793d263f9c8dcdfd451233039/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ___arguments.context.appData['currentUser'] = null;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick *//* content */
}));

define('./pages/EditareComanda/components/aeb57e92f478e05c6532b6ba5edab5ae/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange */
/* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['plataOp'])

  },  
/* handler:onDisabledStateAssignment *//* content */
}));

define('./pages/EditareComanda/components/8c8b0573e64384415fec7c8da8526799/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Valoare cash: ',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['plata_cash']) + (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['plata_card']),'lei'].join(''))

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/1dd5b90597236fee51baecd1525d217e/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick *//* content */
}));

define('./pages/EditareComanda/components/05066af374e2d90e3c0371bc461b0de3/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
    var destinaton, origins, toTime, fromTime, currentUser;

/**
 * Describe this function...
 */
async function distanta_time() {
  if ((___arguments.context.pageData['client'])['tarifareKm']) {
    ___arguments.context.pageData['newAdresaLivrare'] = ([(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['adresaLivrare']),'','','',''].join(''));
    ___arguments.context.pageData['newAdresaRidicare'] = ([(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['adresaRidicare']),'','','',''].join(''));
    destinaton = [(___arguments.context.pageData['newAdresaLivrare']),'',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']) == 'FLORESTI' || (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']) == 'BACIU' || (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']) == 'SOMESENI' || (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']) == 'FELEACU' || (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']) == 'sat POPESTI' || (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']) == 'CHINTENI' ? [' comuna ',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(___arguments.context.pageData['newAdresaRidicare']),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((((___arguments.context.pageData['distanceGoogle'])['distance'])['value']) / 1000 + 0);
    await tarifareKm();
    await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );
    console.log(['\nAdresa Ridicare:',origins,'\nAdresa Livrare:',destinaton].join(''));
    console.log(['\nDistanta bruta:',(((___arguments.context.pageData['distanceGoogle'])['distance'])['value']) / 1000,'\nDistanta:',(___arguments.context.pageData['distance']),'Km','\nKm suplimentari:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['kmSPL'])))].join(''));
  }
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log((___arguments.context.pageData['client'])['tarifareKm']);
  ___arguments.context.pageData['kmSPL'] = ((___arguments.context.pageData['distance']) - ((___arguments.context.pageData['client'])['tarifareKmLimita']) >= 0 ? (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((___arguments.context.pageData['distance']) - ((___arguments.context.pageData['client'])['tarifareKmLimita'])))) : 0);
  if (((___arguments.context.pageData['client'])['tarifareKm']) && (___arguments.context.pageData['kmSPL']) < 6 && (___arguments.context.pageData['kmSPL']) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((((___arguments.context.pageData['client'])['tarifareKmBaza']) + (___arguments.context.pageData['kmSPL']) * ((___arguments.context.pageData['client'])['tarifareKmSPL1']))));
  } else if (((___arguments.context.pageData['client'])['tarifareKm']) && (___arguments.context.pageData['kmSPL']) >= 6) {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((((___arguments.context.pageData['client'])['tarifareKmBaza']) + (___arguments.context.pageData['kmSPL']) * ((___arguments.context.pageData['client'])['tarifareKmSPL2']))));
  }
}


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')
  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator'] = 'FARA LIVRATOR';
  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['emailLivrator'] = 'nomail@nomail.ro';
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );
  if ((await Backendless.Data.of('LivratorActiv').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(currentUser['masterName']),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))))) < 1 && (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrareExtern']) == false) {
    ;await ( async function (message){ alert(message) })('!!! ATENTIE Nu aveti livratori interni activi !!!');
  }
  if (___arguments.value) {
    await distanta_time();
  } else {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifare'] = ((___arguments.context.pageData['client'])['tarifareIntern']);
  }
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onChange *//* content */
}));

define('./pages/EditareComanda/components/89d4d2247669c218f2f94ef1e884dc4e/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange *//* content */
}));

define('./pages/EditareComanda/components/11ff92dd151418d4164a38ac3bbeabf3/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick *//* content */
}));

define('./pages/EditareComanda/components/d2134398b1d7a579aad5ad0d4123d783/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange *//* content */
}));

define('./pages/EditareComanda/components/a48b372419a27b14240a15a1f57c11b8/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['emailLivrator'] = (((await Backendless.Data.of('Livratori').find(Backendless.DataQueryBuilder.create().setWhereClause((['livrator = \'',___arguments.value,'\''].join(''))).setProperties('emailLivrator').setPageSize(10)))[0])['emailLivrator']);
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange *//* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item, toTime, fromTime, currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')
  if (!((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(currentUser['masterName']),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))).setSortBy('livrator asc').setPageSize(100))).map(item => {; return ({ 'label': (item['livrator']),'value': (item['livrator']) });})).length) {
    return [];
  } else {
    return ((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(currentUser['masterName']),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))).setSortBy('livrator asc').setPageSize(100))).map(item => {; return ({ 'label': (item['livrator']),'value': (item['livrator']) });}));
  }

  },  
/* handler:onOptionsAssignment */

/* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrareExtern'])

  },  
/* handler:onDisabledStateAssignment *//* content */
}));

define('./pages/EditareComanda/components/a016e78b0ddef0ede54907a5110ac79d/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'status')) == 'LIVRATA') ? true : false)

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/EditareComanda/components/6d7b6b1d060a0b2af77d8727be236471/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange *//* content */
}));

define('./pages/EditareComanda/components/9e1fb149af04dc8870daf29ddfaf47d5/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String(' Livrator: ') + String(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']))

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/62420c33920b7ebb89567a8613f79166/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (!((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare']) == null) ? ['Comanda a fost livrata la: ',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getDate()),'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getMonth()) + 1,'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getFullYear()),' ',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getHours()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getHours()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getHours()),':',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getMinutes()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getMinutes()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare'])).getMinutes())].join('') : 'Comanda nu a fost livrata inca')

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/c3a5aaa3c34adaa480f51c91c845ac6f/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var timpLivrare;


  timpLivrare = (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare']) - (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['created']);
  ___arguments.context.pageData['ora'] = ((new Date(timpLivrare).getHours()) - 2);
  ___arguments.context.pageData['min'] = (new Date(timpLivrare).getMinutes());
  ___arguments.context.pageData['sec'] = (new Date(timpLivrare).getSeconds());

  return (!((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare']) == null) ? ['Timp livrare: ','',(___arguments.context.pageData['ora']) < 10 ? String('0') + String(___arguments.context.pageData['ora']) : (___arguments.context.pageData['ora']),':',(___arguments.context.pageData['min']) < 10 ? String('0') + String(___arguments.context.pageData['min']) : (___arguments.context.pageData['min']),':',(___arguments.context.pageData['sec']) < 10 ? String('0') + String(___arguments.context.pageData['sec']) : (___arguments.context.pageData['sec']),'','',''].join('') : '-')

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/733937b70de28f56c86d4c028a914a6a/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Comanda lansata la: ',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['created'])).getDate()),'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['created'])).getMonth()) + 1,'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['created'])).getFullYear()),' ',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['created'])).getHours()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['created'])).getHours()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['created'])).getHours()),':',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['created'])).getMinutes()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['created'])).getMinutes()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['created'])).getMinutes())].join(''))

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/abc6d50d6483fcfc226e733adf8fd34a/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Ora limita de livrare: ',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getDate()),'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getMonth()) + 1,'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getFullYear()),' ',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getHours()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getHours()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getHours()),':',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getMinutes()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getMinutes()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['programare'])).getMinutes())].join(''))

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/da36802a2e9c603706051115b7c476ef/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Comanda: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'comanda')))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/5bda93da049cf0ecebdef721cb1c1d1e/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange *//* content */
}));

define('./pages/EditareComanda/components/6b88759fad37e5a4c8bc1ccbb83b8e2a/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange *//* content */
}));

define('./pages/EditareComanda/components/57da1d382dcb6625dbfd602c51553db7/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },
  /* handler:onChange *//* content */
}));

define('./pages/EditareComanda/components/11d6f9196afb6dc23de7b995ba11f337/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare']) == null ? 'Comanda neridicata' : ['Ora ridicare: ',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getDate()),'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getMonth()) + 1,'/',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getFullYear()),' ',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getHours()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getHours()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getHours()),':',(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getMinutes()) < 10 ? String('0') + String(new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getMinutes()) : (new Date((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare'])).getMinutes())].join(''))

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/405357a7d9945a2ae60fe94c4d6633ac/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var timpEfectivLivrare;

/**
 * Describe this function...
 */
async function TELC() {
  ___arguments.context.pageData['oraEL'] = ((new Date(timpEfectivLivrare).getHours()) - 2);
  ___arguments.context.pageData['minEL'] = ((new Date(timpEfectivLivrare).getMinutes()) - 2);
  ___arguments.context.pageData['secEL'] = ((new Date(timpEfectivLivrare).getSeconds()) - 2);
}


  timpEfectivLivrare = (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare']) - (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraRidicare']);
  ___arguments.context.pageData['oraEL'] = ((new Date(timpEfectivLivrare).getHours()) - 2);
  ___arguments.context.pageData['minEL'] = ((new Date(timpEfectivLivrare).getMinutes()) - 2);
  ___arguments.context.pageData['secEL'] = ((new Date(timpEfectivLivrare).getSeconds()) - 2);

  return (!((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['oraLivrare']) == null) ? ['Timp efectiv livrare: ','',(___arguments.context.pageData['oraEL']) < 10 ? String('0') + String(___arguments.context.pageData['oraEL']) : (___arguments.context.pageData['oraEL']),':',(___arguments.context.pageData['minEL']) < 10 ? String('0') + String(___arguments.context.pageData['minEL']) : (___arguments.context.pageData['minEL']),':',(___arguments.context.pageData['secEL']) < 10 ? String('0') + String(___arguments.context.pageData['secEL']) : (___arguments.context.pageData['secEL']),'','',''].join('') : '-')

  },  
  /* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/1fec16a1618d80be5951c0d108d1f049/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Adresa ridicare: ') + String(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['adresaRidicare']))

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/2022b189ce5a1d59d5243ecb8e18edc9/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Adresa livrare: ') + String(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['adresaLivrare']))

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/676c7ff81ecf207c514ee613f0b64268/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['plata_cash']) > 0 ? String('Comanda a fost incasata: ') + String((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['incasarePos']) ? ' cu POS la livrare' : ' cu CASH la livrare') : ' Comanda a fost incasata cu CARD sau OP')

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComanda/components/5de32864eaa4621f5e19e764be440f01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EditareComanda/components/ad4ff63bbd46915b50787938b8c44e7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.pageData['client'] = ((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setPageSize(1)))[0]);

  return ([(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['distance']) / 1000))),'Km\nTarifat cu: ',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifare']),'lei',''].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/EditareComanda/components/f4316047d61d4ac1802fa0f92fbdaeab/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (!((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']) == 'FARA LIVRATOR'))

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/EditareComanda/components/b3e451b3b30659f2bff78ea6088d8626/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/EditareComanda/components/967e709d522d167602934fe6d4b4848a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EditareComanda/components/7c08f6642e02aba248b5ef7d953f3c95/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Comanda SPECIALA(',(getObjectProperty(___arguments.context.appData, 'userName')),')'].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'userName')) == 'Vali')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifareRezerva'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'tarifare'));
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifareLivRezerva'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'tarifareLiv'));
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['detaliiLivrareRezerva'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'detaliiLivrare'));
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['detaliiLivrare'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'detaliiLivrare')),' - COMANDA SPECIALA(',(getObjectProperty(___arguments.context.appData, 'userName')),')'].join(''));
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifare'] = 0;
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifareLiv'] = 0;
  } else if (!___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifare'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'tarifareRezerva'));
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifareLiv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'tarifareLivRezerva'));
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['detaliiLivrare'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'detaliiLivrareRezerva'));
  }
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EditareComandaNew/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function user() {
  if ((getObjectProperty(___arguments.context.appData, 'user')) == null) {
    console.log('no user load');
    await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
    ___arguments.context.appData['user'] = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  }
  currentUser = (getObjectProperty(___arguments.context.appData, 'user'));
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'username'));
}


  await user();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', [(await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(getObjectProperty(___arguments.context.appData, 'server')),'comenzi/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectComanda')), '_id')),''].join('')))).setEncoding('utf8').send())]);
  ___arguments.context.pageData['client'] = ((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(getObjectProperty(___arguments.context.appData, 'server')),'client/get','',''].join('')))).setEncoding('utf8').send(({ [`selected`]: ({ [`masterName`]: (getObjectProperty(currentUser, 'masterName')) }) })))[0]);

  },
  /* handler:onEnter */
/* content */
}));

define('./pages/EditareComandaNew/components/d0292826e5d48b277e8221d63f75b556/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var currentUserName, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (currentUser) {
    currentUserName = (getObjectProperty(currentUser, 'username'));
  }

  return currentUserName

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComandaNew/components/73712c1793d263f9c8dcdfd451233039/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ___arguments.context.appData['currentUser'] = null;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick *//* content */
}));

define('./pages/EditareComandaNew/components/8c8b0573e64384415fec7c8da8526799/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Valoare cash: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'plata_cash')),'lei'].join(''))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComandaNew/components/1dd5b90597236fee51baecd1525d217e/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Comenzi', undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/EditareComandaNew/components/05066af374e2d90e3c0371bc461b0de3/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
    var destinaton, origins, toTime, fromTime, currentUser;

/**
 * Describe this function...
 */
async function distanta_time() {
  if ((___arguments.context.pageData['client'])['tarifareKm']) {
    ___arguments.context.pageData['newAdresaLivrare'] = ([(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['adresaLivrare']),'','','',''].join(''));
    ___arguments.context.pageData['newAdresaRidicare'] = ([(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['adresaRidicare']),'','','',''].join(''));
    destinaton = [(___arguments.context.pageData['newAdresaLivrare']),'',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']) == 'FLORESTI' || (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']) == 'BACIU' || (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']) == 'SOMESENI' || (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']) == 'FELEACU' || (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']) == 'sat POPESTI' || (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']) == 'CHINTENI' ? [' comuna ',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['cartier']),' jud Cluj'].join('') : ' Cluj-Napoca'].join('');
    origins = [(___arguments.context.pageData['newAdresaRidicare']),' Cluj-Napoca',''].join('');
    ___arguments.context.pageData['distanceGoogle'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://calldelivery.ro/maps')).send(({ 'destinations': destinaton,'origins': origins })));
    ___arguments.context.pageData['distance'] = ((((___arguments.context.pageData['distanceGoogle'])['distance'])['value']) / 1000 + 0);
    await tarifareKm();
    await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );
    console.log(['\nAdresa Ridicare:',origins,'\nAdresa Livrare:',destinaton].join(''));
    console.log(['\nDistanta bruta:',(((___arguments.context.pageData['distanceGoogle'])['distance'])['value']) / 1000,'\nDistanta:',(___arguments.context.pageData['distance']),'Km','\nKm suplimentari:',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['kmSPL'])))].join(''));
  }
}

/**
 * Describe this function...
 */
async function tarifareKm() {
  console.log((___arguments.context.pageData['client'])['tarifareKm']);
  ___arguments.context.pageData['kmSPL'] = ((___arguments.context.pageData['distance']) - ((___arguments.context.pageData['client'])['tarifareKmLimita']) >= 0 ? (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((___arguments.context.pageData['distance']) - ((___arguments.context.pageData['client'])['tarifareKmLimita'])))) : 0);
  if (((___arguments.context.pageData['client'])['tarifareKm']) && (___arguments.context.pageData['kmSPL']) < 6 && (___arguments.context.pageData['kmSPL']) >= 0) {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((((___arguments.context.pageData['client'])['tarifareKmBaza']) + (___arguments.context.pageData['kmSPL']) * ((___arguments.context.pageData['client'])['tarifareKmSPL1']))));
  } else if (((___arguments.context.pageData['client'])['tarifareKm']) && (___arguments.context.pageData['kmSPL']) >= 6) {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifare'] = (await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((((___arguments.context.pageData['client'])['tarifareKmBaza']) + (___arguments.context.pageData['kmSPL']) * ((___arguments.context.pageData['client'])['tarifareKmSPL2']))));
  }
}


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')
  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator'] = 'FARA LIVRATOR';
  ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['emailLivrator'] = 'nomail@nomail.ro';
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );
  if ((await Backendless.Data.of('LivratorActiv').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(currentUser['masterName']),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))))) < 1 && (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrareExtern']) == false) {
    ;await ( async function (message){ alert(message) })('!!! ATENTIE Nu aveti livratori interni activi !!!');
  }
  if (___arguments.value) {
    await distanta_time();
  } else {
    ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifare'] = ((___arguments.context.pageData['client'])['tarifareIntern']);
  }
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onChange *//* content */
}));

define('./pages/EditareComandaNew/components/89d4d2247669c218f2f94ef1e884dc4e/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_48ca14785afeef6f05dd11f72b6a3c4f']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), '_id')), ({ [`status`]: ___arguments.value }), ___arguments.context.appData);

  },
  /* handler:onChange *//* content */
}));

define('./pages/EditareComandaNew/components/11ff92dd151418d4164a38ac3bbeabf3/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Comenzi', undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/EditareComandaNew/components/d2134398b1d7a579aad5ad0d4123d783/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_48ca14785afeef6f05dd11f72b6a3c4f']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), '_id')), ({ [`telefonClient`]: ___arguments.value }), ___arguments.context.appData);

  },
  /* handler:onChange *//* content */
}));

define('./pages/EditareComandaNew/components/a48b372419a27b14240a15a1f57c11b8/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['emailLivrator'] = (((await Backendless.Data.of('Livratori').find(Backendless.DataQueryBuilder.create().setWhereClause((['livrator = \'',___arguments.value,'\''].join(''))).setProperties('emailLivrator').setPageSize(10)))[0])['emailLivrator']);
  await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange *//* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item, toTime, fromTime, currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')
  if (!((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(currentUser['masterName']),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))).setSortBy('livrator asc').setPageSize(100))).map(item => {; return ({ 'label': (item['livrator']),'value': (item['livrator']) });})).length) {
    return [];
  } else {
    return ((await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(currentUser['masterName']),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))).setSortBy('livrator asc').setPageSize(100))).map(item => {; return ({ 'label': (item['livrator']),'value': (item['livrator']) });}));
  }

  },  
/* handler:onOptionsAssignment */

/* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrareExtern'])

  },  
/* handler:onDisabledStateAssignment *//* content */
}));

define('./pages/EditareComandaNew/components/a016e78b0ddef0ede54907a5110ac79d/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'status')) == 'LIVRATA') ? true : false)

  },
  /* handler:onDisplayAssignment *//* content */
}));

define('./pages/EditareComandaNew/components/6d7b6b1d060a0b2af77d8727be236471/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_48ca14785afeef6f05dd11f72b6a3c4f']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), '_id')), ({ [`detaliiLivrare`]: ___arguments.value }), ___arguments.context.appData);

  },
  /* handler:onChange *//* content */
}));

define('./pages/EditareComandaNew/components/9e1fb149af04dc8870daf29ddfaf47d5/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String(' Livrator: ') + String(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['livrator']))

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComandaNew/components/da36802a2e9c603706051115b7c476ef/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Comanda: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'comanda')))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComandaNew/components/5bda93da049cf0ecebdef721cb1c1d1e/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_48ca14785afeef6f05dd11f72b6a3c4f']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), '_id')), ({ [`programare`]: ___arguments.value }), ___arguments.context.appData);

  },
  /* handler:onChange *//* content */
}));

define('./pages/EditareComandaNew/components/1fec16a1618d80be5951c0d108d1f049/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Adresa ridicare: ') + String(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['adresaRidicare']))

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComandaNew/components/2022b189ce5a1d59d5243ecb8e18edc9/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Adresa livrare: ') + String(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['adresaLivrare']))

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComandaNew/components/676c7ff81ecf207c514ee613f0b64268/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['plata_cash']) > 0 ? String('Comanda a fost incasata: ') + String((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['incasarePos']) ? ' cu POS la livrare' : ' cu CASH la livrare') : ' Comanda a fost incasata cu CARD sau OP')

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareComandaNew/components/5de32864eaa4621f5e19e764be440f01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.Data.of('Comenzi').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EditareComandaNew/components/ad4ff63bbd46915b50787938b8c44e7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.pageData['client'] = ((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setPageSize(1)))[0]);

  return ([(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['distance']) / 1000))),'Km\nTarifat cu: ',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['tarifare']),'lei',''].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/EditareComandaNew/components/f4316047d61d4ac1802fa0f92fbdaeab/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_48ca14785afeef6f05dd11f72b6a3c4f']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), '_id')), ({ [`reviewLivrator`]: ___arguments.value }), ___arguments.context.appData);

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'livrator')) == 'FARA LIVRATOR'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/EditareComandaNew/components/51b201c706a48d1d05ed7156cb1b9797/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_48ca14785afeef6f05dd11f72b6a3c4f']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), '_id')), ({ 'plataOp': ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EditareLivrator/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async onEnter(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = ___arguments.context.appData;
  if (!(await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  }
  await Backendless.Data.of('DispecerActiv').bulkUpdate( (['userEmail = \'',(currentUser['userEmail']),'\'','','',''].join('')), ({ 'paginaCurenta': 'EditareLVT' }) );
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Livratori').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',((___arguments.context.appData['selectLivrator'])['objectId']),'\''].join(''))).setPageSize(1))));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('737eb8dfef07a249197839c27ea49946', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['userEmail = \'',((___arguments.context.appData['selectLivrator'])['userEmail']),'\''].join(''))).setPageSize(1))));

  },  
  /* handler:onEnter */
/* content */
}));

define('./pages/EditareLivrator/components/d0292826e5d48b277e8221d63f75b556/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currentUserName, currentUser;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (currentUser) {
    currentUserName = (currentUser['username']);
  }

  return currentUserName

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/EditareLivrator/components/73712c1793d263f9c8dcdfd451233039/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ___arguments.context.appData['currentUser'] = null;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick *//* content */
}));

define('./pages/EditareLivrator/components/db8e872ab8c674ae309410e4a91151d6/bundle.js', [], () => ({
  /* content */

  

/* content */
}));




define('./pages/EditareLivrator/components/bcd52ba2f5e422b6147ef62387ac8ead/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Livratori', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/EditareLivrator/components/1dd5b90597236fee51baecd1525d217e/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Livratori', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/EditareLivrator/components/05066af374e2d90e3c0371bc461b0de3/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Livratori').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange *//* content */
}));

define('./pages/EditareLivrator/components/d2134398b1d7a579aad5ad0d4123d783/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Livratori').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange *//* content */
}));

define('./pages/EditareLivrator/components/a16b8658eb8a9d0102bd053a09a12b9c/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Comenzi', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/EditareLivrator/components/c862b754d88be12fd2286e8a115fbfa4/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Users').save( ___arguments.context.getComponentDataStoreByUid('61e3b1f5e197b6fa08bdea1d169f1717') );

  },  
/* handler:onChange *//* content */
}));

define('./pages/EditareLivrator/components/86b99264f58bfd5e49d10545c38f9419/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Livratori').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange *//* content */
}));

define('./pages/EditareLivrator/components/1ca4edb602d73df44901a9a7d51956bf/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Livratori').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange *//* content */
}));

define('./pages/EditareLivrator/components/830b82dc63e14fa92e0d70d6e015a382/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Livratori').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
/* handler:onChange *//* content */
}));

define('./pages/EditareLivrator/components/506c16426fe14888ee2d6fea9d476ef7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('Livratori').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/LivratorNou/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async onEnter(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (!(await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  }
  await Backendless.Data.of('DispecerActiv').bulkUpdate( (['userEmail = \'',(currentUser['userEmail']),'\'','','',''].join('')), ({ 'paginaCurenta': 'AdaugaLVT' }) );

  },  
  /* handler:onEnter */
/* content */
}));

define('./pages/LivratorNou/components/222914427ab8caf9ccb26d9331f9ea99/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var currentLocation, message, appUsername;


  appUsername = ((await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))['username']);
  currentLocation = (___arguments.context.pageData['currentLocation']);
  message = (___arguments.context.dataModel['message']);
  if (message) {
    ___arguments.context.dataModel['message'] = '';
    await Backendless.Messaging.publish('default', ({ 'username': appUsername,'message': message,'lat': (currentLocation['lat']),'lng': (currentLocation['lng']) }), new Backendless.PublishOptions({ subtopic: '' }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
  }

  },  
/* handler:onSubmit *//* content */
}));

define('./pages/LivratorNou/components/d0292826e5d48b277e8221d63f75b556/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currentUserName, currentUser;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (currentUser) {
    currentUserName = (currentUser['username']);
  }

  return currentUserName

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/LivratorNou/components/73712c1793d263f9c8dcdfd451233039/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ___arguments.context.appData['currentUser'] = null;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick *//* content */
}));

define('./pages/LivratorNou/components/db8e872ab8c674ae309410e4a91151d6/bundle.js', [], () => ({
  /* content */

  

/* content */
}));




define('./pages/LivratorNou/components/bcd52ba2f5e422b6147ef62387ac8ead/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Livratori', ___arguments.context.appData);

  },  
/* handler:onClick *//* content */
}));

define('./pages/LivratorNou/components/14654282be67c4ca9d3abddded61c584/bundle.js', [], () => ({
  /* content */

  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    var currentUser, timeOfset, toTime, fromTime;


  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  timeOfset = (new Date());
  ___arguments.context.pageData['newMasterEmail'] = (currentUser['masterEmail']);
  ___arguments.context.pageData['newMasterId'] = (currentUser['masterID']);
  ___arguments.context.pageData['newMasterName'] = (currentUser['masterName']);
  ___arguments.context.dataModel['newLogo'] = (((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setProperties('logo').setPageSize(10)))[0])['logo']);

  },  
/* handler:onBeforeMount *//* handler:onReset */
  async onReset(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Livratori', null);

  },  
/* handler:onReset *//* handler:onSubmit */
  async onSubmit(___arguments) {
    var livratorNou, currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  livratorNou = (await Backendless.Data.of('Users').save( ({ 'rol': 'LIVRATOR','masterEmail': (___arguments.context.pageData['newMasterEmail']),'masterID': (___arguments.context.pageData['newMasterId']),'masterName': (___arguments.context.pageData['newMasterName']),'password': (___arguments.context.dataModel['newPassword']),'telefonUser': (___arguments.context.dataModel['newTelefon']),'userEmail': (___arguments.context.dataModel['newUserEmail']),'username': (___arguments.context.dataModel['newUserName']) }) ));
  livratorNou = (await Backendless.Data.of('Livratori').save( ({ 'activ': true,'emailLivrator': (___arguments.context.dataModel['newUserEmail']),'master': (___arguments.context.pageData['newMasterName']),'livrator': (___arguments.context.dataModel['newUserName']),'tarifare_cursa': (___arguments.context.dataModel['newTarifareCursa']),'tarifare_ora': (___arguments.context.dataModel['newTarifareOra']),'telefon': (___arguments.context.dataModel['newTelefon']),'tipLivrator': 'INTERN','userEmail': (___arguments.context.dataModel['newUserEmail']),'detaliiLivrator': (___arguments.context.dataModel['newDetaliiLivrator']) }) ));
  await Backendless.Messaging.sendEmail('Cont Livrator nou', new Backendless.Bodyparts({ htmlmessage: (['S-a creat un cont nou livrator.','<br>User: <b>',(___arguments.context.dataModel['newUserName']),'</b><br>Password: <b>',(___arguments.context.dataModel['newPassword']),'</b><br>Master: <b>',(___arguments.context.pageData['newMasterName']),'</b> link app:<br> https://calldelivery.ro','</b>or link app:<br> https://calldelivery.store4.ro','</b><br><br> Enjoy! <br> CallDelivery Team<br> tel: 0752621501 ','',''].join('')) }), [' horea.mihaltan@gmail.com'], undefined)
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Livratori', null);

  },  
  /* handler:onSubmit *//* handler:onMounted */
  async onMounted(___arguments) {
    var currentUser;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));

  },  
/* handler:onMounted *//* content */
}));

define('./pages/LivratorNou/components/3aed9c98df6f4d3f76466c26cdbbefd4/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return true

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/Livratori/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var toTime, fromTime, currentUser, object;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (!(await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  await Backendless.Data.of('DispecerActiv').bulkUpdate( (['userEmail = \'',(getObjectProperty(currentUser, 'userEmail')),'\'','','',''].join('')), ({ 'paginaCurenta': 'Livratori INT' }) );
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  ___arguments.context.pageData['sumaNedecontata'] = (await BackendlessUI.Functions.Custom['fn_eb0fab0b577e4258db7644dcf6560004'](null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))).setSortBy('activ desc').setPageSize(100))));
  ___arguments.context.pageData['countLivratoriActivi'] = (await Backendless.Data.of('LivratorActiv').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join('')))));

  ;(function(whereClause) {
    const callback = async object => {
        ___arguments.context.pageData['countLivratoriActivi'] = (await Backendless.Data.of('LivratorActiv').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join('')))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))).setSortBy('created desc').setPageSize(100))));

    };

    const rtHandlers = Backendless.Data.of('LivratorActiv').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addCreateListener.apply(rtHandlers, options);

    getRTSubscriptions().add('livratorActiv', () => rtHandlers.removeCreateListener(callback));

  })((['','','masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join('')));

  ;(function(whereClause) {
    const callback = async object => {
        ___arguments.context.pageData['countLivratoriActivi'] = (await Backendless.Data.of('LivratorActiv').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join('')))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))).setSortBy('created desc').setPageSize(100))));

    };

    const rtHandlers = Backendless.Data.of('LivratorActiv').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add('updateLivratori', () => rtHandlers.removeUpdateListener(callback));

  })((['','','masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join('')));

  },
  /* handler:onEnter */
/* handler:onLeave */
  onLeave(___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}


  getRTSubscriptions().remove('updateLivratori');;
  getRTSubscriptions().remove('livratorActiv');;

  },  
/* handler:onLeave *//* content */
}));

define('./pages/Livratori/components/d0292826e5d48b277e8221d63f75b556/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currentUserName, currentUser;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (currentUser) {
    currentUserName = (currentUser['username']);
  }

  return currentUserName

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/Livratori/components/73712c1793d263f9c8dcdfd451233039/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ___arguments.context.appData['currentUser'] = null;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick *//* content */
}));

define('./pages/Livratori/components/db8e872ab8c674ae309410e4a91151d6/bundle.js', [], () => ({
  /* content */

  

/* content */
}));




define('./pages/Livratori/components/bcd52ba2f5e422b6147ef62387ac8ead/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Livratori/components/11ff92dd151418d4164a38ac3bbeabf3/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LivratorNou', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Livratori/components/6ca4753ad184c287740c3cb65d534339/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    var toTime, fromTime, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0');
  fromTime.setMinutes('0');
  fromTime.setSeconds('0');
  fromTime.setMilliseconds('0');
  toTime.setHours('23');
  toTime.setMinutes('59');
  toTime.setSeconds('59');
  toTime.setMilliseconds('999');
  ___arguments.context.pageData['filtruStatus'] = 'ACTIVI';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('LivratorActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['activ = TRUE ','',' AND masterClient =\'',(getObjectProperty(currentUser, 'masterName')),'\' AND created >= ',(fromTime.valueOf()),' AND created <= ',(toTime.valueOf())].join(''))).setSortBy('livrator').setPageSize(100))));

  },
  /* handler:onClick *//* handler:onLabelAssignment */
  async onLabelAssignment(___arguments) {
    var toTime, fromTime, currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')

  return (['LIVRATORI ACTIVI AZI(',(___arguments.context.pageData['countLivratoriActivi']),')'].join(''))

  },  
/* handler:onLabelAssignment *//* content */
}));

define('./pages/Livratori/components/d4bbcc298e994b8be052ae051ec6520c/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.pageData['filtru'] = 'TOTI';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('Livratori').find(Backendless.DataQueryBuilder.create().setWhereClause((['','tipLivrator = \'intern\'',' AND master =\'',(getObjectProperty(currentUser, 'masterName')),'\'','','',''].join(''))).setSortBy('livrator').setPageSize(100))));

  },
  /* handler:onClick *//* handler:onLabelAssignment */
  async onLabelAssignment(___arguments) {
    var currentUser, toTime, fromTime;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  toTime = (new Date());
  fromTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')

  return (['TOTI LIVRATORII (',(await Backendless.Data.of('Livratori').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['','tipLivrator = \'INTERN\'',' AND master =\'',(currentUser['masterName']),'\'','','',''].join(''))))),')'].join(''))

  },  
/* handler:onLabelAssignment *//* content */
}));

define('./pages/Livratori/components/04a791a6d346897b4f725b27b6c1564e/bundle.js', [], () => ({
  /* content */

  
/* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Decont', null);

  },  
/* handler:onClick *//* handler:onLabelAssignment */
  async onLabelAssignment(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));

  return (['NEDECONTAT: ','',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['sumaNedecontata']))),'lei'].join(''))

  },  
  /* handler:onLabelAssignment *//* content */
}));

define('./pages/Livratori/components/f16cf98b8331e03f6ade6a5c03164c7b/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
    var currentUser, toTime, fromTime;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')

  },  
/* handler:onClick *//* handler:onLabelAssignment */
  async onLabelAssignment(___arguments) {
    var toTime, fromTime, currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  fromTime = (new Date());
  toTime = (new Date());
  fromTime.setHours('0')
  fromTime.setMinutes('0')
  fromTime.setSeconds('0')
  fromTime.setMilliseconds('0')
  toTime.setHours('23')
  toTime.setMinutes('59')
  toTime.setSeconds('59')
  toTime.setMilliseconds('999')

  return (['MAP LIVRATORI','',''].join(''))

  },  
/* handler:onLabelAssignment *//* content */
}));

define('./pages/Livratori/components/a1cc96a510a420014072af972d3d7733/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['livrator = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'livrator')),'\' AND NOT status = \'LIVRATA\' AND NOT status = \'ANULATA\''].join('')))))

  },
  /* handler:onContentAssignment *//* content */
}));

define('./pages/Livratori/components/a16b8658eb8a9d0102bd053a09a12b9c/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Comenzi', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Livratori/components/ca98970a81ab0588c5a93824d6caab1c/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtru')) == 'TOTI') {
    ___arguments.context.appData['selectLivrator'] = ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('EditareLivrator', ({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7'), 'objectId')) }));
  }

  },
  /* handler:onClick *//* content */
}));

define('./pages/Livratori/components/a06b53ff8dfa5e161e4381012cb50e7e/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['activ']) == true)

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/Livratori/components/7cd9bc774c26a322c793e4bd0e32a8a3/bundle.js', [], () => ({
  /* content */

  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['activ']) == false)

  },  
/* handler:onDisplayAssignment *//* content */
}));

define('./pages/MainPage/components/d0292826e5d48b277e8221d63f75b556/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currentUserName, currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (currentUser) {
    currentUserName = (currentUser['username']);
  }

  return currentUserName

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/MainPage/components/73712c1793d263f9c8dcdfd451233039/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ___arguments.context.appData['currentUser'] = null;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick *//* content */
}));

define('./pages/MainPage/components/bcd52ba2f5e422b6147ef62387ac8ead/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Comenzi', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/MainPage/components/page/bundle.js', [], () => ({
  /* content */

  



/* handler:onEnter */
  async onEnter(___arguments) {
    var tarifareKmToate, tarifareKm, offset, sumTarifareKm, item, kmToate, km, sumKm, currentUser, toDayTime, fromDayTime, toateLC, TarifareLC, offsetLC, sumTarifareLC, itemLC, toateComenzile, Tarifare, sumTarifare, averageTELC, sumTELC, averageTLLC, sumTLLC, toateComenzileTE, sumTE, averageTE, sumTL, averageTL;

/**
 * Describe this function...
 */
async function sumTarifareKmLC() {
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND distance > 0',' AND created >=',(___arguments.context.pageData['fromTime']),' AND created <=',(___arguments.context.pageData['toTime'])].join(''))).setPageSize(100))).length > 0) {
    tarifareKmToate = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND distance > 0',' AND created >=',(___arguments.context.pageData['fromTime']),' AND created <=',(___arguments.context.pageData['toTime'])].join('')))));
    tarifareKm = 0;
    ___arguments.context.pageData['valoareTarifareKmLC'] = 0;
    ___arguments.context.pageData['medieTarifareKmLC'] = 0;
    offset = 0;
    while (offset <= tarifareKmToate) {
      sumTarifareKm = ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND distance > 0',' AND created >=',(___arguments.context.pageData['fromTime']),' AND created <=',(___arguments.context.pageData['toTime'])].join(''))).setPageSize(100).setOffset((offset == 0 ? null : offset)))).map(item => {  if ((item['distance']) / 1000 - 2 >= 0 && (item['distance']) / 1000 - 2 < 6) {
          ___arguments.context.pageData['tarifKm'] = ((___arguments.context.pageData['client'])['tarifareKmSPL1']);
        } else if ((item['distance']) / 1000 - 2 >= 6) {
          ___arguments.context.pageData['tarifKm'] = ((___arguments.context.pageData['client'])['tarifareKmSPL2']);
        }
      ; return (((item['distance']) / 1000 - ((___arguments.context.pageData['client'])['tarifareKmLimita'])) * (___arguments.context.pageData['tarifKm']) + ((___arguments.context.pageData['client'])['tarifareKmBaza']));})).reduce(function(x, y) {return x + y;});
      tarifareKm = sumTarifareKm + tarifareKm;
      offset = offset + 100;
    }
    ___arguments.context.pageData['valoareTarifareKmLC'] = tarifareKm;
    ___arguments.context.pageData['medieTarifareKmLC'] = ((___arguments.context.pageData['valoareTarifareKmLC']) / tarifareKmToate);
    console.log(String('Tarifare/Km comenzi LC: ') + String(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['valoareTarifareKmLC']))));
    console.log(String('medie tarifare/km/Comanda LC: ') + String(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['medieTarifareKmLC']))));
  } else {
    ___arguments.context.pageData['valoareTarifareKmLC'] = 0;
    ___arguments.context.pageData['medieTarifareKmLC'] = 0;
  }
}

/**
 * Describe this function...
 */
async function sumKmToate() {
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND distance > 0','','',''].join(''))).setPageSize(100))).length > 0) {
    kmToate = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND distance > 0','','',''].join('')))));
    km = 0;
    ___arguments.context.pageData['valoareKm'] = 0;
    ___arguments.context.pageData['medieKm'] = 0;
    offset = 0;
    while (offset <= kmToate) {
      sumKm = ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND distance > 0','','',''].join(''))).setPageSize(100).setOffset((offset == 0 ? null : offset)))).map(item => {; return ((item['distance']) / 1000);})).reduce(function(x, y) {return x + y;});
      km = sumKm + km;
      offset = offset + 100;
    }
    ___arguments.context.pageData['valoareKm'] = km;
    ___arguments.context.pageData['medieKm'] = ((___arguments.context.pageData['valoareKm']) / kmToate);
    console.log(String('Km comenzi: ') + String(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['valoareKm']))));
    console.log(String('medie km/Comanda: ') + String(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['medieKm']))));
  } else {
    ___arguments.context.pageData['valoareKm'] = 0;
    ___arguments.context.pageData['medieKm'] = 0;
  }
}

/**
 * Describe this function...
 */
async function sumKmLC() {
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND distance > 0',' AND created >=',(___arguments.context.pageData['fromTime']),' AND created <=',(___arguments.context.pageData['toTime'])].join(''))).setPageSize(100))).length > 0) {
    kmToate = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND distance > 0',' AND created >=',(___arguments.context.pageData['fromTime']),' AND created <=',(___arguments.context.pageData['toTime'])].join('')))));
    km = 0;
    ___arguments.context.pageData['valoareKmLC'] = 0;
    ___arguments.context.pageData['medieKmLC'] = 0;
    offset = 0;
    while (offset <= kmToate) {
      sumKm = ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND distance > 0',' AND created >=',(___arguments.context.pageData['fromTime']),' AND created <=',(___arguments.context.pageData['toTime'])].join(''))).setPageSize(100).setOffset((offset == 0 ? null : offset)))).map(item => {; return ((item['distance']) / 1000);})).reduce(function(x, y) {return x + y;});
      km = sumKm + km;
      offset = offset + 100;
    }
    ___arguments.context.pageData['valoareKmLC'] = km;
    ___arguments.context.pageData['medieKmLC'] = ((___arguments.context.pageData['valoareKmLC']) / kmToate);
    console.log(String('Km comenzi LC: ') + String(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['valoareKmLC']))));
    console.log(String('medie km/Comanda LC: ') + String(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['medieKmLC']))));
  } else {
    ___arguments.context.pageData['valoareKmLC'] = 0;
    ___arguments.context.pageData['medieKmLC'] = 0;
  }
}

/**
 * Describe this function...
 */
async function setInterval2() {
  fromDayTime = (new Date());
  toDayTime = (new Date());
  fromDayTime.setDate('1')
  fromDayTime.setHours('0')
  fromDayTime.setMinutes('0')
  fromDayTime.setSeconds('0')
  fromDayTime.setMilliseconds('0')
  toDayTime.setDate('31')
  toDayTime.setHours('23')
  toDayTime.setMinutes('59')
  toDayTime.setSeconds('59')
  toDayTime.setMilliseconds('999')
}

/**
 * Describe this function...
 */
async function sumTarifareLunaCurenta() {
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND timpLivrare >0',' AND created >=',(___arguments.context.pageData['fromTime']),' AND created <=',(___arguments.context.pageData['toTime']),'',''].join(''))).setPageSize(100))).length > 0) {
    toateLC = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND timpLivrare >0',' AND created >=',(___arguments.context.pageData['fromTime']),' AND created <=',(___arguments.context.pageData['toTime']),'',''].join('')))));
    TarifareLC = 0;
    ___arguments.context.pageData['valoareTarifareLC'] = 0;
    ___arguments.context.pageData['medieTarifareLC'] = 0;
    offsetLC = 0;
    while (offsetLC <= toateLC) {
      sumTarifareLC = ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND created >=',(___arguments.context.pageData['fromTime']),' AND created <=',(___arguments.context.pageData['toTime'])].join(''))).setPageSize(100).setOffset((offsetLC == 0 ? null : offsetLC)))).map(itemLC => {; return (itemLC['tarifare']);})).reduce(function(x, y) {return x + y;});
      TarifareLC = sumTarifareLC + TarifareLC;
      offsetLC = offsetLC + 100;
    }
    ___arguments.context.pageData['valoareTarifareLC'] = TarifareLC;
    ___arguments.context.pageData['medieTarifareLC'] = ((___arguments.context.pageData['valoareTarifareLC']) / toateLC);
    console.log(String('valoare tarifareLC: ') + String(___arguments.context.pageData['valoareTarifareLC']));
    console.log(String('medie tarifareLC: ') + String(___arguments.context.pageData['medieTarifareLC']));
  } else {
    ___arguments.context.pageData['valoareTarifareLC'] = 0;
    ___arguments.context.pageData['medieTarifareLC'] = 0;
  }
}

/**
 * Describe this function...
 */
async function sumTarifareKmToate() {
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND distance > 0','','',''].join(''))).setPageSize(100))).length > 0) {
    tarifareKmToate = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND distance > 0','','',''].join('')))));
    tarifareKm = 0;
    ___arguments.context.pageData['valoareTarifareKm'] = 0;
    ___arguments.context.pageData['medieTarifareKm'] = 0;
    offset = 0;
    while (offset <= tarifareKmToate) {
      sumTarifareKm = ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND distance > 0','','',''].join(''))).setPageSize(100).setOffset((offset == 0 ? null : offset)))).map(item => {  if ((item['distance']) / 1000 - 2 >= 0 && (item['distance']) / 1000 - 2 < 6) {
          ___arguments.context.pageData['tarifKm'] = ((___arguments.context.pageData['client'])['tarifareKmSPL1']);
        } else if ((item['distance']) / 1000 - 2 >= 6) {
          ___arguments.context.pageData['tarifKm'] = ((___arguments.context.pageData['client'])['tarifareKmSPL2']);
        }
      ; return (((item['distance']) / 1000 - ((___arguments.context.pageData['client'])['tarifareKmLimita'])) * (___arguments.context.pageData['tarifKm']) + ((___arguments.context.pageData['client'])['tarifareKmBaza']));})).reduce(function(x, y) {return x + y;});
      tarifareKm = sumTarifareKm + tarifareKm;
      offset = offset + 100;
    }
    ___arguments.context.pageData['valoareTarifareKm'] = tarifareKm;
    ___arguments.context.pageData['medieTarifareKm'] = ((___arguments.context.pageData['valoareTarifareKm']) / tarifareKmToate);
    console.log(String('Tarif km baza: ') + String(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((___arguments.context.pageData['client'])['tarifareKmBaza']))));
    console.log(String('Tarif km SPL1: ') + String(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((___arguments.context.pageData['client'])['tarifareKmSPL1']))));
    console.log(String('Tarif km SPL2: ') + String(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced'](((___arguments.context.pageData['client'])['tarifareKmSPL2']))));
    console.log(String('Tarifare/Km comenzi: ') + String(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['valoareTarifareKm']))));
    console.log(String('medie tarifare/km/Comanda: ') + String(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['medieTarifareKm']))));
  } else {
    ___arguments.context.pageData['valoareTarifareKm'] = 0;
    ___arguments.context.pageData['medieTarifareKm'] = 0;
  }
}

/**
 * Describe this function...
 */
async function sumOverloadToate() {
  if ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\'','','',''].join(''))).setPageSize(100))).length > 0) {
    toateComenzile = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\'','','',''].join('')))));
    Tarifare = 0;
    ___arguments.context.pageData['valoareTarifare'] = 0;
    ___arguments.context.pageData['medieTarifare'] = 0;
    offset = 0;
    while (offset <= toateComenzile) {
      sumTarifare = ((await Backendless.Data.of('Comenzi').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\'','','',''].join(''))).setPageSize(100).setOffset((offset == 0 ? null : offset)))).map(item => {; return (item['tarifare']);})).reduce(function(x, y) {return x + y;});
      Tarifare = sumTarifare + Tarifare;
      offset = offset + 100;
    }
    ___arguments.context.pageData['valoareTarifare'] = Tarifare;
    ___arguments.context.pageData['medieTarifare'] = ((___arguments.context.pageData['valoareTarifare']) / toateComenzile);
    console.log(String('valoare tarifare: ') + String(___arguments.context.pageData['valoareTarifare']));
    console.log(String('medie tarifare: ') + String(___arguments.context.pageData['medieTarifare']));
  } else {
    ___arguments.context.pageData['valoareTarifare'] = 0;
    ___arguments.context.pageData['medieTarifare'] = 0;
  }
}

/**
 * Describe this function...
 */
async function averageTELC2() {
}

/**
 * Describe this function...
 */
async function calculCurse() {
  ___arguments.context.pageData['comenziLunaCurenta'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND created >=',(___arguments.context.pageData['fromTime']),' AND created <=',(___arguments.context.pageData['toTime'])].join('')))));
  ___arguments.context.pageData['toateComenzile'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\'','','',''].join('')))));
  ___arguments.context.pageData['curseIncluseFaraTermen'] = ((___arguments.context.pageData['client'])['curseIncluseFaraTermen']);
  ___arguments.context.pageData['curseAbonamentLunar'] = ((___arguments.context.pageData['client'])['curse_abonament']);
  ___arguments.context.pageData['tarifZona2'] = ((___arguments.context.pageData['client'])['tarifare_Z2']);
  ___arguments.context.pageData['tarifZona3'] = ((___arguments.context.pageData['client'])['tarifare_Z3']);
  console.log(___arguments.context.pageData['curseIncluseFaraTermen']);
  console.log(___arguments.context.pageData['curseAbonamentLunar']);
  ___arguments.context.pageData['comenziZ2'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND tarifare =',(___arguments.context.pageData['tarifZona2']),'',''].join('')))));
  console.log(___arguments.context.pageData['comenziZ2']);
  ___arguments.context.pageData['comenziZ3'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND tarifare =',(___arguments.context.pageData['tarifZona3']),'',''].join('')))));
  console.log(___arguments.context.pageData['comenziZ3']);
  ___arguments.context.pageData['comenziIncluse'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND tarifare = 0','','',''].join('')))));
  ___arguments.context.pageData['comenziIncluseAbonament'] = (await Backendless.Data.of('Comenzi').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['masterEmail = \'',(___arguments.context.pageData['masterEmail']),'\' AND tarifare = 0 AND created >=',(___arguments.context.pageData['fromTime']),' AND created <=',(___arguments.context.pageData['toTime'])].join('')))));
}

/**
 * Describe this function...
 */
async function averageTLLC2() {
}

/**
 * Describe this function...
 */
async function medieTE() {
}

/**
 * Describe this function...
 */
async function averageTL2() {
}

/**
 * consuma din abonament si pe urma din fara termen
 */
async function consumCurseIncluse() {
  ___arguments.context.pageData['curseAbonamentRamase'] = ((___arguments.context.pageData['curseAbonamentLunar']) - (___arguments.context.pageData['comenziIncluseAbonament']));
  if ((___arguments.context.pageData['curseAbonamentRamase']) > 0) {
    ___arguments.context.pageData['comenziFaraTermenRamase'] = (___arguments.context.pageData['curseIncluseFaraTermen']);
  } else if ((___arguments.context.pageData['curseAbonamentRamase']) < 0) {
    ___arguments.context.pageData['comenziFaraTermenRamase'] = ((___arguments.context.pageData['curseIncluseFaraTermen']) - (___arguments.context.pageData['comenziIncluse']));
    ___arguments.context.pageData['curseAbonamentRamase'] = 0;
  } else if ((___arguments.context.pageData['curseAbonamentRamase']) < 0) {
    ___arguments.context.pageData['comenziFaraTermenRamase'] = ((___arguments.context.pageData['curseIncluseFaraTermen']) + (___arguments.context.pageData['curseAbonamentRamase']));
    ___arguments.context.pageData['curseAbonamentRamase'] = 0;
  }
  ___arguments.context.pageData['textNumarComenzi'] = 'Comenzi in luna Curenta: ';
}

/**
 * Consuma prima data curse fara termen si pe urma din abonament
 */
async function consumCurseIncluseVechi() {
  ___arguments.context.pageData['comenziFaraTermenRamase'] = ((___arguments.context.pageData['curseIncluseFaraTermen']) - (___arguments.context.pageData['comenziIncluse']));
  console.log(___arguments.context.pageData['comenziIncluse']);
  if ((___arguments.context.pageData['comenziFaraTermenRamase']) > 0) {
    ___arguments.context.pageData['curseAbonamentRamase'] = 0;
  } else {
    ___arguments.context.pageData['curseAbonamentRamase'] = ((___arguments.context.pageData['curseAbonamentLunar']) + (___arguments.context.pageData['comenziIncluseAbonament']));
  }
  ___arguments.context.pageData['textNumarComenzi'] = 'Comenzi in luna Curenta: ';
}


  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db8e872ab8c674ae309410e4a91151d6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d41e63e902d634148ba71df6ffaa15f', false);
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (!(await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))) {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('http://calldelivery.store4.ro', false, null);
  }
  ___arguments.context.pageData['client'] = ((await Backendless.Data.of('Client').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterName = \'',(currentUser['masterName']),'\''].join(''))).setPageSize(1)))[0]);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c48ec4974f67decf56fc21cdd8c1970c', (await Backendless.Data.of('DispecerActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['userEmail = \'',(currentUser['userEmail']),'\'','','',''].join(''))).setPageSize(1))));
  await setInterval2();
  ___arguments.context.pageData['fromTime'] = (fromDayTime.valueOf());
  ___arguments.context.pageData['toTime'] = (toDayTime.valueOf());
  ___arguments.context.pageData['masterEmail'] = (currentUser['masterEmail']);
  ___arguments.context.pageData['masterName'] = (currentUser['masterName']);
  await calculCurse();
  await consumCurseIncluse();
  await sumOverloadToate();
  await sumTarifareLunaCurenta();
  await averageTL2();
  await averageTELC2();
  await averageTLLC2();
  await sumKmToate();
  await sumTarifareKmToate();
  await sumKmLC();
  await sumTarifareKmLC();
  await medieTE();
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db8e872ab8c674ae309410e4a91151d6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d41e63e902d634148ba71df6ffaa15f', true);

  },  
  /* handler:onEnter */

/* content */
}));

define('./pages/MainPage/components/1e98349afe686e29e1d78718331bf8a7/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return (['Total comenzi: ',(___arguments.context.pageData['toateComenzile']),'\nTotal comenzi Zona2: ',(___arguments.context.pageData['comenziZ2']),[' (',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((((___arguments.context.pageData['comenziZ2']) / (___arguments.context.pageData['toateComenzile'])) * 100))),' %)'].join(''),'\nTotal comenzi Zona3: ',(___arguments.context.pageData['comenziZ3']),[' (',(await BackendlessUI.Functions.Custom['roundCuDouaZecimale']((((___arguments.context.pageData['comenziZ3']) / (___arguments.context.pageData['toateComenzile'])) * 100))),' %)'].join(''),'\nTotal comenzi pret redus: ',(___arguments.context.pageData['comenziIncluse']),'\nTotal Comenzi luna curenta: ',(___arguments.context.pageData['comenziLunaCurenta'])].join(''))

  },  
  /* handler:onContentAssignment *//* content */
}));

define('./pages/MainPage/components/6b965a641db16794fa1d78a49b43867c/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://www.google.com/maps/d/u/0/edit?mid=1OYNFzv_nUqOISD4dN2zfCHEiXA2O6_V8&ll=46.76621632234868%2C23.60662580000003&z=12', true, null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/MainPage/components/e6283b3cf43c94d64ed43d7b6c0dbea2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Curse achizitionate fara termen de valabilitate: ',(___arguments.context.pageData['curseIncluseFaraTermen']),'\nCurse fara termen de valabilitate ramase: ',(___arguments.context.pageData['comenziFaraTermenRamase'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/MainPage/components/ad4409d2622968a223fa9a755d7ba533/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Curse achizitionate in abonament lunar: ',(___arguments.context.pageData['curseAbonamentLunar']),'\nCurse abonament ramase: ',(___arguments.context.pageData['curseAbonamentRamase'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/MainPage/components/995fd13c348fc4084eaf0bec7277c4dd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return (['Total valoare tarifare: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['valoareTarifare']))),'\nTotal medie tarifare: ',(await BackendlessUI.Functions.Custom['roundCuDouaZecimale']((___arguments.context.pageData['medieTarifare']))),'\nTotal Km Comenzi: ',(await BackendlessUI.Functions.Custom['roundCuDouaZecimale']((___arguments.context.pageData['valoareKm']))),'\nMedie Km/Comanda: ',(await BackendlessUI.Functions.Custom['roundCuDouaZecimale']((___arguments.context.pageData['medieKm'])))].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/MainPage/components/ca221a08b3cf39a10b84206cdffdcc02/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return (['Valoare tarifare Luna Curenta: ',(await BackendlessUI.Functions.Custom['fn_4151feb5a437708e1781f57b8909bced']((___arguments.context.pageData['valoareTarifareLC']))),'\nMedie tarifare Luna Curenta: ',(await BackendlessUI.Functions.Custom['roundCuDouaZecimale']((___arguments.context.pageData['medieTarifareLC']))),'\nTotal km comenzi Luna Curenta: ',(await BackendlessUI.Functions.Custom['roundCuDouaZecimale']((___arguments.context.pageData['valoareKmLC']))),'\nMedie km/comanda Luna Curenta: ',(await BackendlessUI.Functions.Custom['roundCuDouaZecimale']((___arguments.context.pageData['medieKmLC']))),''].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/MainPage/components/319acb1965a8801a4a25ad2f042d53b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var timpEfectivLivrare;

/**
 * Describe this function...
 */
async function TELC() {
  timpEfectivLivrare = (___arguments.context.pageData['medieTimpEfectivAll']);
  ___arguments.context.pageData['oraTE'] = ((new Date(timpEfectivLivrare).getHours()) - 2);
  ___arguments.context.pageData['minTE'] = (new Date(timpEfectivLivrare).getMinutes());
  ___arguments.context.pageData['secTE'] = (new Date(timpEfectivLivrare).getSeconds());
}


  await TELC();

  return (!((___arguments.context.pageData['medieTimpEfectivAll']) == 0) ? ['Medie timp efectiv livrare: ','',(___arguments.context.pageData['oraTE']) < 10 ? String('0') + String(___arguments.context.pageData['oraTE']) : (___arguments.context.pageData['oraTE']),':',(___arguments.context.pageData['minTE']) < 10 ? String('0') + String(___arguments.context.pageData['minTE']) : (___arguments.context.pageData['minTE']),':',(___arguments.context.pageData['secTE']) < 10 ? String('0') + String(___arguments.context.pageData['secTE']) : (___arguments.context.pageData['secTE']),'','',''].join('') : 'Nu exista comenzi procesate')

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/MainPage/components/4796b969c45dae4987d7e62ca03450f6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var timpLivrare;

/**
 * Describe this function...
 */
async function TLLC() {
  timpLivrare = (___arguments.context.pageData['medieTL']);
  ___arguments.context.pageData['oraTL'] = ((new Date(timpLivrare).getHours()) - 2);
  ___arguments.context.pageData['minTL'] = (new Date(timpLivrare).getMinutes());
  ___arguments.context.pageData['secTL'] = (new Date(timpLivrare).getSeconds());
}


  await TLLC();

  return (!((___arguments.context.pageData['medieTL']) == 0) ? ['Medie timp livrare: ','',(___arguments.context.pageData['oraTL']) < 10 ? String('0') + String(___arguments.context.pageData['oraTL']) : (___arguments.context.pageData['oraTL']),':',(___arguments.context.pageData['minTL']) < 10 ? String('0') + String(___arguments.context.pageData['minTL']) : (___arguments.context.pageData['minTL']),':',(___arguments.context.pageData['secTL']) < 10 ? String('0') + String(___arguments.context.pageData['secTL']) : (___arguments.context.pageData['secTL']),'','',''].join('') : 'Nu exista comenzi procesate')

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/MainPage/components/c018eb029b96f1cde92e0c4e657894ac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var timpEfectivLivrare;

/**
 * Describe this function...
 */
async function TELC() {
  timpEfectivLivrare = (___arguments.context.pageData['medieTimpEfectivLC']);
  ___arguments.context.pageData['oraTELC'] = ((new Date(timpEfectivLivrare).getHours()) - 2);
  ___arguments.context.pageData['minTELC'] = (new Date(timpEfectivLivrare).getMinutes());
  ___arguments.context.pageData['secTELC'] = (new Date(timpEfectivLivrare).getSeconds());
}


  await TELC();

  return (!((___arguments.context.pageData['medieTimpEfectivLC']) == 0) ? ['Medie timp efectiv livrare: ','',(___arguments.context.pageData['oraTELC']) < 10 ? String('0') + String(___arguments.context.pageData['oraTELC']) : (___arguments.context.pageData['oraTELC']),':',(___arguments.context.pageData['minTELC']) < 10 ? String('0') + String(___arguments.context.pageData['minTELC']) : (___arguments.context.pageData['minTELC']),':',(___arguments.context.pageData['secTELC']) < 10 ? String('0') + String(___arguments.context.pageData['secTELC']) : (___arguments.context.pageData['secTELC']),'','',''].join('') : 'Nu sunt comenzi in luna curenta')

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/MainPage/components/d26c193b5b841f8bb6042f0203a7e129/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var timpLivrare;

/**
 * Describe this function...
 */
async function TLLC() {
  timpLivrare = (___arguments.context.pageData['medieTLLC']);
  ___arguments.context.pageData['oraTLLC'] = ((new Date(timpLivrare).getHours()) - 2);
  ___arguments.context.pageData['minTLLC'] = (new Date(timpLivrare).getMinutes());
  ___arguments.context.pageData['secTLLC'] = (new Date(timpLivrare).getSeconds());
}


  await TLLC();

  return (!((___arguments.context.pageData['medieTLLC']) == 0) ? ['Medie timp livrare: ','',(___arguments.context.pageData['oraTLLC']) < 10 ? String('0') + String(___arguments.context.pageData['oraTLLC']) : (___arguments.context.pageData['oraTLLC']),':',(___arguments.context.pageData['minTLLC']) < 10 ? String('0') + String(___arguments.context.pageData['minTLLC']) : (___arguments.context.pageData['minTLLC']),':',(___arguments.context.pageData['secTLLC']) < 10 ? String('0') + String(___arguments.context.pageData['secTLLC']) : (___arguments.context.pageData['secTLLC']),'','',''].join('') : 'Nu sunt comenzi in luna curenta')

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/MainPage/components/46eec22eceb3c9549d66d8e52c1d1bc8/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
      ___arguments.context.dataModel['paginaCurenta'] = 'Rapoarte';
  await Backendless.Data.of('DispecerActiv').save( ___arguments.context.dataModel );

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/MainPage/components/6fe951929012f184edfed756aa74fcfb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Comenzi', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TextSMS/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async onEnter(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (!(await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  }
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fc28e67f3cdb97a2a52ea89ec34ee52c', (await Backendless.Data.of('DispecerActiv').find(Backendless.DataQueryBuilder.create().setWhereClause((['userEmail = \'',(currentUser['userEmail']),'\'','','',''].join(''))).setPageSize(1))));
  ___arguments.context.pageData['selectBrand'] = (((await Backendless.Data.of('BrandClient').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterClient = \'',(currentUser['masterName']),'\' AND default = TRUE'].join(''))).setProperties('brand').setPageSize(1)))[0])['brand']);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('MesajSMS').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterClient = \'',(currentUser['masterName']),'\' AND brand = \'',(___arguments.context.pageData['selectBrand']),'\'',''].join(''))).setPageSize(1))));

  },  
  /* handler:onEnter */
/* content */
}));

define('./pages/TextSMS/components/d0292826e5d48b277e8221d63f75b556/bundle.js', [], () => ({
  /* content */

  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currentUserName, currentUser;


  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (currentUser) {
    currentUserName = (currentUser['username']);
  }

  return currentUserName

  },  
/* handler:onContentAssignment *//* content */
}));

define('./pages/TextSMS/components/73712c1793d263f9c8dcdfd451233039/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ___arguments.context.appData['currentUser'] = null;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick *//* content */
}));

define('./pages/TextSMS/components/1dd5b90597236fee51baecd1525d217e/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.Data.of('MesajSMS').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Comenzi', null);

  },  
  /* handler:onClick *//* content */
}));

define('./pages/TextSMS/components/11ff92dd151418d4164a38ac3bbeabf3/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
/* handler:onClick *//* content */
}));

define('./pages/TextSMS/components/6aafe686166823c60bf2d34f44278533/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['','Comanda la: [adresa livrare] \n',' de la: ',(___arguments.context.pageData['selectBrand']),' este in livrare. Aveti de plata [suma de incasat]Lei\nTelefon livrator: ',' [telefon livrator]\n',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['modalitatePlata']),[' \nAccesand link-ul de mai jos puteti urmari pozitia livratorului pe harta. ',' \n[link share location google maps]',' \nPentru operativitate, va rugam sa dati un share location catre livrator cand deschideti link-ul. ','\nMultumim(CallDeliveryApp 0752621501)'].join(''),'','','','','','','',''].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/TextSMS/components/7ccef6ae9b9691069f1df3fe4ff7516d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Comanda de la: ',(___arguments.context.pageData['selectBrand']),' a fost livrata. ',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['text0Livrata']),' \n ',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['textLivrata1']),'\n ',(___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['textLivrata2']),'\n (DeliveryApp 0752621501)','','','','',''].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/TextSMS/components/23162381483fa081759540a8480a97eb/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
      ___arguments.context.dataModel['paginaCurenta'] = 'editeaza SMS';
  await Backendless.Data.of('DispecerActiv').save( ___arguments.context.dataModel );

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/TextSMS/components/89d9ec6c328c1cb88157c40485e8db03/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('MesajSMS').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/TextSMS/components/7ef59119d84a8a81fe1d718e13ba8806/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('MesajSMS').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onChange */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['sendSmsILIV']) ? 'Se trimite mesajul "IN LIVRARE"' : 'NU se trimite mesajul "IN LIVRARE"')

  },  
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/TextSMS/components/4991fb03d71126229f13f6ecbf78dd77/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('MesajSMS').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onChange */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7')['sendSmsLIV']) ? 'Se trimite mesajul "COMANDA LIVRATA"' : 'NU se trimite mesajul "COMANDA LIVRATA"')

  },  
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/TextSMS/components/25c9107f6807662a976ac14384492f3a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('MesajSMS').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/TextSMS/components/62b9de0e20d34285752ee5a16cbfff2f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('MesajSMS').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/TextSMS/components/08fdcde2bd8abfa28cf39ba975ed11b4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('MesajSMS').save( ___arguments.context.getComponentDataStoreByUid('ead7d02f881c23c7e1c88f68920187b7') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/TextSMS/components/63a8e4942f1f8e97b432bd9b84a4aab8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item, currentUser;

/**
 * Describe this function...
 */
async function user() {
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
}


  await user();

  return ((await Backendless.Data.of('BrandClient').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterClient = \'',(currentUser['masterName']),'\'',''].join(''))).setSortBy('brand asc').setPageSize(10))).map(item => {; return ({ 'label': (item['brand']),'value': (item['brand']) });}))

  },  
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
    var currentUser;

/**
 * Describe this function...
 */
async function user() {
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
}


  await user();
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d7a6cdd28a2714d79c63f3fb84a1b46', (await Backendless.Data.of('MesajSMS').find(Backendless.DataQueryBuilder.create().setWhereClause((['masterClient = \'',(currentUser['masterName']),'\' AND brand = \'',___arguments.value,'\'',''].join(''))).setPageSize(1))));

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/TextSMS/components/73564d5ed827f03abbffa9fe095c3cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  ___arguments.context.dataModel['currentUser'] = currentUser;
  ___arguments.context.dataModel['newBrand'] = '';

  },  
  /* handler:onBeforeMount */
  /* handler:onReset */
  onReset(___arguments) {
      ___arguments.context.dataModel['newBrand'] = '';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e739934750587db3e7c8809adb7e9928', false);

  },  
  /* handler:onReset */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var newSMSBrand, newBrand;

/**
 * Describe this function...
 */
async function newBrand2() {
  newBrand = (await Backendless.Data.of('BrandClient').save( ({ 'brand': (___arguments.context.dataModel['newBrand']),'default': false,'masterClient': ((___arguments.context.dataModel['currentUser'])['masterName']) }) ));
  newSMSBrand = (await Backendless.Data.of('MesajSMS').save( ({ 'brand': (___arguments.context.dataModel['newBrand']),'masterClient': ((___arguments.context.dataModel['currentUser'])['masterName']) }) ));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e739934750587db3e7c8809adb7e9928', false);
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('TextSMS', null);
}


  await newBrand2();

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/TextSMS/components/2d2beb6d83a5d8c866ef8c26e9c90a24/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e739934750587db3e7c8809adb7e9928', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async onEnter(___arguments) {
    var currentUser;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  currentUser = ___arguments.context.appData;
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })(((await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData)) ? 'MainPage' : 'login'), null);

  },  
/* handler:onEnter *//* content */
}));

define('./pages/login/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async onEnter(___arguments) {
    var user;


  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData)
  if (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData)) {
    if ((user['rol']) == 'MASTERADMIN') {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/ui-builder/containers/SystemAdmin/index.html', false, null);
    } else if ((user['rol']) == 'LIVRATOR') {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/ui-builder/containers/Livrator/index.html', false, null);
    } else if ((user['rol']) == 'DISPECER') {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/ui-builder/containers/Dispecer/index.html', false, null);
    }
  }

  },  
/* handler:onEnter *//* content */
}));

define('./pages/login/components/e13c78778b412de8d2c2d4ad9f421133/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var user, error, password, username, stayLoggedIn, logging, loginButton, currentUser;

/**
 * Describe this function...
 */
async function newLogin() {
  console.log('newLogin');
  await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://cd.testenv.ro/api/auth/login')).setEncoding('utf8').send(({ 'username': 'horea@testenv.ro','password': '123456' }));
  ___arguments.context.appData['header'] = '';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('e13c78778b412de8d2c2d4ad9f421133'))['error'] = error;
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.UserService.login( username, password, stayLoggedIn  ));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function updateLoginButton(logging) {
  loginButton = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('359e942fb9f2d5df44939e52ea244ac3'));
  loginButton['label'] = (logging ? 'Please wait...' : 'Log In');
  loginButton['disabled'] = logging;
}

/**
 * Describe this function...
 */
async function user2() {
  if ((getObjectProperty(___arguments.context.appData, 'user')) == null) {
    console.log('no user load');
    await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
    ___arguments.context.appData['user'] = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  }
  currentUser = (getObjectProperty(___arguments.context.appData, 'user'));
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'user')), 'username'));
}


  await setError(null);
  username = (getObjectProperty(___arguments.context.dataModel, 'username')).trim();
  password = (getObjectProperty(___arguments.context.dataModel, 'password'));
  stayLoggedIn = (getObjectProperty(___arguments.context.dataModel, 'stayLoggedIn'));
  if (username && password) {
    await updateLoginButton(true);
    try {
      await login();

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      await updateLoginButton(false);

    }
  } else {
    await setError((new Error('Username and Password must be filled')));
  }
  if (user) {
    ___arguments.context.appData['currentUser'] = user;
    if ((getObjectProperty(user, 'rol')) == 'MASTERADMIN') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/admin/index.html', false, undefined);
    } else if ((getObjectProperty(user, 'rol')) == 'LIVRATOR') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/livrator/index.html', false, undefined);
    } else if ((getObjectProperty(user, 'rol')) == 'DISPECER') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/dispecer/index.html', false, undefined);
    } else if ((getObjectProperty(user, 'rol')) == 'LIVRATORADMIN') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/livrator/index.html', false, undefined);
    }
  }
  await user2();

  },
  /* handler:onSubmit */
/* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function onMounted() {
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if ((await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))) {
    if ((getObjectProperty(currentUser, 'rol')) == 'MASTERADMIN') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/admin/index.html', false, undefined);
    } else if ((getObjectProperty(currentUser, 'rol')) == 'LIVRATOR') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/livrator/index.html', false, undefined);
    } else if ((getObjectProperty(currentUser, 'rol')) == 'DISPECER') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/dispecer/index.html', false, undefined);
    } else if ((getObjectProperty(currentUser, 'rol')) == 'LIVRATORADMIN') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/livrator/index.html', false, undefined);
    }
  }
}


  await onMounted();
  ___arguments.context.dataModel['username'] = '';
  ___arguments.context.dataModel['password'] = '';
  ___arguments.context.dataModel['stayLoggedIn'] = true;

  },
  /* handler:onBeforeMount *//* handler:onMounted */
  async ['onMounted'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function onMounted() {
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if ((await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData))) {
    if ((getObjectProperty(currentUser, 'rol')) == 'MASTERADMIN') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/admin/index.html', false, undefined);
    } else if ((getObjectProperty(currentUser, 'rol')) == 'LIVRATOR') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/livrator/index.html', false, undefined);
    } else if ((getObjectProperty(currentUser, 'rol')) == 'DISPECER') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/dispecer/index.html', false, undefined);
    }
  }
}


  await onMounted();

  },
  /* handler:onMounted */
  /* content */
}));

define('./pages/login/components/2ea3251d2051dccceddee13fe1e70423/bundle.js', [], () => ({
  /* content */

  
/* handler:onMounted */
  async onMounted(___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function onMounted() {
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e13c78778b412de8d2c2d4ad9f421133', false);
  await BackendlessUI.Functions.Custom['fn_71c90b7681f2c8b9eb72624de9567aa7'](___arguments.context.appData);
  currentUser = (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData));
  if (await BackendlessUI.Functions.Custom['fn_c4e97af1f13356084877663da10b7363'](___arguments.context.appData)) {
    if ((getObjectProperty(currentUser, 'rol')) == 'MASTERADMIN') {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/admin/index.html', false, null);
    } else if ((getObjectProperty(currentUser, 'rol')) == 'LIVRATOR') {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/livrator/index.html', false, null);
    } else if ((getObjectProperty(currentUser, 'rol')) == 'DISPECER') {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendlessappcontent.com/D3E675A8-5EAB-4152-A0B7-206D1942B8A6/3E3779EA-C9D1-4AEF-8C11-B644A63FB44C/files/web/dispecer/index.html', false, null);
    }
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e13c78778b412de8d2c2d4ad9f421133', true);
  }
}


  await onMounted();

  },
  /* handler:onMounted */
  /* content */
}));

